//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export * as Client from './axios-client/Client';

export * as Query from './axios-client/Query';



//-----Types.File-----
export enum BankAccountTypeEnum {
    Checking = "checking",
    Savings = "savings",
    BusinessChecking = "businessChecking",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBoatsByLocationQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IPaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBoatsByLocationQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IPaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBoatsByLocationQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBoatsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IPaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBoatsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IPaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBoatsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetPublishedBoatsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IPaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPublishedBoatsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IPaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetPublishedBoatsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBookingsByCreationDateRangeQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IPaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBookingsByCreationDateRangeQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IPaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBookingsByCreationDateRangeQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetAvailableListingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IPaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAvailableListingsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IPaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetAvailableListingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class PaginatedResult_1OfOfGetPublicMarketsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPaginatedResult_1OfOfGetPublicMarketsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetPublicMarketsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IPaginatedResult_1OfOfGetPublicMarketsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPublicMarketsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PaginatedResult_1OfOfGetPublicMarketsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult_1OfOfGetPublicMarketsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IPaginatedResult_1OfOfGetPublicMarketsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetPublicMarketsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class AdditionalFeeTypeItem implements IAdditionalFeeTypeItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
    isActive?: boolean;
    displayOrder?: number;
    defaultTaxes?: TaxLine[] | null;
    autoApplyToWidgetBookings?: boolean;
    defaultPercentage?: number | null;

    constructor(data?: IAdditionalFeeTypeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
            this.autoApplyToWidgetBookings = _data["autoApplyToWidgetBookings"];
            this.defaultPercentage = _data["defaultPercentage"];
        }
    }

    static fromJS(data: any): AdditionalFeeTypeItem {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalFeeTypeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        data["autoApplyToWidgetBookings"] = this.autoApplyToWidgetBookings;
        data["defaultPercentage"] = this.defaultPercentage;
        return data;
    }
}

export interface IAdditionalFeeTypeItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
    isActive?: boolean;
    displayOrder?: number;
    defaultTaxes?: TaxLine[] | null;
    autoApplyToWidgetBookings?: boolean;
    defaultPercentage?: number | null;
}

export class GetAllAdditionalFeeTypesQueryResult implements IGetAllAdditionalFeeTypesQueryResult {
    feeTypes!: AdditionalFeeTypeItem[] | null;

    constructor(data?: IGetAllAdditionalFeeTypesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["feeTypes"])) {
                this.feeTypes = [] as any;
                for (let item of _data["feeTypes"])
                    this.feeTypes!.push(AdditionalFeeTypeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAdditionalFeeTypesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAdditionalFeeTypesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.feeTypes)) {
            data["feeTypes"] = [];
            for (let item of this.feeTypes)
                data["feeTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllAdditionalFeeTypesQueryResult {
    feeTypes: AdditionalFeeTypeItem[] | null;
}

export class AddonOptionDto implements IAddonOptionDto {
    guid!: string;
    name!: string | null;
    description?: string | null;
    basePrice!: number;
    isDefault!: boolean;
    sortOrder!: number;

    constructor(data?: IAddonOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.basePrice = _data["basePrice"];
            this.isDefault = _data["isDefault"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): AddonOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddonOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["basePrice"] = this.basePrice;
        data["isDefault"] = this.isDefault;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IAddonOptionDto {
    guid: string;
    name: string | null;
    description?: string | null;
    basePrice: number;
    isDefault: boolean;
    sortOrder: number;
}

export class AvailableAddonCategoryDto implements IAvailableAddonCategoryDto {
    guid!: string;
    name!: string | null;
    icon?: string | null;

    constructor(data?: IAvailableAddonCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): AvailableAddonCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableAddonCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["icon"] = this.icon;
        return data;
    }
}

export interface IAvailableAddonCategoryDto {
    guid: string;
    name: string | null;
    icon?: string | null;
}

export class GetAvailableAddonCategoriesQueryResult implements IGetAvailableAddonCategoriesQueryResult {
    categories!: AvailableAddonCategoryDto[] | null;

    constructor(data?: IGetAvailableAddonCategoriesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(AvailableAddonCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableAddonCategoriesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableAddonCategoriesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableAddonCategoriesQueryResult {
    categories: AvailableAddonCategoryDto[] | null;
}

export class BoatPictureResultResult implements IBoatPictureResultResult {
    readonly pictureGuid?: string | null;
    readonly host?: string | null;
    bucket?: string | null;
    readonly name?: string | null;
    readonly extension?: string | null;
    readonly height?: number | null;
    readonly width?: number | null;
    readonly size?: number | null;
    sortOrder?: number;
    description?: string | null;

    constructor(data?: IBoatPictureResultResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).pictureGuid = _data["pictureGuid"];
            (<any>this).host = _data["host"];
            this.bucket = _data["bucket"];
            (<any>this).name = _data["name"];
            (<any>this).extension = _data["extension"];
            (<any>this).height = _data["height"];
            (<any>this).width = _data["width"];
            (<any>this).size = _data["size"];
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BoatPictureResultResult {
        data = typeof data === 'object' ? data : {};
        let result = new BoatPictureResultResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureGuid"] = this.pictureGuid;
        data["host"] = this.host;
        data["bucket"] = this.bucket;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["height"] = this.height;
        data["width"] = this.width;
        data["size"] = this.size;
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        return data;
    }
}

export interface IBoatPictureResultResult {
    pictureGuid?: string | null;
    host?: string | null;
    bucket?: string | null;
    name?: string | null;
    extension?: string | null;
    height?: number | null;
    width?: number | null;
    size?: number | null;
    sortOrder?: number;
    description?: string | null;
}

export enum BoatSortOptions {
    Length = "Length",
    DefaultListingTitle = "DefaultListingTitle",
    Status = "Status",
    Owner = "Owner",
    Market = "Market",
    SortPriority = "SortPriority",
    TotalTrips = "TotalTrips",
    TotalRevenue = "TotalRevenue",
    BoatIdentifier = "BoatIdentifier",
}

export class GetBoatGalleryQueryResult implements IGetBoatGalleryQueryResult {
    pictures?: PictureResultModel[] | null;

    constructor(data?: IGetBoatGalleryQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pictures"])) {
                this.pictures = [] as any;
                for (let item of _data["pictures"])
                    this.pictures!.push(PictureResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBoatGalleryQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatGalleryQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pictures)) {
            data["pictures"] = [];
            for (let item of this.pictures)
                data["pictures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBoatGalleryQueryResult {
    pictures?: PictureResultModel[] | null;
}

export class GetBoatQueryResult implements IGetBoatQueryResult {
    guid?: string;
    defaultListingTitle?: string | null;
    registeredName?: string | null;
    makeAndModel?: string | null;
    description?: string | null;
    sortPriority?: number | null;
    ownerType?: BoatOwnerType;
    isComplete?: boolean;
    availabilityMode?: BoatAvailabilityMode;
    owner?: UserResult;
    specification?: BoatSpecification;
    pictures?: BoatPictureResultResult[] | null;
    listings?: GetBoatQueryResultListing[] | null;
    isDeleted?: boolean;
    hasSpecificationFile?: boolean;
    specificationFileOriginalName?: string | null;
    specificationFileSizeBytes?: number | null;

    constructor(data?: IGetBoatQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.registeredName = _data["registeredName"];
            this.makeAndModel = _data["makeAndModel"];
            this.description = _data["description"];
            this.sortPriority = _data["sortPriority"];
            this.ownerType = _data["ownerType"];
            this.isComplete = _data["isComplete"];
            this.availabilityMode = _data["availabilityMode"];
            this.owner = _data["owner"] ? UserResult.fromJS(_data["owner"]) : <any>null;
            this.specification = _data["specification"] ? BoatSpecification.fromJS(_data["specification"]) : <any>null;
            if (Array.isArray(_data["pictures"])) {
                this.pictures = [] as any;
                for (let item of _data["pictures"])
                    this.pictures!.push(BoatPictureResultResult.fromJS(item));
            }
            if (Array.isArray(_data["listings"])) {
                this.listings = [] as any;
                for (let item of _data["listings"])
                    this.listings!.push(GetBoatQueryResultListing.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.hasSpecificationFile = _data["hasSpecificationFile"];
            this.specificationFileOriginalName = _data["specificationFileOriginalName"];
            this.specificationFileSizeBytes = _data["specificationFileSizeBytes"];
        }
    }

    static fromJS(data: any): GetBoatQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["registeredName"] = this.registeredName;
        data["makeAndModel"] = this.makeAndModel;
        data["description"] = this.description;
        data["sortPriority"] = this.sortPriority;
        data["ownerType"] = this.ownerType;
        data["isComplete"] = this.isComplete;
        data["availabilityMode"] = this.availabilityMode;
        data["owner"] = this.owner ? this.owner.toJSON() : this.owner;
        data["specification"] = this.specification ? this.specification.toJSON() : this.specification;
        if (Array.isArray(this.pictures)) {
            data["pictures"] = [];
            for (let item of this.pictures)
                data["pictures"].push(item.toJSON());
        }
        if (Array.isArray(this.listings)) {
            data["listings"] = [];
            for (let item of this.listings)
                data["listings"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["hasSpecificationFile"] = this.hasSpecificationFile;
        data["specificationFileOriginalName"] = this.specificationFileOriginalName;
        data["specificationFileSizeBytes"] = this.specificationFileSizeBytes;
        return data;
    }
}

export interface IGetBoatQueryResult {
    guid?: string;
    defaultListingTitle?: string | null;
    registeredName?: string | null;
    makeAndModel?: string | null;
    description?: string | null;
    sortPriority?: number | null;
    ownerType?: BoatOwnerType;
    isComplete?: boolean;
    availabilityMode?: BoatAvailabilityMode;
    owner?: UserResult;
    specification?: BoatSpecification;
    pictures?: BoatPictureResultResult[] | null;
    listings?: GetBoatQueryResultListing[] | null;
    isDeleted?: boolean;
    hasSpecificationFile?: boolean;
    specificationFileOriginalName?: string | null;
    specificationFileSizeBytes?: number | null;
}

export class GetBoatQueryResultListing implements IGetBoatQueryResultListing {
    guid!: string;
    marketGuid!: string;
    marketCode!: string | null;
    marketTitle!: string | null;
    locationTitle!: string | null;
    marketSpecificTitle!: string | null;
    publishStatus!: PublishStatus;
    defaultSkipper!: UserResult;
    pricingMode!: PricingMode;

    constructor(data?: IGetBoatQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.defaultSkipper = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.marketGuid = _data["marketGuid"];
            this.marketCode = _data["marketCode"];
            this.marketTitle = _data["marketTitle"];
            this.locationTitle = _data["locationTitle"];
            this.marketSpecificTitle = _data["marketSpecificTitle"];
            this.publishStatus = _data["publishStatus"];
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : new UserResult();
            this.pricingMode = _data["pricingMode"];
        }
    }

    static fromJS(data: any): GetBoatQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["marketGuid"] = this.marketGuid;
        data["marketCode"] = this.marketCode;
        data["marketTitle"] = this.marketTitle;
        data["locationTitle"] = this.locationTitle;
        data["marketSpecificTitle"] = this.marketSpecificTitle;
        data["publishStatus"] = this.publishStatus;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["pricingMode"] = this.pricingMode;
        return data;
    }
}

export interface IGetBoatQueryResultListing {
    guid: string;
    marketGuid: string;
    marketCode: string | null;
    marketTitle: string | null;
    locationTitle: string | null;
    marketSpecificTitle: string | null;
    publishStatus: PublishStatus;
    defaultSkipper: UserResult;
    pricingMode: PricingMode;
}

export class GetBoatsByLocationQueryResult implements IGetBoatsByLocationQueryResult {
    guid!: string;
    registeredName!: string | null;
    makeAndModel!: string | null;
    listings!: GetBoatsByLocationQueryResultListing[] | null;

    constructor(data?: IGetBoatsByLocationQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.registeredName = _data["registeredName"];
            this.makeAndModel = _data["makeAndModel"];
            if (Array.isArray(_data["listings"])) {
                this.listings = [] as any;
                for (let item of _data["listings"])
                    this.listings!.push(GetBoatsByLocationQueryResultListing.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBoatsByLocationQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsByLocationQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["registeredName"] = this.registeredName;
        data["makeAndModel"] = this.makeAndModel;
        if (Array.isArray(this.listings)) {
            data["listings"] = [];
            for (let item of this.listings)
                data["listings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBoatsByLocationQueryResult {
    guid: string;
    registeredName: string | null;
    makeAndModel: string | null;
    listings: GetBoatsByLocationQueryResultListing[] | null;
}

export class GetBoatsByLocationQueryResultListing implements IGetBoatsByLocationQueryResultListing {
    title!: string | null;
    publishStatus!: PublishStatus;
    boatIdentifier!: string | null;
    location!: LocationResult;
    market!: MarketResult;
    defaultSkipper!: UserResult;
    defaultStewardess!: UserResult;

    constructor(data?: IGetBoatsByLocationQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new LocationResult();
            this.market = new MarketResult();
            this.defaultSkipper = new UserResult();
            this.defaultStewardess = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : new LocationResult();
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : new MarketResult();
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : new UserResult();
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : new UserResult();
        }
    }

    static fromJS(data: any): GetBoatsByLocationQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsByLocationQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["boatIdentifier"] = this.boatIdentifier;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        return data;
    }
}

export interface IGetBoatsByLocationQueryResultListing {
    title: string | null;
    publishStatus: PublishStatus;
    boatIdentifier: string | null;
    location: LocationResult;
    market: MarketResult;
    defaultSkipper: UserResult;
    defaultStewardess: UserResult;
}

export class GetBoatsQueryResult implements IGetBoatsQueryResult {
    guid?: string;
    length?: number | null;
    defaultListingTitle?: string | null;
    sortPriority?: number | null;
    isComplete?: boolean;
    totalTrips?: number | null;
    totalRevenue?: number | null;
    areAllOwnerTakeRatesSet?: boolean;
    owner?: UserResult;
    markets?: MarketResult[] | null;
    boatPicture?: GetBoatsQueryResult_BoatPictureResultModel;

    constructor(data?: IGetBoatsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.length = _data["length"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.sortPriority = _data["sortPriority"];
            this.isComplete = _data["isComplete"];
            this.totalTrips = _data["totalTrips"];
            this.totalRevenue = _data["totalRevenue"];
            this.areAllOwnerTakeRatesSet = _data["areAllOwnerTakeRatesSet"];
            this.owner = _data["owner"] ? UserResult.fromJS(_data["owner"]) : <any>null;
            if (Array.isArray(_data["markets"])) {
                this.markets = [] as any;
                for (let item of _data["markets"])
                    this.markets!.push(MarketResult.fromJS(item));
            }
            this.boatPicture = _data["boatPicture"] ? GetBoatsQueryResult_BoatPictureResultModel.fromJS(_data["boatPicture"]) : <any>null;
        }
    }

    static fromJS(data: any): GetBoatsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["length"] = this.length;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["sortPriority"] = this.sortPriority;
        data["isComplete"] = this.isComplete;
        data["totalTrips"] = this.totalTrips;
        data["totalRevenue"] = this.totalRevenue;
        data["areAllOwnerTakeRatesSet"] = this.areAllOwnerTakeRatesSet;
        data["owner"] = this.owner ? this.owner.toJSON() : this.owner;
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item.toJSON());
        }
        data["boatPicture"] = this.boatPicture ? this.boatPicture.toJSON() : this.boatPicture;
        return data;
    }
}

export interface IGetBoatsQueryResult {
    guid?: string;
    length?: number | null;
    defaultListingTitle?: string | null;
    sortPriority?: number | null;
    isComplete?: boolean;
    totalTrips?: number | null;
    totalRevenue?: number | null;
    areAllOwnerTakeRatesSet?: boolean;
    owner?: UserResult;
    markets?: MarketResult[] | null;
    boatPicture?: GetBoatsQueryResult_BoatPictureResultModel;
}

export class GetBoatsQueryResult_BoatPictureResultModel implements IGetBoatsQueryResult_BoatPictureResultModel {
    readonly pictureGuid?: string | null;
    readonly host?: string | null;
    bucket?: string | null;
    readonly name?: string | null;
    readonly extension?: string | null;
    readonly height?: number | null;
    readonly width?: number | null;
    readonly size?: number | null;
    sortOrder?: number;
    description?: string | null;

    constructor(data?: IGetBoatsQueryResult_BoatPictureResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).pictureGuid = _data["pictureGuid"];
            (<any>this).host = _data["host"];
            this.bucket = _data["bucket"];
            (<any>this).name = _data["name"];
            (<any>this).extension = _data["extension"];
            (<any>this).height = _data["height"];
            (<any>this).width = _data["width"];
            (<any>this).size = _data["size"];
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetBoatsQueryResult_BoatPictureResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsQueryResult_BoatPictureResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureGuid"] = this.pictureGuid;
        data["host"] = this.host;
        data["bucket"] = this.bucket;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["height"] = this.height;
        data["width"] = this.width;
        data["size"] = this.size;
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetBoatsQueryResult_BoatPictureResultModel {
    pictureGuid?: string | null;
    host?: string | null;
    bucket?: string | null;
    name?: string | null;
    extension?: string | null;
    height?: number | null;
    width?: number | null;
    size?: number | null;
    sortOrder?: number;
    description?: string | null;
}

export class GetPublishedBoatsQueryResult implements IGetPublishedBoatsQueryResult {
    guid?: string;
    registeredName?: string | null;
    defaultListingTitle?: string | null;
    makeAndModel?: string | null;
    length?: number | null;
    passengersCapacity?: number;

    constructor(data?: IGetPublishedBoatsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.registeredName = _data["registeredName"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.makeAndModel = _data["makeAndModel"];
            this.length = _data["length"];
            this.passengersCapacity = _data["passengersCapacity"];
        }
    }

    static fromJS(data: any): GetPublishedBoatsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublishedBoatsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["registeredName"] = this.registeredName;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["makeAndModel"] = this.makeAndModel;
        data["length"] = this.length;
        data["passengersCapacity"] = this.passengersCapacity;
        return data;
    }
}

export interface IGetPublishedBoatsQueryResult {
    guid?: string;
    registeredName?: string | null;
    defaultListingTitle?: string | null;
    makeAndModel?: string | null;
    length?: number | null;
    passengersCapacity?: number;
}

export class GetVisibleBoatsInCalendarQueryResult implements IGetVisibleBoatsInCalendarQueryResult {
    visibleBoatsGuidsInCalendar?: string[] | null;

    constructor(data?: IGetVisibleBoatsInCalendarQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["visibleBoatsGuidsInCalendar"])) {
                this.visibleBoatsGuidsInCalendar = [] as any;
                for (let item of _data["visibleBoatsGuidsInCalendar"])
                    this.visibleBoatsGuidsInCalendar!.push(item);
            }
        }
    }

    static fromJS(data: any): GetVisibleBoatsInCalendarQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetVisibleBoatsInCalendarQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.visibleBoatsGuidsInCalendar)) {
            data["visibleBoatsGuidsInCalendar"] = [];
            for (let item of this.visibleBoatsGuidsInCalendar)
                data["visibleBoatsGuidsInCalendar"].push(item);
        }
        return data;
    }
}

export interface IGetVisibleBoatsInCalendarQueryResult {
    visibleBoatsGuidsInCalendar?: string[] | null;
}

export class AddBookingAddonItem implements IAddBookingAddonItem {
    addonGuid?: string;
    quantity?: number;
    days?: number | null;
    selectedOptionGuid?: string | null;
    expectedTotalGross?: number;
    note?: string | null;

    constructor(data?: IAddBookingAddonItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addonGuid = _data["addonGuid"];
            this.quantity = _data["quantity"];
            this.days = _data["days"];
            this.selectedOptionGuid = _data["selectedOptionGuid"];
            this.expectedTotalGross = _data["expectedTotalGross"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AddBookingAddonItem {
        data = typeof data === 'object' ? data : {};
        let result = new AddBookingAddonItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addonGuid"] = this.addonGuid;
        data["quantity"] = this.quantity;
        data["days"] = this.days;
        data["selectedOptionGuid"] = this.selectedOptionGuid;
        data["expectedTotalGross"] = this.expectedTotalGross;
        data["note"] = this.note;
        return data;
    }
}

export interface IAddBookingAddonItem {
    addonGuid?: string;
    quantity?: number;
    days?: number | null;
    selectedOptionGuid?: string | null;
    expectedTotalGross?: number;
    note?: string | null;
}

export class AddBookingAddonsCommand implements IAddBookingAddonsCommand {
    addons?: AddBookingAddonItem[] | null;

    constructor(data?: IAddBookingAddonsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addons"])) {
                this.addons = [] as any;
                for (let item of _data["addons"])
                    this.addons!.push(AddBookingAddonItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddBookingAddonsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddBookingAddonsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addons)) {
            data["addons"] = [];
            for (let item of this.addons)
                data["addons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddBookingAddonsCommand {
    addons?: AddBookingAddonItem[] | null;
}

export class AddBookingAddonsCommandResult implements IAddBookingAddonsCommandResult {
    bookingAddonGuids!: string[] | null;

    constructor(data?: IAddBookingAddonsCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bookingAddonGuids"])) {
                this.bookingAddonGuids = [] as any;
                for (let item of _data["bookingAddonGuids"])
                    this.bookingAddonGuids!.push(item);
            }
        }
    }

    static fromJS(data: any): AddBookingAddonsCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new AddBookingAddonsCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bookingAddonGuids)) {
            data["bookingAddonGuids"] = [];
            for (let item of this.bookingAddonGuids)
                data["bookingAddonGuids"].push(item);
        }
        return data;
    }
}

export interface IAddBookingAddonsCommandResult {
    bookingAddonGuids: string[] | null;
}

export class CreateMarketplaceBookingCommand implements ICreateMarketplaceBookingCommand {
    customerGuid!: string;
    name!: string | null;
    email!: string | null;
    phone?: string | null;
    listingGuid!: string;
    pricingGuid?: string | null;
    date!: Date;
    startTime!: TimeOnly;
    passengers?: number | null;
    notes?: string | null;
    promoCode?: string | null;
    campaignCode?: string | null;
    widgetDomain?: string | null;
    trackingParams?: BookingTrackingParamsDto;
    isExistingCustomer?: boolean;
    cateringEmailOptIn?: boolean;
    boatingClubEmailOptIn?: boolean;

    constructor(data?: ICreateMarketplaceBookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startTime = new TimeOnly();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.listingGuid = _data["listingGuid"];
            this.pricingGuid = _data["pricingGuid"];
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : new TimeOnly();
            this.passengers = _data["passengers"];
            this.notes = _data["notes"];
            this.promoCode = _data["promoCode"];
            this.campaignCode = _data["campaignCode"];
            this.widgetDomain = _data["widgetDomain"];
            this.trackingParams = _data["trackingParams"] ? BookingTrackingParamsDto.fromJS(_data["trackingParams"]) : <any>null;
            this.isExistingCustomer = _data["isExistingCustomer"];
            this.cateringEmailOptIn = _data["cateringEmailOptIn"];
            this.boatingClubEmailOptIn = _data["boatingClubEmailOptIn"];
        }
    }

    static fromJS(data: any): CreateMarketplaceBookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMarketplaceBookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["listingGuid"] = this.listingGuid;
        data["pricingGuid"] = this.pricingGuid;
        data["date"] = this.date && formatDate(this.date);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["passengers"] = this.passengers;
        data["notes"] = this.notes;
        data["promoCode"] = this.promoCode;
        data["campaignCode"] = this.campaignCode;
        data["widgetDomain"] = this.widgetDomain;
        data["trackingParams"] = this.trackingParams ? this.trackingParams.toJSON() : this.trackingParams;
        data["isExistingCustomer"] = this.isExistingCustomer;
        data["cateringEmailOptIn"] = this.cateringEmailOptIn;
        data["boatingClubEmailOptIn"] = this.boatingClubEmailOptIn;
        return data;
    }
}

export interface ICreateMarketplaceBookingCommand {
    customerGuid: string;
    name: string | null;
    email: string | null;
    phone?: string | null;
    listingGuid: string;
    pricingGuid?: string | null;
    date: Date;
    startTime: TimeOnly;
    passengers?: number | null;
    notes?: string | null;
    promoCode?: string | null;
    campaignCode?: string | null;
    widgetDomain?: string | null;
    trackingParams?: BookingTrackingParamsDto;
    isExistingCustomer?: boolean;
    cateringEmailOptIn?: boolean;
    boatingClubEmailOptIn?: boolean;
}

export class CreateMarketplaceBookingCommandResult implements ICreateMarketplaceBookingCommandResult {
    bookingGuid?: string;
    widgetAccessToken?: string | null;

    constructor(data?: ICreateMarketplaceBookingCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.widgetAccessToken = _data["widgetAccessToken"];
        }
    }

    static fromJS(data: any): CreateMarketplaceBookingCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMarketplaceBookingCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["widgetAccessToken"] = this.widgetAccessToken;
        return data;
    }
}

export interface ICreateMarketplaceBookingCommandResult {
    bookingGuid?: string;
    widgetAccessToken?: string | null;
}

export class UpdateBookingCustomerDetailsCommand implements IUpdateBookingCustomerDetailsCommand {
    phone?: string | null;
    idPassportNumber?: string | null;
    address?: CustomerAddress;
    clearAddress?: boolean;
    billingInfo?: CustomerBillingInfo;
    clearBillingInfo?: boolean;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: IUpdateBookingCustomerDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.idPassportNumber = _data["idPassportNumber"];
            this.address = _data["address"] ? CustomerAddress.fromJS(_data["address"]) : <any>null;
            this.clearAddress = _data["clearAddress"];
            this.billingInfo = _data["billingInfo"] ? CustomerBillingInfo.fromJS(_data["billingInfo"]) : <any>null;
            this.clearBillingInfo = _data["clearBillingInfo"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateBookingCustomerDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingCustomerDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["idPassportNumber"] = this.idPassportNumber;
        data["address"] = this.address ? this.address.toJSON() : this.address;
        data["clearAddress"] = this.clearAddress;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        data["clearBillingInfo"] = this.clearBillingInfo;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateBookingCustomerDetailsCommand {
    phone?: string | null;
    idPassportNumber?: string | null;
    address?: CustomerAddress;
    clearAddress?: boolean;
    billingInfo?: CustomerBillingInfo;
    clearBillingInfo?: boolean;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class UpdateBookingCustomerDetailsResult implements IUpdateBookingCustomerDetailsResult {
    missingFields?: string[] | null;

    constructor(data?: IUpdateBookingCustomerDetailsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missingFields"])) {
                this.missingFields = [] as any;
                for (let item of _data["missingFields"])
                    this.missingFields!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateBookingCustomerDetailsResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingCustomerDetailsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missingFields)) {
            data["missingFields"] = [];
            for (let item of this.missingFields)
                data["missingFields"].push(item);
        }
        return data;
    }
}

export interface IUpdateBookingCustomerDetailsResult {
    missingFields?: string[] | null;
}

export class UpdateBookingSuperchatDetailsCommand implements IUpdateBookingSuperchatDetailsCommand {
    superchatUrl?: string | null;
    externalOfferUrl?: string | null;

    constructor(data?: IUpdateBookingSuperchatDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.superchatUrl = _data["superchatUrl"];
            this.externalOfferUrl = _data["externalOfferUrl"];
        }
    }

    static fromJS(data: any): UpdateBookingSuperchatDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingSuperchatDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["superchatUrl"] = this.superchatUrl;
        data["externalOfferUrl"] = this.externalOfferUrl;
        return data;
    }
}

export interface IUpdateBookingSuperchatDetailsCommand {
    superchatUrl?: string | null;
    externalOfferUrl?: string | null;
}

export class BookingAddonDto implements IBookingAddonDto {
    guid?: string;
    addonGuid?: string;
    name!: string | null;
    description?: string | null;
    vendorGuid?: string;
    vendorName?: string | null;
    categoryGuid?: string;
    categoryName?: string | null;
    pricingModel?: PricingModel;
    bookability?: AddonBookability;
    approvalStatus?: BookingAddonStatus;
    quantity?: number;
    days?: number | null;
    unitBasePrice?: number;
    price!: PricedAmount;
    commissionable?: boolean;
    commissionRatePercentage?: number;
    commissionAmount?: number;
    selectedOptionGuid?: string | null;
    selectedOptionName?: string | null;
    note?: string | null;
    declineNote?: string | null;
    requestedAt?: InstantResult;
    resolvedAt?: InstantResult;
    resolvedByUserGuid?: string | null;
    createdAt!: InstantResult;
    updatedAt?: InstantResult;

    constructor(data?: IBookingAddonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.price = new PricedAmount();
            this.createdAt = new InstantResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.addonGuid = _data["addonGuid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.vendorGuid = _data["vendorGuid"];
            this.vendorName = _data["vendorName"];
            this.categoryGuid = _data["categoryGuid"];
            this.categoryName = _data["categoryName"];
            this.pricingModel = _data["pricingModel"];
            this.bookability = _data["bookability"];
            this.approvalStatus = _data["approvalStatus"];
            this.quantity = _data["quantity"];
            this.days = _data["days"];
            this.unitBasePrice = _data["unitBasePrice"];
            this.price = _data["price"] ? PricedAmount.fromJS(_data["price"]) : new PricedAmount();
            this.commissionable = _data["commissionable"];
            this.commissionRatePercentage = _data["commissionRatePercentage"];
            this.commissionAmount = _data["commissionAmount"];
            this.selectedOptionGuid = _data["selectedOptionGuid"];
            this.selectedOptionName = _data["selectedOptionName"];
            this.note = _data["note"];
            this.declineNote = _data["declineNote"];
            this.requestedAt = _data["requestedAt"] ? InstantResult.fromJS(_data["requestedAt"]) : <any>null;
            this.resolvedAt = _data["resolvedAt"] ? InstantResult.fromJS(_data["resolvedAt"]) : <any>null;
            this.resolvedByUserGuid = _data["resolvedByUserGuid"];
            this.createdAt = _data["createdAt"] ? InstantResult.fromJS(_data["createdAt"]) : new InstantResult();
            this.updatedAt = _data["updatedAt"] ? InstantResult.fromJS(_data["updatedAt"]) : <any>null;
        }
    }

    static fromJS(data: any): BookingAddonDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAddonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["addonGuid"] = this.addonGuid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["vendorGuid"] = this.vendorGuid;
        data["vendorName"] = this.vendorName;
        data["categoryGuid"] = this.categoryGuid;
        data["categoryName"] = this.categoryName;
        data["pricingModel"] = this.pricingModel;
        data["bookability"] = this.bookability;
        data["approvalStatus"] = this.approvalStatus;
        data["quantity"] = this.quantity;
        data["days"] = this.days;
        data["unitBasePrice"] = this.unitBasePrice;
        data["price"] = this.price ? this.price.toJSON() : this.price;
        data["commissionable"] = this.commissionable;
        data["commissionRatePercentage"] = this.commissionRatePercentage;
        data["commissionAmount"] = this.commissionAmount;
        data["selectedOptionGuid"] = this.selectedOptionGuid;
        data["selectedOptionName"] = this.selectedOptionName;
        data["note"] = this.note;
        data["declineNote"] = this.declineNote;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toJSON() : this.requestedAt;
        data["resolvedAt"] = this.resolvedAt ? this.resolvedAt.toJSON() : this.resolvedAt;
        data["resolvedByUserGuid"] = this.resolvedByUserGuid;
        data["createdAt"] = this.createdAt ? this.createdAt.toJSON() : this.createdAt;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toJSON() : this.updatedAt;
        return data;
    }
}

export interface IBookingAddonDto {
    guid?: string;
    addonGuid?: string;
    name: string | null;
    description?: string | null;
    vendorGuid?: string;
    vendorName?: string | null;
    categoryGuid?: string;
    categoryName?: string | null;
    pricingModel?: PricingModel;
    bookability?: AddonBookability;
    approvalStatus?: BookingAddonStatus;
    quantity?: number;
    days?: number | null;
    unitBasePrice?: number;
    price: PricedAmount;
    commissionable?: boolean;
    commissionRatePercentage?: number;
    commissionAmount?: number;
    selectedOptionGuid?: string | null;
    selectedOptionName?: string | null;
    note?: string | null;
    declineNote?: string | null;
    requestedAt?: InstantResult;
    resolvedAt?: InstantResult;
    resolvedByUserGuid?: string | null;
    createdAt: InstantResult;
    updatedAt?: InstantResult;
}

export class BookingAvailableAddonDto implements IBookingAvailableAddonDto {
    guid!: string;
    name!: string | null;
    description?: string | null;
    categoryGuid!: string;
    categoryName!: string | null;
    vendorGuid!: string;
    vendorName!: string | null;
    pricingModel!: PricingModel;
    basePrice!: number;
    price!: PricedAmount;
    defaultTaxes!: TaxLine[] | null;
    bookability!: AddonBookability;
    maxQuantity?: number | null;
    selectionType!: AddonSelectionType;
    options?: AddonOptionDto[] | null;
    image?: PictureResultModel;
    isFeatured!: boolean;
    isBooked!: boolean;

    constructor(data?: IBookingAvailableAddonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.price = new PricedAmount();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryGuid = _data["categoryGuid"];
            this.categoryName = _data["categoryName"];
            this.vendorGuid = _data["vendorGuid"];
            this.vendorName = _data["vendorName"];
            this.pricingModel = _data["pricingModel"];
            this.basePrice = _data["basePrice"];
            this.price = _data["price"] ? PricedAmount.fromJS(_data["price"]) : new PricedAmount();
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
            this.bookability = _data["bookability"];
            this.maxQuantity = _data["maxQuantity"];
            this.selectionType = _data["selectionType"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(AddonOptionDto.fromJS(item));
            }
            this.image = _data["image"] ? PictureResultModel.fromJS(_data["image"]) : <any>null;
            this.isFeatured = _data["isFeatured"];
            this.isBooked = _data["isBooked"];
        }
    }

    static fromJS(data: any): BookingAvailableAddonDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAvailableAddonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryGuid"] = this.categoryGuid;
        data["categoryName"] = this.categoryName;
        data["vendorGuid"] = this.vendorGuid;
        data["vendorName"] = this.vendorName;
        data["pricingModel"] = this.pricingModel;
        data["basePrice"] = this.basePrice;
        data["price"] = this.price ? this.price.toJSON() : this.price;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        data["bookability"] = this.bookability;
        data["maxQuantity"] = this.maxQuantity;
        data["selectionType"] = this.selectionType;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["image"] = this.image ? this.image.toJSON() : this.image;
        data["isFeatured"] = this.isFeatured;
        data["isBooked"] = this.isBooked;
        return data;
    }
}

export interface IBookingAvailableAddonDto {
    guid: string;
    name: string | null;
    description?: string | null;
    categoryGuid: string;
    categoryName: string | null;
    vendorGuid: string;
    vendorName: string | null;
    pricingModel: PricingModel;
    basePrice: number;
    price: PricedAmount;
    defaultTaxes: TaxLine[] | null;
    bookability: AddonBookability;
    maxQuantity?: number | null;
    selectionType: AddonSelectionType;
    options?: AddonOptionDto[] | null;
    image?: PictureResultModel;
    isFeatured: boolean;
    isBooked: boolean;
}

export class BrokerContactResult implements IBrokerContactResult {
    guid!: string;
    firstName!: string | null;
    lastName!: string | null;
    middleName!: string | null;
    fullName!: string | null;
    email!: string | null;
    phone!: string | null;

    constructor(data?: IBrokerContactResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): BrokerContactResult {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerContactResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IBrokerContactResult {
    guid: string;
    firstName: string | null;
    lastName: string | null;
    middleName: string | null;
    fullName: string | null;
    email: string | null;
    phone: string | null;
}

export class GetAnonymousBookingCustomerFieldsStatusQueryResult implements IGetAnonymousBookingCustomerFieldsStatusQueryResult {
    phoneFilled?: boolean;
    addressFilled?: boolean;
    billingInfoFilled?: boolean;
    billingAddressDiffersFromMainAddress?: boolean;
    companyFilled?: boolean;
    taxIdFilled?: boolean;
    idPassportNumberFilled?: boolean;
    firstNameFilled?: boolean;
    lastNameFilled?: boolean;
    emailFilled?: boolean;

    constructor(data?: IGetAnonymousBookingCustomerFieldsStatusQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneFilled = _data["phoneFilled"];
            this.addressFilled = _data["addressFilled"];
            this.billingInfoFilled = _data["billingInfoFilled"];
            this.billingAddressDiffersFromMainAddress = _data["billingAddressDiffersFromMainAddress"];
            this.companyFilled = _data["companyFilled"];
            this.taxIdFilled = _data["taxIdFilled"];
            this.idPassportNumberFilled = _data["idPassportNumberFilled"];
            this.firstNameFilled = _data["firstNameFilled"];
            this.lastNameFilled = _data["lastNameFilled"];
            this.emailFilled = _data["emailFilled"];
        }
    }

    static fromJS(data: any): GetAnonymousBookingCustomerFieldsStatusQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnonymousBookingCustomerFieldsStatusQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneFilled"] = this.phoneFilled;
        data["addressFilled"] = this.addressFilled;
        data["billingInfoFilled"] = this.billingInfoFilled;
        data["billingAddressDiffersFromMainAddress"] = this.billingAddressDiffersFromMainAddress;
        data["companyFilled"] = this.companyFilled;
        data["taxIdFilled"] = this.taxIdFilled;
        data["idPassportNumberFilled"] = this.idPassportNumberFilled;
        data["firstNameFilled"] = this.firstNameFilled;
        data["lastNameFilled"] = this.lastNameFilled;
        data["emailFilled"] = this.emailFilled;
        return data;
    }
}

export interface IGetAnonymousBookingCustomerFieldsStatusQueryResult {
    phoneFilled?: boolean;
    addressFilled?: boolean;
    billingInfoFilled?: boolean;
    billingAddressDiffersFromMainAddress?: boolean;
    companyFilled?: boolean;
    taxIdFilled?: boolean;
    idPassportNumberFilled?: boolean;
    firstNameFilled?: boolean;
    lastNameFilled?: boolean;
    emailFilled?: boolean;
}

export class GetBookingCustomerQueryResult implements IGetBookingCustomerQueryResult {
    guid?: string;
    address?: CustomerAddress;
    billingInfo?: CustomerBillingInfo;
    customerPreferences?: CustomerPreferences;
    concierge?: CustomerConcierge;
    customerClass?: CustomerClass;
    classification?: CustomerClassification;
    classificationReason?: string | null;
    isBlocked?: boolean;
    isDeleted?: boolean;
    customerNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    idPassportNumber?: string | null;
    markets?: MarketResult[] | null;

    constructor(data?: IGetBookingCustomerQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.address = _data["address"] ? CustomerAddress.fromJS(_data["address"]) : <any>null;
            this.billingInfo = _data["billingInfo"] ? CustomerBillingInfo.fromJS(_data["billingInfo"]) : <any>null;
            this.customerPreferences = _data["customerPreferences"] ? CustomerPreferences.fromJS(_data["customerPreferences"]) : <any>null;
            this.concierge = _data["concierge"] ? CustomerConcierge.fromJS(_data["concierge"]) : <any>null;
            this.customerClass = _data["customerClass"];
            this.classification = _data["classification"];
            this.classificationReason = _data["classificationReason"];
            this.isBlocked = _data["isBlocked"];
            this.isDeleted = _data["isDeleted"];
            this.customerNumber = _data["customerNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.idPassportNumber = _data["idPassportNumber"];
            if (Array.isArray(_data["markets"])) {
                this.markets = [] as any;
                for (let item of _data["markets"])
                    this.markets!.push(MarketResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBookingCustomerQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingCustomerQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["address"] = this.address ? this.address.toJSON() : this.address;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        data["customerPreferences"] = this.customerPreferences ? this.customerPreferences.toJSON() : this.customerPreferences;
        data["concierge"] = this.concierge ? this.concierge.toJSON() : this.concierge;
        data["customerClass"] = this.customerClass;
        data["classification"] = this.classification;
        data["classificationReason"] = this.classificationReason;
        data["isBlocked"] = this.isBlocked;
        data["isDeleted"] = this.isDeleted;
        data["customerNumber"] = this.customerNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["idPassportNumber"] = this.idPassportNumber;
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBookingCustomerQueryResult {
    guid?: string;
    address?: CustomerAddress;
    billingInfo?: CustomerBillingInfo;
    customerPreferences?: CustomerPreferences;
    concierge?: CustomerConcierge;
    customerClass?: CustomerClass;
    classification?: CustomerClassification;
    classificationReason?: string | null;
    isBlocked?: boolean;
    isDeleted?: boolean;
    customerNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    idPassportNumber?: string | null;
    markets?: MarketResult[] | null;
}

export class GetBookingPublicUrlQueryResult implements IGetBookingPublicUrlQueryResult {
    bookingDetailUrl!: string | null;

    constructor(data?: IGetBookingPublicUrlQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingDetailUrl = _data["bookingDetailUrl"];
        }
    }

    static fromJS(data: any): GetBookingPublicUrlQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingPublicUrlQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDetailUrl"] = this.bookingDetailUrl;
        return data;
    }
}

export interface IGetBookingPublicUrlQueryResult {
    bookingDetailUrl: string | null;
}

export class GetBookingQueryResult implements IGetBookingQueryResult {
    bookingId?: number;
    aliasId?: number | null;
    multibookingGuid?: string | null;
    multibookingId?: number | null;
    formattedMultibookingId?: string | null;
    status?: BookingStatus;
    expiredFrom?: BookingStatus;
    customer?: BookingCustomer;
    hasAuthenticationUser?: boolean;
    listingTitle?: string | null;
    from?: Date;
    to?: Date;
    startDate?: Date;
    startTime?: TimeOnly;
    endDate?: Date;
    endTime?: TimeOnly;
    passengers?: number | null;
    listing?: GetBookingQueryResultListing;
    pricingTemplateGuid?: string | null;
    bookingConflicts?: GetBookingQueryResultBookingConflict[] | null;
    boatEventConflictGuids?: string[] | null;
    pickupLocation?: LocationResult;
    dropOffLocation?: LocationResult;
    contractStatus?: ContractStatus;
    contractLastSentAt?: InstantResult;
    contractSignedAt?: InstantResult;
    skipper?: UserResult;
    checkinPerson?: UserResult;
    salesPerson?: GetBookingQueryResultSalesPerson;
    createdBy?: UserResult;
    createdAt?: InstantResult;
    updatedAt?: InstantResult;
    readonly stewardess?: UserResult[] | null;
    bookingNotes?: BookingNotes;
    gratuityLevel?: number | null;
    superchatDetails?: SuperchatDetails;
    basePrice?: number;
    rentalPrice?: PricedAmount;
    discountedRentalNetAmount?: number;
    discountedRentalTaxAmount?: number;
    discountedRentalGrossAmount?: number;
    paymentStatus?: BookingPaymentStatus;
    additionalFees?: BookingAdditionalFees;
    totalOnlineCustomerFeeAmount?: number;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    boatOwnerTakeRateAmount?: number | null;
    appliedPromoCode?: BookingAppliedPromoCode;
    appliedAgentDiscount?: BookingAppliedAgentDiscount;
    appliedCampaign?: BookingAppliedCampaign;
    commissionPercentage?: number;
    commissionAmount?: number;
    priceBreakdown?: BookingPriceBreakdown;
    ownerGuid?: string | null;
    pickupAddress?: OrderingLocationAddress;
    dropOffAddress?: OrderingLocationAddress;
    totalPrice?: number;
    netTotalAmount?: number;
    taxTotalAmount?: number;
    grossTotalAmount?: number;
    totalPaid?: number;
    totalPriceWithCustomerFee?: number;
    outstandingBalanceWithCustomerFee?: number;
    totalOnlineCustomerFeeWithRemaining?: number;
    remainingCustomerFee?: number;
    remainingToPay?: number;
    cancellationDetails?: BookingCancellationDetails;
    packageName?: string | null;
    boatPicture?: BoatPictureResultResult;
    bookingSourceInfo?: BookingSourceInfo;
    hasBoatSpecificationFile?: boolean;
    channelType?: BookingChannelType;
    agent?: BookingAgent;
    brokerGuid?: string | null;
    brokerContact?: BrokerContactResult;
    directChannelGuid?: string | null;
    isAvailableForReservation?: boolean;
    isOfferExpired?: boolean;
    isProformaExpired?: boolean;
    canRecalculatePrice?: boolean;
    proformaAvailabilityBlockExpiresAt?: InstantResult;
    offerAvailabilityBlockExpiresAt?: InstantResult;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    currency?: string | null;
    cashPaymentLimitAmount?: number | null;
    addonPurchaseCutoffAt?: InstantResult;
    addonPurchaseClosed?: boolean;
    requestApproved?: boolean | null;
    canProcessPayment?: boolean;
    requiredPrePaymentPercentage?: number | null;
    isPrePaymentOverridden?: boolean;
    prePayment?: PrePaymentInfo;
    marketplaceSessionId?: string | null;
    addons?: BookingAddonDto[] | null;

    constructor(data?: IGetBookingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.aliasId = _data["aliasId"];
            this.multibookingGuid = _data["multibookingGuid"];
            this.multibookingId = _data["multibookingId"];
            this.formattedMultibookingId = _data["formattedMultibookingId"];
            this.status = _data["status"];
            this.expiredFrom = _data["expiredFrom"];
            this.customer = _data["customer"] ? BookingCustomer.fromJS(_data["customer"]) : <any>null;
            this.hasAuthenticationUser = _data["hasAuthenticationUser"];
            this.listingTitle = _data["listingTitle"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : <any>null;
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? TimeOnly.fromJS(_data["endTime"]) : <any>null;
            this.passengers = _data["passengers"];
            this.listing = _data["listing"] ? GetBookingQueryResultListing.fromJS(_data["listing"]) : <any>null;
            this.pricingTemplateGuid = _data["pricingTemplateGuid"];
            if (Array.isArray(_data["bookingConflicts"])) {
                this.bookingConflicts = [] as any;
                for (let item of _data["bookingConflicts"])
                    this.bookingConflicts!.push(GetBookingQueryResultBookingConflict.fromJS(item));
            }
            if (Array.isArray(_data["boatEventConflictGuids"])) {
                this.boatEventConflictGuids = [] as any;
                for (let item of _data["boatEventConflictGuids"])
                    this.boatEventConflictGuids!.push(item);
            }
            this.pickupLocation = _data["pickupLocation"] ? LocationResult.fromJS(_data["pickupLocation"]) : <any>null;
            this.dropOffLocation = _data["dropOffLocation"] ? LocationResult.fromJS(_data["dropOffLocation"]) : <any>null;
            this.contractStatus = _data["contractStatus"];
            this.contractLastSentAt = _data["contractLastSentAt"] ? InstantResult.fromJS(_data["contractLastSentAt"]) : <any>null;
            this.contractSignedAt = _data["contractSignedAt"] ? InstantResult.fromJS(_data["contractSignedAt"]) : <any>null;
            this.skipper = _data["skipper"] ? UserResult.fromJS(_data["skipper"]) : <any>null;
            this.checkinPerson = _data["checkinPerson"] ? UserResult.fromJS(_data["checkinPerson"]) : <any>null;
            this.salesPerson = _data["salesPerson"] ? GetBookingQueryResultSalesPerson.fromJS(_data["salesPerson"]) : <any>null;
            this.createdBy = _data["createdBy"] ? UserResult.fromJS(_data["createdBy"]) : <any>null;
            this.createdAt = _data["createdAt"] ? InstantResult.fromJS(_data["createdAt"]) : <any>null;
            this.updatedAt = _data["updatedAt"] ? InstantResult.fromJS(_data["updatedAt"]) : <any>null;
            if (Array.isArray(_data["stewardess"])) {
                (<any>this).stewardess = [] as any;
                for (let item of _data["stewardess"])
                    (<any>this).stewardess!.push(UserResult.fromJS(item));
            }
            this.bookingNotes = _data["bookingNotes"] ? BookingNotes.fromJS(_data["bookingNotes"]) : <any>null;
            this.gratuityLevel = _data["gratuityLevel"];
            this.superchatDetails = _data["superchatDetails"] ? SuperchatDetails.fromJS(_data["superchatDetails"]) : <any>null;
            this.basePrice = _data["basePrice"];
            this.rentalPrice = _data["rentalPrice"] ? PricedAmount.fromJS(_data["rentalPrice"]) : <any>null;
            this.discountedRentalNetAmount = _data["discountedRentalNetAmount"];
            this.discountedRentalTaxAmount = _data["discountedRentalTaxAmount"];
            this.discountedRentalGrossAmount = _data["discountedRentalGrossAmount"];
            this.paymentStatus = _data["paymentStatus"];
            this.additionalFees = _data["additionalFees"] ? BookingAdditionalFees.fromJS(_data["additionalFees"]) : <any>null;
            this.totalOnlineCustomerFeeAmount = _data["totalOnlineCustomerFeeAmount"];
            this.basePriceDiscount = _data["basePriceDiscount"];
            this.discountTypeGuid = _data["discountTypeGuid"];
            this.boatOwnerTakeRateAmount = _data["boatOwnerTakeRateAmount"];
            this.appliedPromoCode = _data["appliedPromoCode"] ? BookingAppliedPromoCode.fromJS(_data["appliedPromoCode"]) : <any>null;
            this.appliedAgentDiscount = _data["appliedAgentDiscount"] ? BookingAppliedAgentDiscount.fromJS(_data["appliedAgentDiscount"]) : <any>null;
            this.appliedCampaign = _data["appliedCampaign"] ? BookingAppliedCampaign.fromJS(_data["appliedCampaign"]) : <any>null;
            this.commissionPercentage = _data["commissionPercentage"];
            this.commissionAmount = _data["commissionAmount"];
            this.priceBreakdown = _data["priceBreakdown"] ? BookingPriceBreakdown.fromJS(_data["priceBreakdown"]) : <any>null;
            this.ownerGuid = _data["ownerGuid"];
            this.pickupAddress = _data["pickupAddress"] ? OrderingLocationAddress.fromJS(_data["pickupAddress"]) : <any>null;
            this.dropOffAddress = _data["dropOffAddress"] ? OrderingLocationAddress.fromJS(_data["dropOffAddress"]) : <any>null;
            this.totalPrice = _data["totalPrice"];
            this.netTotalAmount = _data["netTotalAmount"];
            this.taxTotalAmount = _data["taxTotalAmount"];
            this.grossTotalAmount = _data["grossTotalAmount"];
            this.totalPaid = _data["totalPaid"];
            this.totalPriceWithCustomerFee = _data["totalPriceWithCustomerFee"];
            this.outstandingBalanceWithCustomerFee = _data["outstandingBalanceWithCustomerFee"];
            this.totalOnlineCustomerFeeWithRemaining = _data["totalOnlineCustomerFeeWithRemaining"];
            this.remainingCustomerFee = _data["remainingCustomerFee"];
            this.remainingToPay = _data["remainingToPay"];
            this.cancellationDetails = _data["cancellationDetails"] ? BookingCancellationDetails.fromJS(_data["cancellationDetails"]) : <any>null;
            this.packageName = _data["packageName"];
            this.boatPicture = _data["boatPicture"] ? BoatPictureResultResult.fromJS(_data["boatPicture"]) : <any>null;
            this.bookingSourceInfo = _data["bookingSourceInfo"] ? BookingSourceInfo.fromJS(_data["bookingSourceInfo"]) : <any>null;
            this.hasBoatSpecificationFile = _data["hasBoatSpecificationFile"];
            this.channelType = _data["channelType"];
            this.agent = _data["agent"] ? BookingAgent.fromJS(_data["agent"]) : <any>null;
            this.brokerGuid = _data["brokerGuid"];
            this.brokerContact = _data["brokerContact"] ? BrokerContactResult.fromJS(_data["brokerContact"]) : <any>null;
            this.directChannelGuid = _data["directChannelGuid"];
            this.isAvailableForReservation = _data["isAvailableForReservation"];
            this.isOfferExpired = _data["isOfferExpired"];
            this.isProformaExpired = _data["isProformaExpired"];
            this.canRecalculatePrice = _data["canRecalculatePrice"];
            this.proformaAvailabilityBlockExpiresAt = _data["proformaAvailabilityBlockExpiresAt"] ? InstantResult.fromJS(_data["proformaAvailabilityBlockExpiresAt"]) : <any>null;
            this.offerAvailabilityBlockExpiresAt = _data["offerAvailabilityBlockExpiresAt"] ? InstantResult.fromJS(_data["offerAvailabilityBlockExpiresAt"]) : <any>null;
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.culture = _data["culture"];
            this.currency = _data["currency"];
            this.cashPaymentLimitAmount = _data["cashPaymentLimitAmount"];
            this.addonPurchaseCutoffAt = _data["addonPurchaseCutoffAt"] ? InstantResult.fromJS(_data["addonPurchaseCutoffAt"]) : <any>null;
            this.addonPurchaseClosed = _data["addonPurchaseClosed"];
            this.requestApproved = _data["requestApproved"];
            this.canProcessPayment = _data["canProcessPayment"];
            this.requiredPrePaymentPercentage = _data["requiredPrePaymentPercentage"];
            this.isPrePaymentOverridden = _data["isPrePaymentOverridden"];
            this.prePayment = _data["prePayment"] ? PrePaymentInfo.fromJS(_data["prePayment"]) : <any>null;
            this.marketplaceSessionId = _data["marketplaceSessionId"];
            if (Array.isArray(_data["addons"])) {
                this.addons = [] as any;
                for (let item of _data["addons"])
                    this.addons!.push(BookingAddonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBookingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["aliasId"] = this.aliasId;
        data["multibookingGuid"] = this.multibookingGuid;
        data["multibookingId"] = this.multibookingId;
        data["formattedMultibookingId"] = this.formattedMultibookingId;
        data["status"] = this.status;
        data["expiredFrom"] = this.expiredFrom;
        data["customer"] = this.customer ? this.customer.toJSON() : this.customer;
        data["hasAuthenticationUser"] = this.hasAuthenticationUser;
        data["listingTitle"] = this.listingTitle;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["endDate"] = this.endDate && formatDate(this.endDate);
        data["endTime"] = this.endTime ? this.endTime.toJSON() : this.endTime;
        data["passengers"] = this.passengers;
        data["listing"] = this.listing ? this.listing.toJSON() : this.listing;
        data["pricingTemplateGuid"] = this.pricingTemplateGuid;
        if (Array.isArray(this.bookingConflicts)) {
            data["bookingConflicts"] = [];
            for (let item of this.bookingConflicts)
                data["bookingConflicts"].push(item.toJSON());
        }
        if (Array.isArray(this.boatEventConflictGuids)) {
            data["boatEventConflictGuids"] = [];
            for (let item of this.boatEventConflictGuids)
                data["boatEventConflictGuids"].push(item);
        }
        data["pickupLocation"] = this.pickupLocation ? this.pickupLocation.toJSON() : this.pickupLocation;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : this.dropOffLocation;
        data["contractStatus"] = this.contractStatus;
        data["contractLastSentAt"] = this.contractLastSentAt ? this.contractLastSentAt.toJSON() : this.contractLastSentAt;
        data["contractSignedAt"] = this.contractSignedAt ? this.contractSignedAt.toJSON() : this.contractSignedAt;
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["checkinPerson"] = this.checkinPerson ? this.checkinPerson.toJSON() : this.checkinPerson;
        data["salesPerson"] = this.salesPerson ? this.salesPerson.toJSON() : this.salesPerson;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toJSON() : this.createdAt;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toJSON() : this.updatedAt;
        if (Array.isArray(this.stewardess)) {
            data["stewardess"] = [];
            for (let item of this.stewardess)
                data["stewardess"].push(item.toJSON());
        }
        data["bookingNotes"] = this.bookingNotes ? this.bookingNotes.toJSON() : this.bookingNotes;
        data["gratuityLevel"] = this.gratuityLevel;
        data["superchatDetails"] = this.superchatDetails ? this.superchatDetails.toJSON() : this.superchatDetails;
        data["basePrice"] = this.basePrice;
        data["rentalPrice"] = this.rentalPrice ? this.rentalPrice.toJSON() : this.rentalPrice;
        data["discountedRentalNetAmount"] = this.discountedRentalNetAmount;
        data["discountedRentalTaxAmount"] = this.discountedRentalTaxAmount;
        data["discountedRentalGrossAmount"] = this.discountedRentalGrossAmount;
        data["paymentStatus"] = this.paymentStatus;
        data["additionalFees"] = this.additionalFees ? this.additionalFees.toJSON() : this.additionalFees;
        data["totalOnlineCustomerFeeAmount"] = this.totalOnlineCustomerFeeAmount;
        data["basePriceDiscount"] = this.basePriceDiscount;
        data["discountTypeGuid"] = this.discountTypeGuid;
        data["boatOwnerTakeRateAmount"] = this.boatOwnerTakeRateAmount;
        data["appliedPromoCode"] = this.appliedPromoCode ? this.appliedPromoCode.toJSON() : this.appliedPromoCode;
        data["appliedAgentDiscount"] = this.appliedAgentDiscount ? this.appliedAgentDiscount.toJSON() : this.appliedAgentDiscount;
        data["appliedCampaign"] = this.appliedCampaign ? this.appliedCampaign.toJSON() : this.appliedCampaign;
        data["commissionPercentage"] = this.commissionPercentage;
        data["commissionAmount"] = this.commissionAmount;
        data["priceBreakdown"] = this.priceBreakdown ? this.priceBreakdown.toJSON() : this.priceBreakdown;
        data["ownerGuid"] = this.ownerGuid;
        data["pickupAddress"] = this.pickupAddress ? this.pickupAddress.toJSON() : this.pickupAddress;
        data["dropOffAddress"] = this.dropOffAddress ? this.dropOffAddress.toJSON() : this.dropOffAddress;
        data["totalPrice"] = this.totalPrice;
        data["netTotalAmount"] = this.netTotalAmount;
        data["taxTotalAmount"] = this.taxTotalAmount;
        data["grossTotalAmount"] = this.grossTotalAmount;
        data["totalPaid"] = this.totalPaid;
        data["totalPriceWithCustomerFee"] = this.totalPriceWithCustomerFee;
        data["outstandingBalanceWithCustomerFee"] = this.outstandingBalanceWithCustomerFee;
        data["totalOnlineCustomerFeeWithRemaining"] = this.totalOnlineCustomerFeeWithRemaining;
        data["remainingCustomerFee"] = this.remainingCustomerFee;
        data["remainingToPay"] = this.remainingToPay;
        data["cancellationDetails"] = this.cancellationDetails ? this.cancellationDetails.toJSON() : this.cancellationDetails;
        data["packageName"] = this.packageName;
        data["boatPicture"] = this.boatPicture ? this.boatPicture.toJSON() : this.boatPicture;
        data["bookingSourceInfo"] = this.bookingSourceInfo ? this.bookingSourceInfo.toJSON() : this.bookingSourceInfo;
        data["hasBoatSpecificationFile"] = this.hasBoatSpecificationFile;
        data["channelType"] = this.channelType;
        data["agent"] = this.agent ? this.agent.toJSON() : this.agent;
        data["brokerGuid"] = this.brokerGuid;
        data["brokerContact"] = this.brokerContact ? this.brokerContact.toJSON() : this.brokerContact;
        data["directChannelGuid"] = this.directChannelGuid;
        data["isAvailableForReservation"] = this.isAvailableForReservation;
        data["isOfferExpired"] = this.isOfferExpired;
        data["isProformaExpired"] = this.isProformaExpired;
        data["canRecalculatePrice"] = this.canRecalculatePrice;
        data["proformaAvailabilityBlockExpiresAt"] = this.proformaAvailabilityBlockExpiresAt ? this.proformaAvailabilityBlockExpiresAt.toJSON() : this.proformaAvailabilityBlockExpiresAt;
        data["offerAvailabilityBlockExpiresAt"] = this.offerAvailabilityBlockExpiresAt ? this.offerAvailabilityBlockExpiresAt.toJSON() : this.offerAvailabilityBlockExpiresAt;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["culture"] = this.culture;
        data["currency"] = this.currency;
        data["cashPaymentLimitAmount"] = this.cashPaymentLimitAmount;
        data["addonPurchaseCutoffAt"] = this.addonPurchaseCutoffAt ? this.addonPurchaseCutoffAt.toJSON() : this.addonPurchaseCutoffAt;
        data["addonPurchaseClosed"] = this.addonPurchaseClosed;
        data["requestApproved"] = this.requestApproved;
        data["canProcessPayment"] = this.canProcessPayment;
        data["requiredPrePaymentPercentage"] = this.requiredPrePaymentPercentage;
        data["isPrePaymentOverridden"] = this.isPrePaymentOverridden;
        data["prePayment"] = this.prePayment ? this.prePayment.toJSON() : this.prePayment;
        data["marketplaceSessionId"] = this.marketplaceSessionId;
        if (Array.isArray(this.addons)) {
            data["addons"] = [];
            for (let item of this.addons)
                data["addons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBookingQueryResult {
    bookingId?: number;
    aliasId?: number | null;
    multibookingGuid?: string | null;
    multibookingId?: number | null;
    formattedMultibookingId?: string | null;
    status?: BookingStatus;
    expiredFrom?: BookingStatus;
    customer?: BookingCustomer;
    hasAuthenticationUser?: boolean;
    listingTitle?: string | null;
    from?: Date;
    to?: Date;
    startDate?: Date;
    startTime?: TimeOnly;
    endDate?: Date;
    endTime?: TimeOnly;
    passengers?: number | null;
    listing?: GetBookingQueryResultListing;
    pricingTemplateGuid?: string | null;
    bookingConflicts?: GetBookingQueryResultBookingConflict[] | null;
    boatEventConflictGuids?: string[] | null;
    pickupLocation?: LocationResult;
    dropOffLocation?: LocationResult;
    contractStatus?: ContractStatus;
    contractLastSentAt?: InstantResult;
    contractSignedAt?: InstantResult;
    skipper?: UserResult;
    checkinPerson?: UserResult;
    salesPerson?: GetBookingQueryResultSalesPerson;
    createdBy?: UserResult;
    createdAt?: InstantResult;
    updatedAt?: InstantResult;
    stewardess?: UserResult[] | null;
    bookingNotes?: BookingNotes;
    gratuityLevel?: number | null;
    superchatDetails?: SuperchatDetails;
    basePrice?: number;
    rentalPrice?: PricedAmount;
    discountedRentalNetAmount?: number;
    discountedRentalTaxAmount?: number;
    discountedRentalGrossAmount?: number;
    paymentStatus?: BookingPaymentStatus;
    additionalFees?: BookingAdditionalFees;
    totalOnlineCustomerFeeAmount?: number;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    boatOwnerTakeRateAmount?: number | null;
    appliedPromoCode?: BookingAppliedPromoCode;
    appliedAgentDiscount?: BookingAppliedAgentDiscount;
    appliedCampaign?: BookingAppliedCampaign;
    commissionPercentage?: number;
    commissionAmount?: number;
    priceBreakdown?: BookingPriceBreakdown;
    ownerGuid?: string | null;
    pickupAddress?: OrderingLocationAddress;
    dropOffAddress?: OrderingLocationAddress;
    totalPrice?: number;
    netTotalAmount?: number;
    taxTotalAmount?: number;
    grossTotalAmount?: number;
    totalPaid?: number;
    totalPriceWithCustomerFee?: number;
    outstandingBalanceWithCustomerFee?: number;
    totalOnlineCustomerFeeWithRemaining?: number;
    remainingCustomerFee?: number;
    remainingToPay?: number;
    cancellationDetails?: BookingCancellationDetails;
    packageName?: string | null;
    boatPicture?: BoatPictureResultResult;
    bookingSourceInfo?: BookingSourceInfo;
    hasBoatSpecificationFile?: boolean;
    channelType?: BookingChannelType;
    agent?: BookingAgent;
    brokerGuid?: string | null;
    brokerContact?: BrokerContactResult;
    directChannelGuid?: string | null;
    isAvailableForReservation?: boolean;
    isOfferExpired?: boolean;
    isProformaExpired?: boolean;
    canRecalculatePrice?: boolean;
    proformaAvailabilityBlockExpiresAt?: InstantResult;
    offerAvailabilityBlockExpiresAt?: InstantResult;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    currency?: string | null;
    cashPaymentLimitAmount?: number | null;
    addonPurchaseCutoffAt?: InstantResult;
    addonPurchaseClosed?: boolean;
    requestApproved?: boolean | null;
    canProcessPayment?: boolean;
    requiredPrePaymentPercentage?: number | null;
    isPrePaymentOverridden?: boolean;
    prePayment?: PrePaymentInfo;
    marketplaceSessionId?: string | null;
    addons?: BookingAddonDto[] | null;
}

export class GetBookingQueryResultBookingConflict implements IGetBookingQueryResultBookingConflict {
    guid!: string;
    bookingId!: number;

    constructor(data?: IGetBookingQueryResultBookingConflict) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
        }
    }

    static fromJS(data: any): GetBookingQueryResultBookingConflict {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingQueryResultBookingConflict();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        return data;
    }
}

export interface IGetBookingQueryResultBookingConflict {
    guid: string;
    bookingId: number;
}

export class GetBookingQueryResultListing implements IGetBookingQueryResultListing {
    guid?: string;
    boatGuid?: string;
    title?: string | null;
    publishStatus?: PublishStatus;
    boatIdentifier?: string | null;
    market?: MarketResult;
    location?: LocationResult;
    defaultSkipper?: UserResult;
    defaultStewardess?: UserResult;

    constructor(data?: IGetBookingQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.boatGuid = _data["boatGuid"];
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : <any>null;
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : <any>null;
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : <any>null;
        }
    }

    static fromJS(data: any): GetBookingQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["boatGuid"] = this.boatGuid;
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["boatIdentifier"] = this.boatIdentifier;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        return data;
    }
}

export interface IGetBookingQueryResultListing {
    guid?: string;
    boatGuid?: string;
    title?: string | null;
    publishStatus?: PublishStatus;
    boatIdentifier?: string | null;
    market?: MarketResult;
    location?: LocationResult;
    defaultSkipper?: UserResult;
    defaultStewardess?: UserResult;
}

export class GetBookingQueryResultSalesPerson implements IGetBookingQueryResultSalesPerson {
    fullName!: string | null;
    guid!: string;
    userGuid!: string;

    constructor(data?: IGetBookingQueryResultSalesPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.guid = _data["guid"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): GetBookingQueryResultSalesPerson {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingQueryResultSalesPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["guid"] = this.guid;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IGetBookingQueryResultSalesPerson {
    fullName: string | null;
    guid: string;
    userGuid: string;
}

export class GetBookingsByCreationDateRangeQueryResult implements IGetBookingsByCreationDateRangeQueryResult {
    readonly bookingGuid?: string;
    readonly bookingId?: number;
    readonly customerEmail?: string | null;
    readonly customerFullName?: string | null;
    readonly customerCreatedAtUtc?: Date;
    readonly customerPhone?: string | null;
    readonly bookingCreatedAtUtc?: Date;
    readonly bookingReservedAtUtc?: Date | null;
    bookingStatus?: BookingStatus;
    readonly bookingTotalPrice?: number;

    constructor(data?: IGetBookingsByCreationDateRangeQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).bookingGuid = _data["bookingGuid"];
            (<any>this).bookingId = _data["bookingId"];
            (<any>this).customerEmail = _data["customerEmail"];
            (<any>this).customerFullName = _data["customerFullName"];
            (<any>this).customerCreatedAtUtc = _data["customerCreatedAtUtc"] ? new Date(_data["customerCreatedAtUtc"].toString()) : <any>null;
            (<any>this).customerPhone = _data["customerPhone"];
            (<any>this).bookingCreatedAtUtc = _data["bookingCreatedAtUtc"] ? new Date(_data["bookingCreatedAtUtc"].toString()) : <any>null;
            (<any>this).bookingReservedAtUtc = _data["bookingReservedAtUtc"] ? new Date(_data["bookingReservedAtUtc"].toString()) : <any>null;
            this.bookingStatus = _data["bookingStatus"];
            (<any>this).bookingTotalPrice = _data["bookingTotalPrice"];
        }
    }

    static fromJS(data: any): GetBookingsByCreationDateRangeQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingsByCreationDateRangeQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["bookingId"] = this.bookingId;
        data["customerEmail"] = this.customerEmail;
        data["customerFullName"] = this.customerFullName;
        data["customerCreatedAtUtc"] = this.customerCreatedAtUtc && this.customerCreatedAtUtc.toISOString();
        data["customerPhone"] = this.customerPhone;
        data["bookingCreatedAtUtc"] = this.bookingCreatedAtUtc && this.bookingCreatedAtUtc.toISOString();
        data["bookingReservedAtUtc"] = this.bookingReservedAtUtc && this.bookingReservedAtUtc.toISOString();
        data["bookingStatus"] = this.bookingStatus;
        data["bookingTotalPrice"] = this.bookingTotalPrice;
        return data;
    }
}

export interface IGetBookingsByCreationDateRangeQueryResult {
    bookingGuid?: string;
    bookingId?: number;
    customerEmail?: string | null;
    customerFullName?: string | null;
    customerCreatedAtUtc?: Date;
    customerPhone?: string | null;
    bookingCreatedAtUtc?: Date;
    bookingReservedAtUtc?: Date | null;
    bookingStatus?: BookingStatus;
    bookingTotalPrice?: number;
}

export class GetOrCreateCustomerByEmailCommand implements IGetOrCreateCustomerByEmailCommand {
    name!: string | null;
    email!: string | null;
    phone?: string | null;

    constructor(data?: IGetOrCreateCustomerByEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GetOrCreateCustomerByEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrCreateCustomerByEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IGetOrCreateCustomerByEmailCommand {
    name: string | null;
    email: string | null;
    phone?: string | null;
}

export class GetOrCreateCustomerByEmailCommandResult implements IGetOrCreateCustomerByEmailCommandResult {
    customerGuid?: string;
    isExistingCustomer?: boolean;

    constructor(data?: IGetOrCreateCustomerByEmailCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.isExistingCustomer = _data["isExistingCustomer"];
        }
    }

    static fromJS(data: any): GetOrCreateCustomerByEmailCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrCreateCustomerByEmailCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["isExistingCustomer"] = this.isExistingCustomer;
        return data;
    }
}

export interface IGetOrCreateCustomerByEmailCommandResult {
    customerGuid?: string;
    isExistingCustomer?: boolean;
}

export class UpdateCustomerSuperchatDetailsCommand implements IUpdateCustomerSuperchatDetailsCommand {
    superchatId?: string | null;
    superchatLastUrl?: string | null;
    preferredLanguage?: string | null;
    campaignId?: string | null;

    constructor(data?: IUpdateCustomerSuperchatDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.superchatId = _data["superchatId"];
            this.superchatLastUrl = _data["superchatLastUrl"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.campaignId = _data["campaignId"];
        }
    }

    static fromJS(data: any): UpdateCustomerSuperchatDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerSuperchatDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["superchatId"] = this.superchatId;
        data["superchatLastUrl"] = this.superchatLastUrl;
        data["preferredLanguage"] = this.preferredLanguage;
        data["campaignId"] = this.campaignId;
        return data;
    }
}

export interface IUpdateCustomerSuperchatDetailsCommand {
    superchatId?: string | null;
    superchatLastUrl?: string | null;
    preferredLanguage?: string | null;
    campaignId?: string | null;
}

export class ExchangeBookingAnonymousTokenCommand implements IExchangeBookingAnonymousTokenCommand {
    anonymousToken!: string | null;

    constructor(data?: IExchangeBookingAnonymousTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anonymousToken = _data["anonymousToken"];
        }
    }

    static fromJS(data: any): ExchangeBookingAnonymousTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeBookingAnonymousTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anonymousToken"] = this.anonymousToken;
        return data;
    }
}

export interface IExchangeBookingAnonymousTokenCommand {
    anonymousToken: string | null;
}

export class ExchangeBookingAnonymousTokenCommandResult implements IExchangeBookingAnonymousTokenCommandResult {
    accessToken?: string | null;

    constructor(data?: IExchangeBookingAnonymousTokenCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): ExchangeBookingAnonymousTokenCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeBookingAnonymousTokenCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IExchangeBookingAnonymousTokenCommandResult {
    accessToken?: string | null;
}

export class ExchangeMultibookingAnonymousTokenCommand implements IExchangeMultibookingAnonymousTokenCommand {
    anonymousToken!: string | null;

    constructor(data?: IExchangeMultibookingAnonymousTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anonymousToken = _data["anonymousToken"];
        }
    }

    static fromJS(data: any): ExchangeMultibookingAnonymousTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeMultibookingAnonymousTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anonymousToken"] = this.anonymousToken;
        return data;
    }
}

export interface IExchangeMultibookingAnonymousTokenCommand {
    anonymousToken: string | null;
}

export class ExchangeMultibookingAnonymousTokenCommandResult implements IExchangeMultibookingAnonymousTokenCommandResult {
    accessToken?: string | null;

    constructor(data?: IExchangeMultibookingAnonymousTokenCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): ExchangeMultibookingAnonymousTokenCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeMultibookingAnonymousTokenCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IExchangeMultibookingAnonymousTokenCommandResult {
    accessToken?: string | null;
}

export class GenerateAuthenticationUserJwtFromMagicTokenCommand implements IGenerateAuthenticationUserJwtFromMagicTokenCommand {
    magicToken!: string | null;
    accessedUrl!: string | null;

    constructor(data?: IGenerateAuthenticationUserJwtFromMagicTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.magicToken = _data["magicToken"];
            this.accessedUrl = _data["accessedUrl"];
        }
    }

    static fromJS(data: any): GenerateAuthenticationUserJwtFromMagicTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAuthenticationUserJwtFromMagicTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["magicToken"] = this.magicToken;
        data["accessedUrl"] = this.accessedUrl;
        return data;
    }
}

export interface IGenerateAuthenticationUserJwtFromMagicTokenCommand {
    magicToken: string | null;
    accessedUrl: string | null;
}

export class GenerateAuthenticationUserJwtFromMagicTokenCommandResult implements IGenerateAuthenticationUserJwtFromMagicTokenCommandResult {
    accessToken?: string | null;
    refreshToken?: string | null;

    constructor(data?: IGenerateAuthenticationUserJwtFromMagicTokenCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): GenerateAuthenticationUserJwtFromMagicTokenCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAuthenticationUserJwtFromMagicTokenCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IGenerateAuthenticationUserJwtFromMagicTokenCommandResult {
    accessToken?: string | null;
    refreshToken?: string | null;
}

export class RequestMagicLinkByBookingGuidCommand implements IRequestMagicLinkByBookingGuidCommand {
    bookingGuid!: string;
    accessedUrl!: string | null;
    customerEmail?: string | null;

    constructor(data?: IRequestMagicLinkByBookingGuidCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.accessedUrl = _data["accessedUrl"];
            this.customerEmail = _data["customerEmail"];
        }
    }

    static fromJS(data: any): RequestMagicLinkByBookingGuidCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestMagicLinkByBookingGuidCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["accessedUrl"] = this.accessedUrl;
        data["customerEmail"] = this.customerEmail;
        return data;
    }
}

export interface IRequestMagicLinkByBookingGuidCommand {
    bookingGuid: string;
    accessedUrl: string | null;
    customerEmail?: string | null;
}

export class BoatPictureResultResult2 implements IBoatPictureResultResult2 {
    readonly pictureGuid?: string | null;
    readonly host?: string | null;
    bucket?: string | null;
    readonly name?: string | null;
    readonly extension?: string | null;
    readonly height?: number | null;
    readonly width?: number | null;
    readonly size?: number | null;
    sortOrder?: number;
    description?: string | null;

    constructor(data?: IBoatPictureResultResult2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).pictureGuid = _data["pictureGuid"];
            (<any>this).host = _data["host"];
            this.bucket = _data["bucket"];
            (<any>this).name = _data["name"];
            (<any>this).extension = _data["extension"];
            (<any>this).height = _data["height"];
            (<any>this).width = _data["width"];
            (<any>this).size = _data["size"];
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BoatPictureResultResult2 {
        data = typeof data === 'object' ? data : {};
        let result = new BoatPictureResultResult2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureGuid"] = this.pictureGuid;
        data["host"] = this.host;
        data["bucket"] = this.bucket;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["height"] = this.height;
        data["width"] = this.width;
        data["size"] = this.size;
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        return data;
    }
}

export interface IBoatPictureResultResult2 {
    pictureGuid?: string | null;
    host?: string | null;
    bucket?: string | null;
    name?: string | null;
    extension?: string | null;
    height?: number | null;
    width?: number | null;
    size?: number | null;
    sortOrder?: number;
    description?: string | null;
}

export class Booked implements IBooked {
    bookedFrom?: Date;
    bookedTo?: Date;

    constructor(data?: IBooked) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookedFrom = _data["bookedFrom"] ? new Date(_data["bookedFrom"].toString()) : <any>null;
            this.bookedTo = _data["bookedTo"] ? new Date(_data["bookedTo"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): Booked {
        data = typeof data === 'object' ? data : {};
        let result = new Booked();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookedFrom"] = this.bookedFrom && this.bookedFrom.toISOString();
        data["bookedTo"] = this.bookedTo && this.bookedTo.toISOString();
        return data;
    }
}

export interface IBooked {
    bookedFrom?: Date;
    bookedTo?: Date;
}

export class CalendarDayPriceResult implements ICalendarDayPriceResult {
    date!: Date;
    basePrice!: number;
    feesTotal!: number;
    isAvailable!: boolean;
    earliestAvailableStartTime?: TimeOnly;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;

    constructor(data?: ICalendarDayPriceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.basePrice = _data["basePrice"];
            this.feesTotal = _data["feesTotal"];
            this.isAvailable = _data["isAvailable"];
            this.earliestAvailableStartTime = _data["earliestAvailableStartTime"] ? TimeOnly.fromJS(_data["earliestAvailableStartTime"]) : <any>null;
            this.seasonGuid = _data["seasonGuid"];
            this.seasonName = _data["seasonName"];
            this.seasonColor = _data["seasonColor"];
            this.isCustomPrice = _data["isCustomPrice"];
        }
    }

    static fromJS(data: any): CalendarDayPriceResult {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDayPriceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        data["basePrice"] = this.basePrice;
        data["feesTotal"] = this.feesTotal;
        data["isAvailable"] = this.isAvailable;
        data["earliestAvailableStartTime"] = this.earliestAvailableStartTime ? this.earliestAvailableStartTime.toJSON() : this.earliestAvailableStartTime;
        data["seasonGuid"] = this.seasonGuid;
        data["seasonName"] = this.seasonName;
        data["seasonColor"] = this.seasonColor;
        data["isCustomPrice"] = this.isCustomPrice;
        return data;
    }
}

export interface ICalendarDayPriceResult {
    date: Date;
    basePrice: number;
    feesTotal: number;
    isAvailable: boolean;
    earliestAvailableStartTime?: TimeOnly;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;
}

export class DayPackagePriceAvailableListingResult implements IDayPackagePriceAvailableListingResult {
    readonly isAvailable?: boolean;
    startTime?: TimeOnly;
    duration?: TimeSpan;
    readonly name?: string | null;
    readonly basePrice?: number;
    readonly additionalFeesTotal?: number;
    readonly pricingGuid?: string;
    booked?: Booked[] | null;
    readonly sortOrder?: number | null;

    constructor(data?: IDayPackagePriceAvailableListingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isAvailable = _data["isAvailable"];
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : <any>null;
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>null;
            (<any>this).name = _data["name"];
            (<any>this).basePrice = _data["basePrice"];
            (<any>this).additionalFeesTotal = _data["additionalFeesTotal"];
            (<any>this).pricingGuid = _data["pricingGuid"];
            if (Array.isArray(_data["booked"])) {
                this.booked = [] as any;
                for (let item of _data["booked"])
                    this.booked!.push(Booked.fromJS(item));
            }
            (<any>this).sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): DayPackagePriceAvailableListingResult {
        data = typeof data === 'object' ? data : {};
        let result = new DayPackagePriceAvailableListingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        data["name"] = this.name;
        data["basePrice"] = this.basePrice;
        data["additionalFeesTotal"] = this.additionalFeesTotal;
        data["pricingGuid"] = this.pricingGuid;
        if (Array.isArray(this.booked)) {
            data["booked"] = [];
            for (let item of this.booked)
                data["booked"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IDayPackagePriceAvailableListingResult {
    isAvailable?: boolean;
    startTime?: TimeOnly;
    duration?: TimeSpan;
    name?: string | null;
    basePrice?: number;
    additionalFeesTotal?: number;
    pricingGuid?: string;
    booked?: Booked[] | null;
    sortOrder?: number | null;
}

export class DayPackagePriceResult implements IDayPackagePriceResult {
    guid?: string;
    isAvailable?: boolean;
    startTime?: TimeOnly;
    duration?: TimeSpan;
    name?: string | null;
    basePrice?: number;
    totalPrice?: number;
    pricingGuid?: string;
    additionalFees?: PricingAdditionalFeeItem[] | null;
    sortOrder?: number | null;

    constructor(data?: IDayPackagePriceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isAvailable = _data["isAvailable"];
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : <any>null;
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>null;
            this.name = _data["name"];
            this.basePrice = _data["basePrice"];
            this.totalPrice = _data["totalPrice"];
            this.pricingGuid = _data["pricingGuid"];
            if (Array.isArray(_data["additionalFees"])) {
                this.additionalFees = [] as any;
                for (let item of _data["additionalFees"])
                    this.additionalFees!.push(PricingAdditionalFeeItem.fromJS(item));
            }
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): DayPackagePriceResult {
        data = typeof data === 'object' ? data : {};
        let result = new DayPackagePriceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isAvailable"] = this.isAvailable;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        data["name"] = this.name;
        data["basePrice"] = this.basePrice;
        data["totalPrice"] = this.totalPrice;
        data["pricingGuid"] = this.pricingGuid;
        if (Array.isArray(this.additionalFees)) {
            data["additionalFees"] = [];
            for (let item of this.additionalFees)
                data["additionalFees"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IDayPackagePriceResult {
    guid?: string;
    isAvailable?: boolean;
    startTime?: TimeOnly;
    duration?: TimeSpan;
    name?: string | null;
    basePrice?: number;
    totalPrice?: number;
    pricingGuid?: string;
    additionalFees?: PricingAdditionalFeeItem[] | null;
    sortOrder?: number | null;
}

export class GetAvailableListingsQueryResult implements IGetAvailableListingsQueryResult {
    guid!: string;
    title!: string | null;
    marketTitle!: string | null;
    passengers!: number | null;
    length!: number | null;
    bathroomsCount!: number | null;
    crewCapacity!: number | null;
    boatIdentifier!: string | null;
    boatGuid!: string;
    listingTitle!: string | null;
    sortPriority!: number | null;
    ownerGuid!: string | null;
    pickupAddress!: LocationResult;
    skipper!: UserResult;
    picture!: PictureResultModel;
    priceFrom!: number;
    dayPackagePrices!: DayPackagePriceAvailableListingResult[] | null;

    constructor(data?: IGetAvailableListingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pickupAddress = new LocationResult();
            this.skipper = new UserResult();
            this.picture = new PictureResultModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.marketTitle = _data["marketTitle"];
            this.passengers = _data["passengers"];
            this.length = _data["length"];
            this.bathroomsCount = _data["bathroomsCount"];
            this.crewCapacity = _data["crewCapacity"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.boatGuid = _data["boatGuid"];
            this.listingTitle = _data["listingTitle"];
            this.sortPriority = _data["sortPriority"];
            this.ownerGuid = _data["ownerGuid"];
            this.pickupAddress = _data["pickupAddress"] ? LocationResult.fromJS(_data["pickupAddress"]) : new LocationResult();
            this.skipper = _data["skipper"] ? UserResult.fromJS(_data["skipper"]) : new UserResult();
            this.picture = _data["picture"] ? PictureResultModel.fromJS(_data["picture"]) : new PictureResultModel();
            this.priceFrom = _data["priceFrom"];
            if (Array.isArray(_data["dayPackagePrices"])) {
                this.dayPackagePrices = [] as any;
                for (let item of _data["dayPackagePrices"])
                    this.dayPackagePrices!.push(DayPackagePriceAvailableListingResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableListingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableListingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["marketTitle"] = this.marketTitle;
        data["passengers"] = this.passengers;
        data["length"] = this.length;
        data["bathroomsCount"] = this.bathroomsCount;
        data["crewCapacity"] = this.crewCapacity;
        data["boatIdentifier"] = this.boatIdentifier;
        data["boatGuid"] = this.boatGuid;
        data["listingTitle"] = this.listingTitle;
        data["sortPriority"] = this.sortPriority;
        data["ownerGuid"] = this.ownerGuid;
        data["pickupAddress"] = this.pickupAddress ? this.pickupAddress.toJSON() : this.pickupAddress;
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["picture"] = this.picture ? this.picture.toJSON() : this.picture;
        data["priceFrom"] = this.priceFrom;
        if (Array.isArray(this.dayPackagePrices)) {
            data["dayPackagePrices"] = [];
            for (let item of this.dayPackagePrices)
                data["dayPackagePrices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableListingsQueryResult {
    guid: string;
    title: string | null;
    marketTitle: string | null;
    passengers: number | null;
    length: number | null;
    bathroomsCount: number | null;
    crewCapacity: number | null;
    boatIdentifier: string | null;
    boatGuid: string;
    listingTitle: string | null;
    sortPriority: number | null;
    ownerGuid: string | null;
    pickupAddress: LocationResult;
    skipper: UserResult;
    picture: PictureResultModel;
    priceFrom: number;
    dayPackagePrices: DayPackagePriceAvailableListingResult[] | null;
}

export class GetMarketplaceAvailableCalendarPricingQuery implements IGetMarketplaceAvailableCalendarPricingQuery {
    listingGuid?: string;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IGetMarketplaceAvailableCalendarPricingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingGuid = _data["listingGuid"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetMarketplaceAvailableCalendarPricingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceAvailableCalendarPricingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingGuid"] = this.listingGuid;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["endDate"] = this.endDate && formatDate(this.endDate);
        return data;
    }
}

export interface IGetMarketplaceAvailableCalendarPricingQuery {
    listingGuid?: string;
    startDate?: Date;
    endDate?: Date;
}

export class GetMarketplaceAvailableCalendarPricingQueryResult implements IGetMarketplaceAvailableCalendarPricingQueryResult {
    isAvailable?: boolean;

    constructor(data?: IGetMarketplaceAvailableCalendarPricingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): GetMarketplaceAvailableCalendarPricingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceAvailableCalendarPricingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IGetMarketplaceAvailableCalendarPricingQueryResult {
    isAvailable?: boolean;
}

export class GetMarketplaceAvailableListingQuery implements IGetMarketplaceAvailableListingQuery {
    pricingGuid?: string;
    startDate?: Date;
    startTime?: TimeOnly;

    constructor(data?: IGetMarketplaceAvailableListingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricingGuid = _data["pricingGuid"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : <any>null;
        }
    }

    static fromJS(data: any): GetMarketplaceAvailableListingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceAvailableListingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricingGuid"] = this.pricingGuid;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        return data;
    }
}

export interface IGetMarketplaceAvailableListingQuery {
    pricingGuid?: string;
    startDate?: Date;
    startTime?: TimeOnly;
}

export class GetMarketplaceAvailableListingQueryResult implements IGetMarketplaceAvailableListingQueryResult {
    isAvailable?: boolean;

    constructor(data?: IGetMarketplaceAvailableListingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): GetMarketplaceAvailableListingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceAvailableListingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IGetMarketplaceAvailableListingQueryResult {
    isAvailable?: boolean;
}

export class GetMarketplaceCalendarDayPricingsQueryResult implements IGetMarketplaceCalendarDayPricingsQueryResult {
    listingTitle?: string | null;
    dayPackagePrices?: DayPackagePriceResult[] | null;

    constructor(data?: IGetMarketplaceCalendarDayPricingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingTitle = _data["listingTitle"];
            if (Array.isArray(_data["dayPackagePrices"])) {
                this.dayPackagePrices = [] as any;
                for (let item of _data["dayPackagePrices"])
                    this.dayPackagePrices!.push(DayPackagePriceResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMarketplaceCalendarDayPricingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceCalendarDayPricingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingTitle"] = this.listingTitle;
        if (Array.isArray(this.dayPackagePrices)) {
            data["dayPackagePrices"] = [];
            for (let item of this.dayPackagePrices)
                data["dayPackagePrices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMarketplaceCalendarDayPricingsQueryResult {
    listingTitle?: string | null;
    dayPackagePrices?: DayPackagePriceResult[] | null;
}

export class GetMarketplaceCalendarDaysQueryResult implements IGetMarketplaceCalendarDaysQueryResult {
    day?: Date;
    availability?: CalendarDayAvailability;
    earliestAvailableStartTime?: TimeOnly;

    constructor(data?: IGetMarketplaceCalendarDaysQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"] ? parseDateOnly(_data["day"].toString()) : <any>null;
            this.availability = _data["availability"];
            this.earliestAvailableStartTime = _data["earliestAvailableStartTime"] ? TimeOnly.fromJS(_data["earliestAvailableStartTime"]) : <any>null;
        }
    }

    static fromJS(data: any): GetMarketplaceCalendarDaysQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceCalendarDaysQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day && formatDate(this.day);
        data["availability"] = this.availability;
        data["earliestAvailableStartTime"] = this.earliestAvailableStartTime ? this.earliestAvailableStartTime.toJSON() : this.earliestAvailableStartTime;
        return data;
    }
}

export interface IGetMarketplaceCalendarDaysQueryResult {
    day?: Date;
    availability?: CalendarDayAvailability;
    earliestAvailableStartTime?: TimeOnly;
}

export class GetMarketplaceCalendarPricingQueryResult implements IGetMarketplaceCalendarPricingQueryResult {
    listingTitle!: string | null;
    pricingMode!: PricingMode;
    dayPrices!: CalendarDayPriceResult[] | null;

    constructor(data?: IGetMarketplaceCalendarPricingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingTitle = _data["listingTitle"];
            this.pricingMode = _data["pricingMode"];
            if (Array.isArray(_data["dayPrices"])) {
                this.dayPrices = [] as any;
                for (let item of _data["dayPrices"])
                    this.dayPrices!.push(CalendarDayPriceResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMarketplaceCalendarPricingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceCalendarPricingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingTitle"] = this.listingTitle;
        data["pricingMode"] = this.pricingMode;
        if (Array.isArray(this.dayPrices)) {
            data["dayPrices"] = [];
            for (let item of this.dayPrices)
                data["dayPrices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMarketplaceCalendarPricingQueryResult {
    listingTitle: string | null;
    pricingMode: PricingMode;
    dayPrices: CalendarDayPriceResult[] | null;
}

export class GetMarketplaceListingQueryBoatResult implements IGetMarketplaceListingQueryBoatResult {
    listingTitle?: string | null;
    registeredName?: string | null;
    passengers?: number;
    boatPicture?: BoatPictureResultResult2;
    availabilityMode?: BoatAvailabilityMode;
    makeAndModel?: string | null;
    description?: string | null;

    constructor(data?: IGetMarketplaceListingQueryBoatResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingTitle = _data["listingTitle"];
            this.registeredName = _data["registeredName"];
            this.passengers = _data["passengers"];
            this.boatPicture = _data["boatPicture"] ? BoatPictureResultResult2.fromJS(_data["boatPicture"]) : <any>null;
            this.availabilityMode = _data["availabilityMode"];
            this.makeAndModel = _data["makeAndModel"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetMarketplaceListingQueryBoatResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceListingQueryBoatResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingTitle"] = this.listingTitle;
        data["registeredName"] = this.registeredName;
        data["passengers"] = this.passengers;
        data["boatPicture"] = this.boatPicture ? this.boatPicture.toJSON() : this.boatPicture;
        data["availabilityMode"] = this.availabilityMode;
        data["makeAndModel"] = this.makeAndModel;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetMarketplaceListingQueryBoatResult {
    listingTitle?: string | null;
    registeredName?: string | null;
    passengers?: number;
    boatPicture?: BoatPictureResultResult2;
    availabilityMode?: BoatAvailabilityMode;
    makeAndModel?: string | null;
    description?: string | null;
}

export class GetMarketplaceListingQueryLocationResult implements IGetMarketplaceListingQueryLocationResult {
    title?: string | null;
    timeZoneInfoId?: string | null;

    constructor(data?: IGetMarketplaceListingQueryLocationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
        }
    }

    static fromJS(data: any): GetMarketplaceListingQueryLocationResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceListingQueryLocationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        return data;
    }
}

export interface IGetMarketplaceListingQueryLocationResult {
    title?: string | null;
    timeZoneInfoId?: string | null;
}

export class GetMarketplaceListingQueryResult implements IGetMarketplaceListingQueryResult {
    guid?: string;
    title?: string | null;
    boat?: GetMarketplaceListingQueryBoatResult;
    pickUpLocation?: GetMarketplaceListingQueryLocationResult;
    dropOffLocation?: GetMarketplaceListingQueryLocationResult;
    slipNumber?: string | null;
    notes?: string | null;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    currency?: string | null;
    pricingMode?: PricingMode;
    bookingType?: BookingType;
    widgetMode?: WidgetMode;
    widgetTheme?: GetMarketplaceListingQueryWidgetThemeResult;
    summaryNote?: string | null;
    locale?: LocaleSettingsResult;
    requirePassengers?: boolean;

    constructor(data?: IGetMarketplaceListingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.boat = _data["boat"] ? GetMarketplaceListingQueryBoatResult.fromJS(_data["boat"]) : <any>null;
            this.pickUpLocation = _data["pickUpLocation"] ? GetMarketplaceListingQueryLocationResult.fromJS(_data["pickUpLocation"]) : <any>null;
            this.dropOffLocation = _data["dropOffLocation"] ? GetMarketplaceListingQueryLocationResult.fromJS(_data["dropOffLocation"]) : <any>null;
            this.slipNumber = _data["slipNumber"];
            this.notes = _data["notes"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.culture = _data["culture"];
            this.currency = _data["currency"];
            this.pricingMode = _data["pricingMode"];
            this.bookingType = _data["bookingType"];
            this.widgetMode = _data["widgetMode"];
            this.widgetTheme = _data["widgetTheme"] ? GetMarketplaceListingQueryWidgetThemeResult.fromJS(_data["widgetTheme"]) : <any>null;
            this.summaryNote = _data["summaryNote"];
            this.locale = _data["locale"] ? LocaleSettingsResult.fromJS(_data["locale"]) : <any>null;
            this.requirePassengers = _data["requirePassengers"];
        }
    }

    static fromJS(data: any): GetMarketplaceListingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceListingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["pickUpLocation"] = this.pickUpLocation ? this.pickUpLocation.toJSON() : this.pickUpLocation;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : this.dropOffLocation;
        data["slipNumber"] = this.slipNumber;
        data["notes"] = this.notes;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["culture"] = this.culture;
        data["currency"] = this.currency;
        data["pricingMode"] = this.pricingMode;
        data["bookingType"] = this.bookingType;
        data["widgetMode"] = this.widgetMode;
        data["widgetTheme"] = this.widgetTheme ? this.widgetTheme.toJSON() : this.widgetTheme;
        data["summaryNote"] = this.summaryNote;
        data["locale"] = this.locale ? this.locale.toJSON() : this.locale;
        data["requirePassengers"] = this.requirePassengers;
        return data;
    }
}

export interface IGetMarketplaceListingQueryResult {
    guid?: string;
    title?: string | null;
    boat?: GetMarketplaceListingQueryBoatResult;
    pickUpLocation?: GetMarketplaceListingQueryLocationResult;
    dropOffLocation?: GetMarketplaceListingQueryLocationResult;
    slipNumber?: string | null;
    notes?: string | null;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    currency?: string | null;
    pricingMode?: PricingMode;
    bookingType?: BookingType;
    widgetMode?: WidgetMode;
    widgetTheme?: GetMarketplaceListingQueryWidgetThemeResult;
    summaryNote?: string | null;
    locale?: LocaleSettingsResult;
    requirePassengers?: boolean;
}

export class GetMarketplaceListingQueryWidgetThemeResult implements IGetMarketplaceListingQueryWidgetThemeResult {
    primaryColor?: string | null;
    primaryLightColor?: string | null;
    primaryTextColor?: string | null;
    calendarTextColor?: string | null;
    buttonRadius?: string | null;

    constructor(data?: IGetMarketplaceListingQueryWidgetThemeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["primaryColor"];
            this.primaryLightColor = _data["primaryLightColor"];
            this.primaryTextColor = _data["primaryTextColor"];
            this.calendarTextColor = _data["calendarTextColor"];
            this.buttonRadius = _data["buttonRadius"];
        }
    }

    static fromJS(data: any): GetMarketplaceListingQueryWidgetThemeResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceListingQueryWidgetThemeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryColor"] = this.primaryColor;
        data["primaryLightColor"] = this.primaryLightColor;
        data["primaryTextColor"] = this.primaryTextColor;
        data["calendarTextColor"] = this.calendarTextColor;
        data["buttonRadius"] = this.buttonRadius;
        return data;
    }
}

export interface IGetMarketplaceListingQueryWidgetThemeResult {
    primaryColor?: string | null;
    primaryLightColor?: string | null;
    primaryTextColor?: string | null;
    calendarTextColor?: string | null;
    buttonRadius?: string | null;
}

export class GetPublicMarketsQueryResult implements IGetPublicMarketsQueryResult {
    guid?: string;
    title?: string | null;
    code?: string | null;

    constructor(data?: IGetPublicMarketsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): GetPublicMarketsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicMarketsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["code"] = this.code;
        return data;
    }
}

export interface IGetPublicMarketsQueryResult {
    guid?: string;
    title?: string | null;
    code?: string | null;
}

export class AddCampaignVisitCommand implements IAddCampaignVisitCommand {
    campaignCode!: string | null;

    constructor(data?: IAddCampaignVisitCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignCode = _data["campaignCode"];
        }
    }

    static fromJS(data: any): AddCampaignVisitCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCampaignVisitCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignCode"] = this.campaignCode;
        return data;
    }
}

export interface IAddCampaignVisitCommand {
    campaignCode: string | null;
}

export class ValidateCampaignByEmailCommand implements IValidateCampaignByEmailCommand {
    campaignCode!: string | null;
    customerEmail!: string | null;
    startDate!: Date;
    startTime!: TimeOnly;

    constructor(data?: IValidateCampaignByEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startTime = new TimeOnly();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignCode = _data["campaignCode"];
            this.customerEmail = _data["customerEmail"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : new TimeOnly();
        }
    }

    static fromJS(data: any): ValidateCampaignByEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCampaignByEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignCode"] = this.campaignCode;
        data["customerEmail"] = this.customerEmail;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        return data;
    }
}

export interface IValidateCampaignByEmailCommand {
    campaignCode: string | null;
    customerEmail: string | null;
    startDate: Date;
    startTime: TimeOnly;
}

export class ValidateCampaignCommand implements IValidateCampaignCommand {
    campaignCode!: string | null;
    customerGuid!: string;
    startDate!: Date;
    startTime!: TimeOnly;

    constructor(data?: IValidateCampaignCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startTime = new TimeOnly();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignCode = _data["campaignCode"];
            this.customerGuid = _data["customerGuid"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : new TimeOnly();
        }
    }

    static fromJS(data: any): ValidateCampaignCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCampaignCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignCode"] = this.campaignCode;
        data["customerGuid"] = this.customerGuid;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        return data;
    }
}

export interface IValidateCampaignCommand {
    campaignCode: string | null;
    customerGuid: string;
    startDate: Date;
    startTime: TimeOnly;
}

export class ValidateCampaignResult implements IValidateCampaignResult {
    discountAmount?: number;

    constructor(data?: IValidateCampaignResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discountAmount = _data["discountAmount"];
        }
    }

    static fromJS(data: any): ValidateCampaignResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCampaignResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountAmount"] = this.discountAmount;
        return data;
    }
}

export interface IValidateCampaignResult {
    discountAmount?: number;
}

export class GetMultibookingSummaryForCustomerQueryResult implements IGetMultibookingSummaryForCustomerQueryResult {
    guid!: string;
    multibookingId!: number;
    formattedMultibookingId!: string | null;
    bookings?: MultibookingCustomerBookingSummary[] | null;
    totalPrice?: number;
    totalPaid?: number;
    remainingToPay?: number;
    totalPriceWithCustomerFee?: number;
    outstandingBalanceWithCustomerFee?: number;
    totalOnlineCustomerFeeWithRemaining?: number;
    remainingCustomerFee?: number;
    customerGuid!: string;
    culture!: string | null;
    prePayment?: PrePaymentInfo;

    constructor(data?: IGetMultibookingSummaryForCustomerQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.multibookingId = _data["multibookingId"];
            this.formattedMultibookingId = _data["formattedMultibookingId"];
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(MultibookingCustomerBookingSummary.fromJS(item));
            }
            this.totalPrice = _data["totalPrice"];
            this.totalPaid = _data["totalPaid"];
            this.remainingToPay = _data["remainingToPay"];
            this.totalPriceWithCustomerFee = _data["totalPriceWithCustomerFee"];
            this.outstandingBalanceWithCustomerFee = _data["outstandingBalanceWithCustomerFee"];
            this.totalOnlineCustomerFeeWithRemaining = _data["totalOnlineCustomerFeeWithRemaining"];
            this.remainingCustomerFee = _data["remainingCustomerFee"];
            this.customerGuid = _data["customerGuid"];
            this.culture = _data["culture"];
            this.prePayment = _data["prePayment"] ? PrePaymentInfo.fromJS(_data["prePayment"]) : <any>null;
        }
    }

    static fromJS(data: any): GetMultibookingSummaryForCustomerQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultibookingSummaryForCustomerQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["multibookingId"] = this.multibookingId;
        data["formattedMultibookingId"] = this.formattedMultibookingId;
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        data["totalPaid"] = this.totalPaid;
        data["remainingToPay"] = this.remainingToPay;
        data["totalPriceWithCustomerFee"] = this.totalPriceWithCustomerFee;
        data["outstandingBalanceWithCustomerFee"] = this.outstandingBalanceWithCustomerFee;
        data["totalOnlineCustomerFeeWithRemaining"] = this.totalOnlineCustomerFeeWithRemaining;
        data["remainingCustomerFee"] = this.remainingCustomerFee;
        data["customerGuid"] = this.customerGuid;
        data["culture"] = this.culture;
        data["prePayment"] = this.prePayment ? this.prePayment.toJSON() : this.prePayment;
        return data;
    }
}

export interface IGetMultibookingSummaryForCustomerQueryResult {
    guid: string;
    multibookingId: number;
    formattedMultibookingId: string | null;
    bookings?: MultibookingCustomerBookingSummary[] | null;
    totalPrice?: number;
    totalPaid?: number;
    remainingToPay?: number;
    totalPriceWithCustomerFee?: number;
    outstandingBalanceWithCustomerFee?: number;
    totalOnlineCustomerFeeWithRemaining?: number;
    remainingCustomerFee?: number;
    customerGuid: string;
    culture: string | null;
    prePayment?: PrePaymentInfo;
}

export class MultibookingCustomerBookingSummary implements IMultibookingCustomerBookingSummary {
    guid?: string;
    bookingId?: number;
    status?: BookingStatus;
    listingTitle?: string | null;
    boatName?: string | null;
    startUtc?: Date;
    from?: Date;
    to?: Date;
    totalPrice?: number;
    totalPaid?: number;
    pickupLocation?: string | null;
    dropOffLocation?: string | null;
    passengers?: number | null;
    currency!: string | null;
    boatPicture?: BoatPictureResultResult;
    appliedAgentDiscount?: BookingAppliedAgentDiscount;
    appliedCampaign?: BookingAppliedCampaign;

    constructor(data?: IMultibookingCustomerBookingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.status = _data["status"];
            this.listingTitle = _data["listingTitle"];
            this.boatName = _data["boatName"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : <any>null;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.totalPrice = _data["totalPrice"];
            this.totalPaid = _data["totalPaid"];
            this.pickupLocation = _data["pickupLocation"];
            this.dropOffLocation = _data["dropOffLocation"];
            this.passengers = _data["passengers"];
            this.currency = _data["currency"];
            this.boatPicture = _data["boatPicture"] ? BoatPictureResultResult.fromJS(_data["boatPicture"]) : <any>null;
            this.appliedAgentDiscount = _data["appliedAgentDiscount"] ? BookingAppliedAgentDiscount.fromJS(_data["appliedAgentDiscount"]) : <any>null;
            this.appliedCampaign = _data["appliedCampaign"] ? BookingAppliedCampaign.fromJS(_data["appliedCampaign"]) : <any>null;
        }
    }

    static fromJS(data: any): MultibookingCustomerBookingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new MultibookingCustomerBookingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["status"] = this.status;
        data["listingTitle"] = this.listingTitle;
        data["boatName"] = this.boatName;
        data["startUtc"] = this.startUtc && this.startUtc.toISOString();
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["totalPrice"] = this.totalPrice;
        data["totalPaid"] = this.totalPaid;
        data["pickupLocation"] = this.pickupLocation;
        data["dropOffLocation"] = this.dropOffLocation;
        data["passengers"] = this.passengers;
        data["currency"] = this.currency;
        data["boatPicture"] = this.boatPicture ? this.boatPicture.toJSON() : this.boatPicture;
        data["appliedAgentDiscount"] = this.appliedAgentDiscount ? this.appliedAgentDiscount.toJSON() : this.appliedAgentDiscount;
        data["appliedCampaign"] = this.appliedCampaign ? this.appliedCampaign.toJSON() : this.appliedCampaign;
        return data;
    }
}

export interface IMultibookingCustomerBookingSummary {
    guid?: string;
    bookingId?: number;
    status?: BookingStatus;
    listingTitle?: string | null;
    boatName?: string | null;
    startUtc?: Date;
    from?: Date;
    to?: Date;
    totalPrice?: number;
    totalPaid?: number;
    pickupLocation?: string | null;
    dropOffLocation?: string | null;
    passengers?: number | null;
    currency: string | null;
    boatPicture?: BoatPictureResultResult;
    appliedAgentDiscount?: BookingAppliedAgentDiscount;
    appliedCampaign?: BookingAppliedCampaign;
}

export class ValidateListingPromoCodeCommand implements IValidateListingPromoCodeCommand {
    promoCode!: string | null;
    startDate!: Date;

    constructor(data?: IValidateListingPromoCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promoCode = _data["promoCode"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ValidateListingPromoCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateListingPromoCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoCode"] = this.promoCode;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        return data;
    }
}

export interface IValidateListingPromoCodeCommand {
    promoCode: string | null;
    startDate: Date;
}

export class ValidateOrderingPromoCodeCommand implements IValidateOrderingPromoCodeCommand {
    promoCode!: string | null;
    startDate!: Date;
    startTime!: TimeOnly;

    constructor(data?: IValidateOrderingPromoCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startTime = new TimeOnly();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promoCode = _data["promoCode"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : new TimeOnly();
        }
    }

    static fromJS(data: any): ValidateOrderingPromoCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateOrderingPromoCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoCode"] = this.promoCode;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        return data;
    }
}

export interface IValidateOrderingPromoCodeCommand {
    promoCode: string | null;
    startDate: Date;
    startTime: TimeOnly;
}

export class ValidatePromoCodeResult implements IValidatePromoCodeResult {
    discountAmount?: number;

    constructor(data?: IValidatePromoCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discountAmount = _data["discountAmount"];
        }
    }

    static fromJS(data: any): ValidatePromoCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePromoCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountAmount"] = this.discountAmount;
        return data;
    }
}

export interface IValidatePromoCodeResult {
    discountAmount?: number;
}

export class GetOwnerQueryResult implements IGetOwnerQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: IGetOwnerQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.userGuid = _data["userGuid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GetOwnerQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOwnerQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["userGuid"] = this.userGuid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IGetOwnerQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class ChargeBookingAuthorizeNetPaymentCommand implements IChargeBookingAuthorizeNetPaymentCommand {
    bookingGuid!: string;
    creditCardPaymentRequest?: CreditCardPaymentRequest;
    bankAccountPaymentRequest?: BankAccountPaymentRequest;
    note?: string | null;

    constructor(data?: IChargeBookingAuthorizeNetPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.creditCardPaymentRequest = _data["creditCardPaymentRequest"] ? CreditCardPaymentRequest.fromJS(_data["creditCardPaymentRequest"]) : <any>null;
            this.bankAccountPaymentRequest = _data["bankAccountPaymentRequest"] ? BankAccountPaymentRequest.fromJS(_data["bankAccountPaymentRequest"]) : <any>null;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ChargeBookingAuthorizeNetPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeBookingAuthorizeNetPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["creditCardPaymentRequest"] = this.creditCardPaymentRequest ? this.creditCardPaymentRequest.toJSON() : this.creditCardPaymentRequest;
        data["bankAccountPaymentRequest"] = this.bankAccountPaymentRequest ? this.bankAccountPaymentRequest.toJSON() : this.bankAccountPaymentRequest;
        data["note"] = this.note;
        return data;
    }
}

export interface IChargeBookingAuthorizeNetPaymentCommand {
    bookingGuid: string;
    creditCardPaymentRequest?: CreditCardPaymentRequest;
    bankAccountPaymentRequest?: BankAccountPaymentRequest;
    note?: string | null;
}

export class ChargeBookingAuthorizeNetPaymentCommandResult implements IChargeBookingAuthorizeNetPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;

    constructor(data?: IChargeBookingAuthorizeNetPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.transactionStatus = _data["transactionStatus"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): ChargeBookingAuthorizeNetPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeBookingAuthorizeNetPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["transactionStatus"] = this.transactionStatus;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IChargeBookingAuthorizeNetPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;
}

export class CreateBookingAuthorizeNetCheckoutSessionCommand implements ICreateBookingAuthorizeNetCheckoutSessionCommand {
    bookingGuid!: string;
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateBookingAuthorizeNetCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateBookingAuthorizeNetCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingAuthorizeNetCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateBookingAuthorizeNetCheckoutSessionCommand {
    bookingGuid: string;
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class ProcessAuthorizeNetCheckoutSessionPaymentCommand implements IProcessAuthorizeNetCheckoutSessionPaymentCommand {
    checkoutSessionGuid!: string;
    creditCardPaymentRequest?: CreditCardPaymentRequest;
    bankAccountPaymentRequest?: BankAccountPaymentRequest;
    note?: string | null;

    constructor(data?: IProcessAuthorizeNetCheckoutSessionPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionGuid = _data["checkoutSessionGuid"];
            this.creditCardPaymentRequest = _data["creditCardPaymentRequest"] ? CreditCardPaymentRequest.fromJS(_data["creditCardPaymentRequest"]) : <any>null;
            this.bankAccountPaymentRequest = _data["bankAccountPaymentRequest"] ? BankAccountPaymentRequest.fromJS(_data["bankAccountPaymentRequest"]) : <any>null;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ProcessAuthorizeNetCheckoutSessionPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAuthorizeNetCheckoutSessionPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionGuid"] = this.checkoutSessionGuid;
        data["creditCardPaymentRequest"] = this.creditCardPaymentRequest ? this.creditCardPaymentRequest.toJSON() : this.creditCardPaymentRequest;
        data["bankAccountPaymentRequest"] = this.bankAccountPaymentRequest ? this.bankAccountPaymentRequest.toJSON() : this.bankAccountPaymentRequest;
        data["note"] = this.note;
        return data;
    }
}

export interface IProcessAuthorizeNetCheckoutSessionPaymentCommand {
    checkoutSessionGuid: string;
    creditCardPaymentRequest?: CreditCardPaymentRequest;
    bankAccountPaymentRequest?: BankAccountPaymentRequest;
    note?: string | null;
}

export class ProcessAuthorizeNetCheckoutSessionPaymentCommandResult implements IProcessAuthorizeNetCheckoutSessionPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;

    constructor(data?: IProcessAuthorizeNetCheckoutSessionPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.transactionStatus = _data["transactionStatus"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): ProcessAuthorizeNetCheckoutSessionPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAuthorizeNetCheckoutSessionPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["transactionStatus"] = this.transactionStatus;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IProcessAuthorizeNetCheckoutSessionPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;
}

export class BookingCheckoutSessionResponse implements IBookingCheckoutSessionResponse {
    start?: Date;
    end?: Date;
    passengers?: number | null;
    listingTitle?: string | null;

    constructor(data?: IBookingCheckoutSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
            this.passengers = _data["passengers"];
            this.listingTitle = _data["listingTitle"];
        }
    }

    static fromJS(data: any): BookingCheckoutSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCheckoutSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start && this.start.toISOString();
        data["end"] = this.end && this.end.toISOString();
        data["passengers"] = this.passengers;
        data["listingTitle"] = this.listingTitle;
        return data;
    }
}

export interface IBookingCheckoutSessionResponse {
    start?: Date;
    end?: Date;
    passengers?: number | null;
    listingTitle?: string | null;
}

export class GetAuthorizeNetCheckoutSessionQueryResponse implements IGetAuthorizeNetCheckoutSessionQueryResponse {
    sessionGuid?: string;
    amount?: number;
    currency?: string | null;
    isAvailable?: boolean;
    booking?: BookingCheckoutSessionResponse;
    lineItems?: AuthorizeNetCheckoutSessionLineItem[] | null;

    constructor(data?: IGetAuthorizeNetCheckoutSessionQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.isAvailable = _data["isAvailable"];
            this.booking = _data["booking"] ? BookingCheckoutSessionResponse.fromJS(_data["booking"]) : <any>null;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(AuthorizeNetCheckoutSessionLineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAuthorizeNetCheckoutSessionQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthorizeNetCheckoutSessionQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["isAvailable"] = this.isAvailable;
        data["booking"] = this.booking ? this.booking.toJSON() : this.booking;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAuthorizeNetCheckoutSessionQueryResponse {
    sessionGuid?: string;
    amount?: number;
    currency?: string | null;
    isAvailable?: boolean;
    booking?: BookingCheckoutSessionResponse;
    lineItems?: AuthorizeNetCheckoutSessionLineItem[] | null;
}

export class CreateBookingPaymentIntentCommand implements ICreateBookingPaymentIntentCommand {
    bookingGuid!: string;
    isPrePayment!: boolean;
    expectedAmount!: number;

    constructor(data?: ICreateBookingPaymentIntentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.isPrePayment = _data["isPrePayment"];
            this.expectedAmount = _data["expectedAmount"];
        }
    }

    static fromJS(data: any): CreateBookingPaymentIntentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingPaymentIntentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["isPrePayment"] = this.isPrePayment;
        data["expectedAmount"] = this.expectedAmount;
        return data;
    }
}

export interface ICreateBookingPaymentIntentCommand {
    bookingGuid: string;
    isPrePayment: boolean;
    expectedAmount: number;
}

export class CreateBookingStripeCheckoutSessionCommand implements ICreateBookingStripeCheckoutSessionCommand {
    bookingGuid!: string;
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateBookingStripeCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateBookingStripeCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingStripeCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateBookingStripeCheckoutSessionCommand {
    bookingGuid: string;
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateCustomerDashboardBookingStripeCheckoutSessionCommand implements ICreateCustomerDashboardBookingStripeCheckoutSessionCommand {
    bookingGuid!: string;
    amount!: number;
    description?: string | null;

    constructor(data?: ICreateCustomerDashboardBookingStripeCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateCustomerDashboardBookingStripeCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDashboardBookingStripeCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateCustomerDashboardBookingStripeCheckoutSessionCommand {
    bookingGuid: string;
    amount: number;
    description?: string | null;
}

export class CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult implements ICreateCustomerDashboardBookingStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;

    constructor(data?: ICreateCustomerDashboardBookingStripeCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionId = _data["checkoutSessionId"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
        }
    }

    static fromJS(data: any): CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        return data;
    }
}

export interface ICreateCustomerDashboardBookingStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;
}

export class CreatePaymentIntentCommandResult implements ICreatePaymentIntentCommandResult {
    clientSecret?: string | null;
    paymentGuid?: string;
    paymentIntentId?: string | null;

    constructor(data?: ICreatePaymentIntentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientSecret = _data["clientSecret"];
            this.paymentGuid = _data["paymentGuid"];
            this.paymentIntentId = _data["paymentIntentId"];
        }
    }

    static fromJS(data: any): CreatePaymentIntentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentIntentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientSecret"] = this.clientSecret;
        data["paymentGuid"] = this.paymentGuid;
        data["paymentIntentId"] = this.paymentIntentId;
        return data;
    }
}

export interface ICreatePaymentIntentCommandResult {
    clientSecret?: string | null;
    paymentGuid?: string;
    paymentIntentId?: string | null;
}

export class CreateStripeCheckoutSessionCommandResult implements ICreateStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;

    constructor(data?: ICreateStripeCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionId = _data["checkoutSessionId"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
        }
    }

    static fromJS(data: any): CreateStripeCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStripeCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        return data;
    }
}

export interface ICreateStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;
}

export class CreateMultibookingAuthorizeNetCheckoutSessionCommand implements ICreateMultibookingAuthorizeNetCheckoutSessionCommand {
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateMultibookingAuthorizeNetCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateMultibookingAuthorizeNetCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingAuthorizeNetCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateMultibookingAuthorizeNetCheckoutSessionCommand {
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateMultibookingStripeCheckoutSessionCommand implements ICreateMultibookingStripeCheckoutSessionCommand {
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateMultibookingStripeCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateMultibookingStripeCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingStripeCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateMultibookingStripeCheckoutSessionCommand {
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateMultibookingStripeCheckoutSessionCommandResult implements ICreateMultibookingStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;

    constructor(data?: ICreateMultibookingStripeCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionId = _data["checkoutSessionId"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
        }
    }

    static fromJS(data: any): CreateMultibookingStripeCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingStripeCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        return data;
    }
}

export interface ICreateMultibookingStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;
}

export class CreateMultibookingWorldPayCheckoutSessionCommand implements ICreateMultibookingWorldPayCheckoutSessionCommand {
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateMultibookingWorldPayCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateMultibookingWorldPayCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingWorldPayCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateMultibookingWorldPayCheckoutSessionCommand {
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateMultibookingWorldPayCheckoutSessionCommandResult implements ICreateMultibookingWorldPayCheckoutSessionCommandResult {
    sessionGuid!: string;
    checkoutSessionUrl!: string | null;
    merchantId!: string | null;
    amount!: number;
    currency!: string | null;

    constructor(data?: ICreateMultibookingWorldPayCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
            this.merchantId = _data["merchantId"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CreateMultibookingWorldPayCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingWorldPayCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["merchantId"] = this.merchantId;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICreateMultibookingWorldPayCheckoutSessionCommandResult {
    sessionGuid: string;
    checkoutSessionUrl: string | null;
    merchantId: string | null;
    amount: number;
    currency: string | null;
}

export class GetPaymentQueryResult implements IGetPaymentQueryResult {
    guid?: string;
    createdAt?: Date;
    amount?: number;
    currency?: string | null;
    note?: string | null;
    status?: PaymentStatus;
    provider?: PaymentProvider;
    externalPaymentInfo?: ExternalPaymentInfo;
    stripePaymentInfo?: StripePaymentInfo;
    authorizeNetPaymentInfo?: AuthorizeNetPaymentInfo;

    constructor(data?: IGetPaymentQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.provider = _data["provider"];
            this.externalPaymentInfo = _data["externalPaymentInfo"] ? ExternalPaymentInfo.fromJS(_data["externalPaymentInfo"]) : <any>null;
            this.stripePaymentInfo = _data["stripePaymentInfo"] ? StripePaymentInfo.fromJS(_data["stripePaymentInfo"]) : <any>null;
            this.authorizeNetPaymentInfo = _data["authorizeNetPaymentInfo"] ? AuthorizeNetPaymentInfo.fromJS(_data["authorizeNetPaymentInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPaymentQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["note"] = this.note;
        data["status"] = this.status;
        data["provider"] = this.provider;
        data["externalPaymentInfo"] = this.externalPaymentInfo ? this.externalPaymentInfo.toJSON() : this.externalPaymentInfo;
        data["stripePaymentInfo"] = this.stripePaymentInfo ? this.stripePaymentInfo.toJSON() : this.stripePaymentInfo;
        data["authorizeNetPaymentInfo"] = this.authorizeNetPaymentInfo ? this.authorizeNetPaymentInfo.toJSON() : this.authorizeNetPaymentInfo;
        return data;
    }
}

export interface IGetPaymentQueryResult {
    guid?: string;
    createdAt?: Date;
    amount?: number;
    currency?: string | null;
    note?: string | null;
    status?: PaymentStatus;
    provider?: PaymentProvider;
    externalPaymentInfo?: ExternalPaymentInfo;
    stripePaymentInfo?: StripePaymentInfo;
    authorizeNetPaymentInfo?: AuthorizeNetPaymentInfo;
}

export class GetPaymentStatusQueryResult implements IGetPaymentStatusQueryResult {
    guid?: string;
    status?: PaymentStatus;
    paymentProvider?: PaymentProvider;
    cardLast4?: string | null;
    cardBrand?: string | null;
    createdAt?: Date;
    amount?: number;
    currency?: string | null;
    paidOn?: Date | null;

    constructor(data?: IGetPaymentStatusQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.status = _data["status"];
            this.paymentProvider = _data["paymentProvider"];
            this.cardLast4 = _data["cardLast4"];
            this.cardBrand = _data["cardBrand"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetPaymentStatusQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentStatusQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["status"] = this.status;
        data["paymentProvider"] = this.paymentProvider;
        data["cardLast4"] = this.cardLast4;
        data["cardBrand"] = this.cardBrand;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["paidOn"] = this.paidOn && this.paidOn.toISOString();
        return data;
    }
}

export interface IGetPaymentStatusQueryResult {
    guid?: string;
    status?: PaymentStatus;
    paymentProvider?: PaymentProvider;
    cardLast4?: string | null;
    cardBrand?: string | null;
    createdAt?: Date;
    amount?: number;
    currency?: string | null;
    paidOn?: Date | null;
}

export class CreateBookingWorldPayCheckoutSessionCommand implements ICreateBookingWorldPayCheckoutSessionCommand {
    bookingGuid!: string;
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateBookingWorldPayCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateBookingWorldPayCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingWorldPayCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateBookingWorldPayCheckoutSessionCommand {
    bookingGuid: string;
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateBookingWorldPayCheckoutSessionCommandResult implements ICreateBookingWorldPayCheckoutSessionCommandResult {
    sessionGuid!: string;
    checkoutSessionUrl!: string | null;
    merchantId!: string | null;
    amount!: number;
    currency!: string | null;

    constructor(data?: ICreateBookingWorldPayCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
            this.merchantId = _data["merchantId"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CreateBookingWorldPayCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingWorldPayCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["merchantId"] = this.merchantId;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICreateBookingWorldPayCheckoutSessionCommandResult {
    sessionGuid: string;
    checkoutSessionUrl: string | null;
    merchantId: string | null;
    amount: number;
    currency: string | null;
}

export class CreateCustomerDashboardBookingWorldPayCheckoutSessionCommand implements ICreateCustomerDashboardBookingWorldPayCheckoutSessionCommand {
    bookingGuid!: string;
    amount!: number;
    description?: string | null;

    constructor(data?: ICreateCustomerDashboardBookingWorldPayCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateCustomerDashboardBookingWorldPayCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDashboardBookingWorldPayCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateCustomerDashboardBookingWorldPayCheckoutSessionCommand {
    bookingGuid: string;
    amount: number;
    description?: string | null;
}

export class CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult implements ICreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult {
    sessionGuid!: string;
    checkoutSessionUrl!: string | null;
    merchantId!: string | null;
    amount!: number;
    currency!: string | null;

    constructor(data?: ICreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
            this.merchantId = _data["merchantId"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["merchantId"] = this.merchantId;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult {
    sessionGuid: string;
    checkoutSessionUrl: string | null;
    merchantId: string | null;
    amount: number;
    currency: string | null;
}

export class ProcessWorldPayCheckoutSessionPaymentCommand implements IProcessWorldPayCheckoutSessionPaymentCommand {
    sessionGuid!: string;
    token!: string | null;
    tokenId!: string | null;
    last4Digits!: string | null;

    constructor(data?: IProcessWorldPayCheckoutSessionPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.token = _data["token"];
            this.tokenId = _data["tokenId"];
            this.last4Digits = _data["last4Digits"];
        }
    }

    static fromJS(data: any): ProcessWorldPayCheckoutSessionPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWorldPayCheckoutSessionPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["token"] = this.token;
        data["tokenId"] = this.tokenId;
        data["last4Digits"] = this.last4Digits;
        return data;
    }
}

export interface IProcessWorldPayCheckoutSessionPaymentCommand {
    sessionGuid: string;
    token: string | null;
    tokenId: string | null;
    last4Digits: string | null;
}

export class ProcessWorldPayCheckoutSessionPaymentCommandResult implements IProcessWorldPayCheckoutSessionPaymentCommandResult {
    paymentGuid!: string;
    transactionStatus!: WorldPayTransactionStatus;
    success!: boolean;
    errorMessage?: string | null;
    paymentMethodGuid?: string | null;
    isNewPaymentMethod?: boolean;

    constructor(data?: IProcessWorldPayCheckoutSessionPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.transactionStatus = _data["transactionStatus"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.paymentMethodGuid = _data["paymentMethodGuid"];
            this.isNewPaymentMethod = _data["isNewPaymentMethod"];
        }
    }

    static fromJS(data: any): ProcessWorldPayCheckoutSessionPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWorldPayCheckoutSessionPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["transactionStatus"] = this.transactionStatus;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["paymentMethodGuid"] = this.paymentMethodGuid;
        data["isNewPaymentMethod"] = this.isNewPaymentMethod;
        return data;
    }
}

export interface IProcessWorldPayCheckoutSessionPaymentCommandResult {
    paymentGuid: string;
    transactionStatus: WorldPayTransactionStatus;
    success: boolean;
    errorMessage?: string | null;
    paymentMethodGuid?: string | null;
    isNewPaymentMethod?: boolean;
}

export class GetWorldPayCheckoutSessionQueryResponse implements IGetWorldPayCheckoutSessionQueryResponse {
    sessionGuid?: string;
    amount?: number;
    currency?: string | null;
    description?: string | null;
    isAvailable?: boolean;
    merchantId?: string | null;
    booking?: WorldPayBookingCheckoutSessionResponse;
    lineItems?: WorldPayCheckoutSessionLineItem[] | null;

    constructor(data?: IGetWorldPayCheckoutSessionQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.description = _data["description"];
            this.isAvailable = _data["isAvailable"];
            this.merchantId = _data["merchantId"];
            this.booking = _data["booking"] ? WorldPayBookingCheckoutSessionResponse.fromJS(_data["booking"]) : <any>null;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(WorldPayCheckoutSessionLineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorldPayCheckoutSessionQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorldPayCheckoutSessionQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["description"] = this.description;
        data["isAvailable"] = this.isAvailable;
        data["merchantId"] = this.merchantId;
        data["booking"] = this.booking ? this.booking.toJSON() : this.booking;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWorldPayCheckoutSessionQueryResponse {
    sessionGuid?: string;
    amount?: number;
    currency?: string | null;
    description?: string | null;
    isAvailable?: boolean;
    merchantId?: string | null;
    booking?: WorldPayBookingCheckoutSessionResponse;
    lineItems?: WorldPayCheckoutSessionLineItem[] | null;
}

export class GetWorldPayCustomerIdQueryResult implements IGetWorldPayCustomerIdQueryResult {
    worldPayCustomerId?: string | null;

    constructor(data?: IGetWorldPayCustomerIdQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worldPayCustomerId = _data["worldPayCustomerId"];
        }
    }

    static fromJS(data: any): GetWorldPayCustomerIdQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorldPayCustomerIdQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worldPayCustomerId"] = this.worldPayCustomerId;
        return data;
    }
}

export interface IGetWorldPayCustomerIdQueryResult {
    worldPayCustomerId?: string | null;
}

export class WorldPayBookingCheckoutSessionResponse implements IWorldPayBookingCheckoutSessionResponse {
    start?: Date;
    end?: Date;
    passengers?: number | null;
    listingTitle?: string | null;
    contactPhone?: string | null;

    constructor(data?: IWorldPayBookingCheckoutSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
            this.passengers = _data["passengers"];
            this.listingTitle = _data["listingTitle"];
            this.contactPhone = _data["contactPhone"];
        }
    }

    static fromJS(data: any): WorldPayBookingCheckoutSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorldPayBookingCheckoutSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start && this.start.toISOString();
        data["end"] = this.end && this.end.toISOString();
        data["passengers"] = this.passengers;
        data["listingTitle"] = this.listingTitle;
        data["contactPhone"] = this.contactPhone;
        return data;
    }
}

export interface IWorldPayBookingCheckoutSessionResponse {
    start?: Date;
    end?: Date;
    passengers?: number | null;
    listingTitle?: string | null;
    contactPhone?: string | null;
}

export class CurrencyFormatResult implements ICurrencyFormatResult {
    code!: string | null;
    symbol!: string | null;
    locale!: string | null;
    decimalPlaces!: number;
    symbolPosition!: string | null;

    constructor(data?: ICurrencyFormatResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.symbol = _data["symbol"];
            this.locale = _data["locale"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.symbolPosition = _data["symbolPosition"];
        }
    }

    static fromJS(data: any): CurrencyFormatResult {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyFormatResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["symbol"] = this.symbol;
        data["locale"] = this.locale;
        data["decimalPlaces"] = this.decimalPlaces;
        data["symbolPosition"] = this.symbolPosition;
        return data;
    }
}

export interface ICurrencyFormatResult {
    code: string | null;
    symbol: string | null;
    locale: string | null;
    decimalPlaces: number;
    symbolPosition: string | null;
}

export class DateFormatResult implements IDateFormatResult {
    pattern!: string | null;
    locale!: string | null;
    separator!: string | null;

    constructor(data?: IDateFormatResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pattern = _data["pattern"];
            this.locale = _data["locale"];
            this.separator = _data["separator"];
        }
    }

    static fromJS(data: any): DateFormatResult {
        data = typeof data === 'object' ? data : {};
        let result = new DateFormatResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pattern"] = this.pattern;
        data["locale"] = this.locale;
        data["separator"] = this.separator;
        return data;
    }
}

export interface IDateFormatResult {
    pattern: string | null;
    locale: string | null;
    separator: string | null;
}

export class GetPlatformAccountPaymentGatewayQueryResult implements IGetPlatformAccountPaymentGatewayQueryResult {
    paymentGateway?: PaymentGateway;
    stripeConnectedAccountId?: string | null;

    constructor(data?: IGetPlatformAccountPaymentGatewayQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGateway = _data["paymentGateway"];
            this.stripeConnectedAccountId = _data["stripeConnectedAccountId"];
        }
    }

    static fromJS(data: any): GetPlatformAccountPaymentGatewayQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlatformAccountPaymentGatewayQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGateway"] = this.paymentGateway;
        data["stripeConnectedAccountId"] = this.stripeConnectedAccountId;
        return data;
    }
}

export interface IGetPlatformAccountPaymentGatewayQueryResult {
    paymentGateway?: PaymentGateway;
    stripeConnectedAccountId?: string | null;
}

export class GetPlatformAccountSettingsQueryResult implements IGetPlatformAccountSettingsQueryResult {
    name?: string | null;
    settings?: PlatformAccountSettings;
    measurementSystem?: MeasurementSystem;
    conversionTrackingEnabled?: boolean;
    locale?: LocaleSettingsResult;
    phone?: string | null;
    hasTwilioNumber?: boolean;

    constructor(data?: IGetPlatformAccountSettingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.settings = _data["settings"] ? PlatformAccountSettings.fromJS(_data["settings"]) : <any>null;
            this.measurementSystem = _data["measurementSystem"];
            this.conversionTrackingEnabled = _data["conversionTrackingEnabled"];
            this.locale = _data["locale"] ? LocaleSettingsResult.fromJS(_data["locale"]) : <any>null;
            this.phone = _data["phone"];
            this.hasTwilioNumber = _data["hasTwilioNumber"];
        }
    }

    static fromJS(data: any): GetPlatformAccountSettingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlatformAccountSettingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["settings"] = this.settings ? this.settings.toJSON() : this.settings;
        data["measurementSystem"] = this.measurementSystem;
        data["conversionTrackingEnabled"] = this.conversionTrackingEnabled;
        data["locale"] = this.locale ? this.locale.toJSON() : this.locale;
        data["phone"] = this.phone;
        data["hasTwilioNumber"] = this.hasTwilioNumber;
        return data;
    }
}

export interface IGetPlatformAccountSettingsQueryResult {
    name?: string | null;
    settings?: PlatformAccountSettings;
    measurementSystem?: MeasurementSystem;
    conversionTrackingEnabled?: boolean;
    locale?: LocaleSettingsResult;
    phone?: string | null;
    hasTwilioNumber?: boolean;
}

export class LocaleSettingsResult implements ILocaleSettingsResult {
    culture!: string | null;
    country!: string | null;
    language!: string | null;
    timeZoneInfoId!: string | null;
    measurementSystem!: MeasurementSystem;
    dateFormat!: DateFormatResult;
    timeFormat!: TimeFormatResult;
    currencyFormat!: CurrencyFormatResult;
    measurementUnits!: MeasurementUnitsResult;
    weekStartDay!: DayOfWeek;

    constructor(data?: ILocaleSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dateFormat = new DateFormatResult();
            this.timeFormat = new TimeFormatResult();
            this.currencyFormat = new CurrencyFormatResult();
            this.measurementUnits = new MeasurementUnitsResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.culture = _data["culture"];
            this.country = _data["country"];
            this.language = _data["language"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.measurementSystem = _data["measurementSystem"];
            this.dateFormat = _data["dateFormat"] ? DateFormatResult.fromJS(_data["dateFormat"]) : new DateFormatResult();
            this.timeFormat = _data["timeFormat"] ? TimeFormatResult.fromJS(_data["timeFormat"]) : new TimeFormatResult();
            this.currencyFormat = _data["currencyFormat"] ? CurrencyFormatResult.fromJS(_data["currencyFormat"]) : new CurrencyFormatResult();
            this.measurementUnits = _data["measurementUnits"] ? MeasurementUnitsResult.fromJS(_data["measurementUnits"]) : new MeasurementUnitsResult();
            this.weekStartDay = _data["weekStartDay"];
        }
    }

    static fromJS(data: any): LocaleSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new LocaleSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["culture"] = this.culture;
        data["country"] = this.country;
        data["language"] = this.language;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["measurementSystem"] = this.measurementSystem;
        data["dateFormat"] = this.dateFormat ? this.dateFormat.toJSON() : this.dateFormat;
        data["timeFormat"] = this.timeFormat ? this.timeFormat.toJSON() : this.timeFormat;
        data["currencyFormat"] = this.currencyFormat ? this.currencyFormat.toJSON() : this.currencyFormat;
        data["measurementUnits"] = this.measurementUnits ? this.measurementUnits.toJSON() : this.measurementUnits;
        data["weekStartDay"] = this.weekStartDay;
        return data;
    }
}

export interface ILocaleSettingsResult {
    culture: string | null;
    country: string | null;
    language: string | null;
    timeZoneInfoId: string | null;
    measurementSystem: MeasurementSystem;
    dateFormat: DateFormatResult;
    timeFormat: TimeFormatResult;
    currencyFormat: CurrencyFormatResult;
    measurementUnits: MeasurementUnitsResult;
    weekStartDay: DayOfWeek;
}

export class MeasurementUnitsResult implements IMeasurementUnitsResult {
    lengthUnit!: string | null;
    volumeUnit!: string | null;
    fuelConsumptionUnit!: string | null;
    distanceUnit!: string | null;
    speedUnit!: string | null;
    cabinLabel!: string | null;

    constructor(data?: IMeasurementUnitsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lengthUnit = _data["lengthUnit"];
            this.volumeUnit = _data["volumeUnit"];
            this.fuelConsumptionUnit = _data["fuelConsumptionUnit"];
            this.distanceUnit = _data["distanceUnit"];
            this.speedUnit = _data["speedUnit"];
            this.cabinLabel = _data["cabinLabel"];
        }
    }

    static fromJS(data: any): MeasurementUnitsResult {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementUnitsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lengthUnit"] = this.lengthUnit;
        data["volumeUnit"] = this.volumeUnit;
        data["fuelConsumptionUnit"] = this.fuelConsumptionUnit;
        data["distanceUnit"] = this.distanceUnit;
        data["speedUnit"] = this.speedUnit;
        data["cabinLabel"] = this.cabinLabel;
        return data;
    }
}

export interface IMeasurementUnitsResult {
    lengthUnit: string | null;
    volumeUnit: string | null;
    fuelConsumptionUnit: string | null;
    distanceUnit: string | null;
    speedUnit: string | null;
    cabinLabel: string | null;
}

export class TimeFormatResult implements ITimeFormatResult {
    pattern!: string | null;
    use12Hour!: boolean;
    showPeriod!: boolean;
    showLeadingZero!: boolean;

    constructor(data?: ITimeFormatResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pattern = _data["pattern"];
            this.use12Hour = _data["use12Hour"];
            this.showPeriod = _data["showPeriod"];
            this.showLeadingZero = _data["showLeadingZero"];
        }
    }

    static fromJS(data: any): TimeFormatResult {
        data = typeof data === 'object' ? data : {};
        let result = new TimeFormatResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pattern"] = this.pattern;
        data["use12Hour"] = this.use12Hour;
        data["showPeriod"] = this.showPeriod;
        data["showLeadingZero"] = this.showLeadingZero;
        return data;
    }
}

export interface ITimeFormatResult {
    pattern: string | null;
    use12Hour: boolean;
    showPeriod: boolean;
    showLeadingZero: boolean;
}

export class GetMarketplaceCalculatedPriceQueryResult implements IGetMarketplaceCalculatedPriceQueryResult {
    packageName?: string | null;
    items?: PricingLineItem[] | null;
    readonly totalPrice?: number;
    readonly totalPriceWithoutOnlineCustomerFee?: number;
    prePayment?: PrePaymentInfo;

    constructor(data?: IGetMarketplaceCalculatedPriceQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageName = _data["packageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PricingLineItem.fromJS(item));
            }
            (<any>this).totalPrice = _data["totalPrice"];
            (<any>this).totalPriceWithoutOnlineCustomerFee = _data["totalPriceWithoutOnlineCustomerFee"];
            this.prePayment = _data["prePayment"] ? PrePaymentInfo.fromJS(_data["prePayment"]) : <any>null;
        }
    }

    static fromJS(data: any): GetMarketplaceCalculatedPriceQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceCalculatedPriceQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageName"] = this.packageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        data["totalPriceWithoutOnlineCustomerFee"] = this.totalPriceWithoutOnlineCustomerFee;
        data["prePayment"] = this.prePayment ? this.prePayment.toJSON() : this.prePayment;
        return data;
    }
}

export interface IGetMarketplaceCalculatedPriceQueryResult {
    packageName?: string | null;
    items?: PricingLineItem[] | null;
    totalPrice?: number;
    totalPriceWithoutOnlineCustomerFee?: number;
    prePayment?: PrePaymentInfo;
}

export class GetMarketplaceCalendarCalculatedPriceQueryResult implements IGetMarketplaceCalendarCalculatedPriceQueryResult {
    listingTitle?: string | null;
    items?: PricingLineItem[] | null;
    chargeableDaysCount?: number;
    readonly totalPrice?: number;
    readonly totalPriceWithoutOnlineCustomerFee?: number;
    prePayment?: PrePaymentInfo;

    constructor(data?: IGetMarketplaceCalendarCalculatedPriceQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingTitle = _data["listingTitle"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PricingLineItem.fromJS(item));
            }
            this.chargeableDaysCount = _data["chargeableDaysCount"];
            (<any>this).totalPrice = _data["totalPrice"];
            (<any>this).totalPriceWithoutOnlineCustomerFee = _data["totalPriceWithoutOnlineCustomerFee"];
            this.prePayment = _data["prePayment"] ? PrePaymentInfo.fromJS(_data["prePayment"]) : <any>null;
        }
    }

    static fromJS(data: any): GetMarketplaceCalendarCalculatedPriceQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceCalendarCalculatedPriceQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingTitle"] = this.listingTitle;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["chargeableDaysCount"] = this.chargeableDaysCount;
        data["totalPrice"] = this.totalPrice;
        data["totalPriceWithoutOnlineCustomerFee"] = this.totalPriceWithoutOnlineCustomerFee;
        data["prePayment"] = this.prePayment ? this.prePayment.toJSON() : this.prePayment;
        return data;
    }
}

export interface IGetMarketplaceCalendarCalculatedPriceQueryResult {
    listingTitle?: string | null;
    items?: PricingLineItem[] | null;
    chargeableDaysCount?: number;
    totalPrice?: number;
    totalPriceWithoutOnlineCustomerFee?: number;
    prePayment?: PrePaymentInfo;
}

export class SubmitSalesLeadCommand implements ISubmitSalesLeadCommand {
    platformAccountGuid!: string;
    marketGuid!: string;
    firstName!: string | null;
    middleName?: string | null;
    lastName!: string | null;
    email!: string | null;
    phone?: string | null;
    numberOfGuests?: number | null;
    budget?: number | null;
    departureDate?: Date | null;
    boatGuid?: string | null;
    message?: string | null;
    source?: string | null;
    acceptedContactConsent!: boolean;
    acceptedSmsConsent?: boolean | null;
    captchaToken!: string | null;

    constructor(data?: ISubmitSalesLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platformAccountGuid = _data["platformAccountGuid"];
            this.marketGuid = _data["marketGuid"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.numberOfGuests = _data["numberOfGuests"];
            this.budget = _data["budget"];
            this.departureDate = _data["departureDate"] ? parseDateOnly(_data["departureDate"].toString()) : <any>null;
            this.boatGuid = _data["boatGuid"];
            this.message = _data["message"];
            this.source = _data["source"];
            this.acceptedContactConsent = _data["acceptedContactConsent"];
            this.acceptedSmsConsent = _data["acceptedSmsConsent"];
            this.captchaToken = _data["captchaToken"];
        }
    }

    static fromJS(data: any): SubmitSalesLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitSalesLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platformAccountGuid"] = this.platformAccountGuid;
        data["marketGuid"] = this.marketGuid;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["numberOfGuests"] = this.numberOfGuests;
        data["budget"] = this.budget;
        data["departureDate"] = this.departureDate && formatDate(this.departureDate);
        data["boatGuid"] = this.boatGuid;
        data["message"] = this.message;
        data["source"] = this.source;
        data["acceptedContactConsent"] = this.acceptedContactConsent;
        data["acceptedSmsConsent"] = this.acceptedSmsConsent;
        data["captchaToken"] = this.captchaToken;
        return data;
    }
}

export interface ISubmitSalesLeadCommand {
    platformAccountGuid: string;
    marketGuid: string;
    firstName: string | null;
    middleName?: string | null;
    lastName: string | null;
    email: string | null;
    phone?: string | null;
    numberOfGuests?: number | null;
    budget?: number | null;
    departureDate?: Date | null;
    boatGuid?: string | null;
    message?: string | null;
    source?: string | null;
    acceptedContactConsent: boolean;
    acceptedSmsConsent?: boolean | null;
    captchaToken: string | null;
}

export class UpdateSalesLeadSuperchatDetailsCommand implements IUpdateSalesLeadSuperchatDetailsCommand {
    superchatUrl?: string | null;
    externalOfferUrl?: string | null;

    constructor(data?: IUpdateSalesLeadSuperchatDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.superchatUrl = _data["superchatUrl"];
            this.externalOfferUrl = _data["externalOfferUrl"];
        }
    }

    static fromJS(data: any): UpdateSalesLeadSuperchatDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSalesLeadSuperchatDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["superchatUrl"] = this.superchatUrl;
        data["externalOfferUrl"] = this.externalOfferUrl;
        return data;
    }
}

export interface IUpdateSalesLeadSuperchatDetailsCommand {
    superchatUrl?: string | null;
    externalOfferUrl?: string | null;
}

export class InstantResult implements IInstantResult {
    utcDateTime!: Date;
    localDateTime!: Date;
    timeZoneInfoId!: string | null;

    constructor(data?: IInstantResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utcDateTime = _data["utcDateTime"] ? new Date(_data["utcDateTime"].toString()) : <any>null;
            this.localDateTime = _data["localDateTime"] ? new Date(_data["localDateTime"].toString()) : <any>null;
            this.timeZoneInfoId = _data["timeZoneInfoId"];
        }
    }

    static fromJS(data: any): InstantResult {
        data = typeof data === 'object' ? data : {};
        let result = new InstantResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utcDateTime"] = this.utcDateTime && this.utcDateTime.toISOString();
        data["localDateTime"] = this.localDateTime && this.localDateTime.toISOString();
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        return data;
    }
}

export interface IInstantResult {
    utcDateTime: Date;
    localDateTime: Date;
    timeZoneInfoId: string | null;
}

export class LocationResult implements ILocationResult {
    guid!: string;
    title!: string | null;
    city!: string | null;
    fullAddress!: string | null;
    shortAddress!: string | null;
    timeZoneInfoId!: string | null;
    marketGuid!: string;
    marketCode!: string | null;
    marketTitle!: string | null;

    constructor(data?: ILocationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.city = _data["city"];
            this.fullAddress = _data["fullAddress"];
            this.shortAddress = _data["shortAddress"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.marketGuid = _data["marketGuid"];
            this.marketCode = _data["marketCode"];
            this.marketTitle = _data["marketTitle"];
        }
    }

    static fromJS(data: any): LocationResult {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["city"] = this.city;
        data["fullAddress"] = this.fullAddress;
        data["shortAddress"] = this.shortAddress;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["marketGuid"] = this.marketGuid;
        data["marketCode"] = this.marketCode;
        data["marketTitle"] = this.marketTitle;
        return data;
    }
}

export interface ILocationResult {
    guid: string;
    title: string | null;
    city: string | null;
    fullAddress: string | null;
    shortAddress: string | null;
    timeZoneInfoId: string | null;
    marketGuid: string;
    marketCode: string | null;
    marketTitle: string | null;
}

export class MarketResult implements IMarketResult {
    guid!: string;
    code!: string | null;
    title!: string | null;

    constructor(data?: IMarketResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.code = _data["code"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MarketResult {
        data = typeof data === 'object' ? data : {};
        let result = new MarketResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["title"] = this.title;
        return data;
    }
}

export interface IMarketResult {
    guid: string;
    code: string | null;
    title: string | null;
}

export class UserResult implements IUserResult {
    guid!: string;
    userGuid!: string;
    firstName!: string | null;
    lastName!: string | null;
    middleName!: string | null;
    readonly fullName?: string | null;
    email!: string | null;
    phone!: string | null;

    constructor(data?: IUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.userGuid = _data["userGuid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            (<any>this).fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): UserResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["userGuid"] = this.userGuid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IUserResult {
    guid: string;
    userGuid: string;
    firstName: string | null;
    lastName: string | null;
    middleName: string | null;
    fullName?: string | null;
    email: string | null;
    phone: string | null;
}

export class PricedAmount implements IPricedAmount {
    netAmount?: number;
    taxes?: TaxLine[] | null;
    grossAmount?: number;
    readonly totalTaxAmount?: number;

    constructor(data?: IPricedAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.netAmount = _data["netAmount"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxLine.fromJS(item));
            }
            this.grossAmount = _data["grossAmount"];
            (<any>this).totalTaxAmount = _data["totalTaxAmount"];
        }
    }

    static fromJS(data: any): PricedAmount {
        data = typeof data === 'object' ? data : {};
        let result = new PricedAmount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netAmount"] = this.netAmount;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        data["grossAmount"] = this.grossAmount;
        data["totalTaxAmount"] = this.totalTaxAmount;
        return data;
    }
}

export interface IPricedAmount {
    netAmount?: number;
    taxes?: TaxLine[] | null;
    grossAmount?: number;
    totalTaxAmount?: number;
}

export class TaxLine implements ITaxLine {
    name?: string | null;
    ratePercentage?: number;
    amount?: number;
    includedInPrice?: boolean;

    constructor(data?: ITaxLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ratePercentage = _data["ratePercentage"];
            this.amount = _data["amount"];
            this.includedInPrice = _data["includedInPrice"];
        }
    }

    static fromJS(data: any): TaxLine {
        data = typeof data === 'object' ? data : {};
        let result = new TaxLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ratePercentage"] = this.ratePercentage;
        data["amount"] = this.amount;
        data["includedInPrice"] = this.includedInPrice;
        return data;
    }
}

export interface ITaxLine {
    name?: string | null;
    ratePercentage?: number;
    amount?: number;
    includedInPrice?: boolean;
}

export class PictureResultModel implements IPictureResultModel {
    readonly pictureGuid?: string | null;
    readonly host?: string | null;
    bucket?: string | null;
    readonly name?: string | null;
    readonly extension?: string | null;
    readonly description?: string | null;
    readonly height?: number | null;
    readonly width?: number | null;
    readonly size?: number | null;

    constructor(data?: IPictureResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).pictureGuid = _data["pictureGuid"];
            (<any>this).host = _data["host"];
            this.bucket = _data["bucket"];
            (<any>this).name = _data["name"];
            (<any>this).extension = _data["extension"];
            (<any>this).description = _data["description"];
            (<any>this).height = _data["height"];
            (<any>this).width = _data["width"];
            (<any>this).size = _data["size"];
        }
    }

    static fromJS(data: any): PictureResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new PictureResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureGuid"] = this.pictureGuid;
        data["host"] = this.host;
        data["bucket"] = this.bucket;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["description"] = this.description;
        data["height"] = this.height;
        data["width"] = this.width;
        data["size"] = this.size;
        return data;
    }
}

export interface IPictureResultModel {
    pictureGuid?: string | null;
    host?: string | null;
    bucket?: string | null;
    name?: string | null;
    extension?: string | null;
    description?: string | null;
    height?: number | null;
    width?: number | null;
    size?: number | null;
}

export class ExternalPaymentInfo implements IExternalPaymentInfo {
    methodGuid?: string;
    methodCode?: string | null;

    constructor(data?: IExternalPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.methodGuid = _data["methodGuid"];
            this.methodCode = _data["methodCode"];
        }
    }

    static fromJS(data: any): ExternalPaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalPaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methodGuid"] = this.methodGuid;
        data["methodCode"] = this.methodCode;
        return data;
    }
}

export interface IExternalPaymentInfo {
    methodGuid?: string;
    methodCode?: string | null;
}

export class AuthorizeNetCheckoutSessionLineItem implements IAuthorizeNetCheckoutSessionLineItem {
    readonly guid?: string;
    name?: string | null;
    unitPrice?: number;
    quantity?: number;
    readonly totalPrice?: number;

    constructor(data?: IAuthorizeNetCheckoutSessionLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            (<any>this).totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): AuthorizeNetCheckoutSessionLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetCheckoutSessionLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IAuthorizeNetCheckoutSessionLineItem {
    guid?: string;
    name?: string | null;
    unitPrice?: number;
    quantity?: number;
    totalPrice?: number;
}

export class AuthorizeNetPaymentInfo implements IAuthorizeNetPaymentInfo {
    readonly guid?: string;
    readonly transactionId?: string | null;
    readonly customerProfileId?: string | null;
    readonly checkoutSessionGuid?: string | null;
    readonly checkoutSessionUrl?: string | null;
    readonly authorizationCode?: string | null;
    transactionStatus?: AuthorizeNetTransactionStatus;
    readonly errorCode?: string | null;
    readonly errorMessage?: string | null;
    paymentProcessorCost?: number | null;
    paymentProfileInfo?: AuthorizeNetPaymentProfileInfo;

    constructor(data?: IAuthorizeNetPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).transactionId = _data["transactionId"];
            (<any>this).customerProfileId = _data["customerProfileId"];
            (<any>this).checkoutSessionGuid = _data["checkoutSessionGuid"];
            (<any>this).checkoutSessionUrl = _data["checkoutSessionUrl"];
            (<any>this).authorizationCode = _data["authorizationCode"];
            this.transactionStatus = _data["transactionStatus"];
            (<any>this).errorCode = _data["errorCode"];
            (<any>this).errorMessage = _data["errorMessage"];
            this.paymentProcessorCost = _data["paymentProcessorCost"];
            this.paymentProfileInfo = _data["paymentProfileInfo"] ? AuthorizeNetPaymentProfileInfo.fromJS(_data["paymentProfileInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): AuthorizeNetPaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetPaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["transactionId"] = this.transactionId;
        data["customerProfileId"] = this.customerProfileId;
        data["checkoutSessionGuid"] = this.checkoutSessionGuid;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["authorizationCode"] = this.authorizationCode;
        data["transactionStatus"] = this.transactionStatus;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["paymentProcessorCost"] = this.paymentProcessorCost;
        data["paymentProfileInfo"] = this.paymentProfileInfo ? this.paymentProfileInfo.toJSON() : this.paymentProfileInfo;
        return data;
    }
}

export interface IAuthorizeNetPaymentInfo {
    guid?: string;
    transactionId?: string | null;
    customerProfileId?: string | null;
    checkoutSessionGuid?: string | null;
    checkoutSessionUrl?: string | null;
    authorizationCode?: string | null;
    transactionStatus?: AuthorizeNetTransactionStatus;
    errorCode?: string | null;
    errorMessage?: string | null;
    paymentProcessorCost?: number | null;
    paymentProfileInfo?: AuthorizeNetPaymentProfileInfo;
}

export enum AuthorizeNetPaymentMethodType {
    NotSet = "NotSet",
    CreditCard = "CreditCard",
    BankAccount = "BankAccount",
}

export class AuthorizeNetPaymentProfileInfo implements IAuthorizeNetPaymentProfileInfo {
    paymentProfileId?: string | null;
    maskedCardNumber?: string | null;
    expirationDate?: Date | null;
    cardType?: string | null;
    maskedAccountNumber?: string | null;
    maskedRoutingNumber?: string | null;
    bankName?: string | null;
    paymentMethod?: AuthorizeNetPaymentMethodType;

    constructor(data?: IAuthorizeNetPaymentProfileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfileId = _data["paymentProfileId"];
            this.maskedCardNumber = _data["maskedCardNumber"];
            this.expirationDate = _data["expirationDate"] ? parseDateOnly(_data["expirationDate"].toString()) : <any>null;
            this.cardType = _data["cardType"];
            this.maskedAccountNumber = _data["maskedAccountNumber"];
            this.maskedRoutingNumber = _data["maskedRoutingNumber"];
            this.bankName = _data["bankName"];
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): AuthorizeNetPaymentProfileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetPaymentProfileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfileId"] = this.paymentProfileId;
        data["maskedCardNumber"] = this.maskedCardNumber;
        data["expirationDate"] = this.expirationDate && formatDate(this.expirationDate);
        data["cardType"] = this.cardType;
        data["maskedAccountNumber"] = this.maskedAccountNumber;
        data["maskedRoutingNumber"] = this.maskedRoutingNumber;
        data["bankName"] = this.bankName;
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }
}

export interface IAuthorizeNetPaymentProfileInfo {
    paymentProfileId?: string | null;
    maskedCardNumber?: string | null;
    expirationDate?: Date | null;
    cardType?: string | null;
    maskedAccountNumber?: string | null;
    maskedRoutingNumber?: string | null;
    bankName?: string | null;
    paymentMethod?: AuthorizeNetPaymentMethodType;
}

export enum AuthorizeNetTransactionStatus {
    Unknown = "Unknown",
    ApprovedReview = "ApprovedReview",
    AuthorizedHeldPendingRelease = "AuthorizedHeldPendingRelease",
    AuthorizedPendingCapture = "AuthorizedPendingCapture",
    CapturedPendingSettlement = "CapturedPendingSettlement",
    CouldNotVoid = "CouldNotVoid",
    Declined = "Declined",
    Expired = "Expired",
    FailedReview = "FailedReview",
    FDSAuthorizedPendingReview = "FDSAuthorizedPendingReview",
    FDSPendingReview = "FDSPendingReview",
    PendingFinalSettlement = "PendingFinalSettlement",
    PendingSettlement = "PendingSettlement",
    Refund = "Refund",
    RefundPendingSettlement = "RefundPendingSettlement",
    SettledSuccessfully = "SettledSuccessfully",
    SettlementError = "SettlementError",
    UnderReview = "UnderReview",
    Voided = "Voided",
}

export class BankAccountPaymentRequest implements IBankAccountPaymentRequest {
    opaqueDataValue!: string | null;
    opaqueDataDescriptor!: string | null;
    routingNumberLastFourDigits!: string | null;
    accountNumberLastFourDigits!: string | null;
    nameOnAccount!: string | null;
    accountType!: BankAccountTypeEnum;

    constructor(data?: IBankAccountPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opaqueDataValue = _data["opaqueDataValue"];
            this.opaqueDataDescriptor = _data["opaqueDataDescriptor"];
            this.routingNumberLastFourDigits = _data["routingNumberLastFourDigits"];
            this.accountNumberLastFourDigits = _data["accountNumberLastFourDigits"];
            this.nameOnAccount = _data["nameOnAccount"];
            this.accountType = _data["accountType"];
        }
    }

    static fromJS(data: any): BankAccountPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opaqueDataValue"] = this.opaqueDataValue;
        data["opaqueDataDescriptor"] = this.opaqueDataDescriptor;
        data["routingNumberLastFourDigits"] = this.routingNumberLastFourDigits;
        data["accountNumberLastFourDigits"] = this.accountNumberLastFourDigits;
        data["nameOnAccount"] = this.nameOnAccount;
        data["accountType"] = this.accountType;
        return data;
    }
}

export interface IBankAccountPaymentRequest {
    opaqueDataValue: string | null;
    opaqueDataDescriptor: string | null;
    routingNumberLastFourDigits: string | null;
    accountNumberLastFourDigits: string | null;
    nameOnAccount: string | null;
    accountType: BankAccountTypeEnum;
}

export class CreditCardPaymentRequest implements ICreditCardPaymentRequest {
    cardHolderName!: string | null;
    opaqueDataValue!: string | null;
    opaqueDataDescriptor!: string | null;
    lastFourDigits!: string | null;
    expirationDate!: Date;

    constructor(data?: ICreditCardPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardHolderName = _data["cardHolderName"];
            this.opaqueDataValue = _data["opaqueDataValue"];
            this.opaqueDataDescriptor = _data["opaqueDataDescriptor"];
            this.lastFourDigits = _data["lastFourDigits"];
            this.expirationDate = _data["expirationDate"] ? parseDateOnly(_data["expirationDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CreditCardPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardHolderName"] = this.cardHolderName;
        data["opaqueDataValue"] = this.opaqueDataValue;
        data["opaqueDataDescriptor"] = this.opaqueDataDescriptor;
        data["lastFourDigits"] = this.lastFourDigits;
        data["expirationDate"] = this.expirationDate && formatDate(this.expirationDate);
        return data;
    }
}

export interface ICreditCardPaymentRequest {
    cardHolderName: string | null;
    opaqueDataValue: string | null;
    opaqueDataDescriptor: string | null;
    lastFourDigits: string | null;
    expirationDate: Date;
}

export enum PaymentMethodSource {
    Admin = "Admin",
    PublicApi = "PublicApi",
    CustomerPortal = "CustomerPortal",
}

export class WorldPayCheckoutSessionLineItem implements IWorldPayCheckoutSessionLineItem {
    readonly guid?: string;
    name?: string | null;
    unitPrice?: number;
    quantity?: number;
    totalPrice?: number;

    constructor(data?: IWorldPayCheckoutSessionLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): WorldPayCheckoutSessionLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new WorldPayCheckoutSessionLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IWorldPayCheckoutSessionLineItem {
    guid?: string;
    name?: string | null;
    unitPrice?: number;
    quantity?: number;
    totalPrice?: number;
}

export enum WorldPayTransactionStatus {
    Pending = "Pending",
    Approved = "Approved",
    Failed = "Failed",
    Captured = "Captured",
    Settled = "Settled",
    Returned = "Returned",
    Voided = "Voided",
    Unknown = "Unknown",
}

export class StripePaymentInfo implements IStripePaymentInfo {
    readonly guid?: string;
    readonly paymentIntentId?: string | null;
    readonly checkoutSessionId?: string | null;
    readonly paymentProcessorCost?: number | null;
    readonly availableOn?: Date | null;
    paymentMethod?: StripePaymentMethodInfo;

    constructor(data?: IStripePaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).paymentIntentId = _data["paymentIntentId"];
            (<any>this).checkoutSessionId = _data["checkoutSessionId"];
            (<any>this).paymentProcessorCost = _data["paymentProcessorCost"];
            (<any>this).availableOn = _data["availableOn"] ? new Date(_data["availableOn"].toString()) : <any>null;
            this.paymentMethod = _data["paymentMethod"] ? StripePaymentMethodInfo.fromJS(_data["paymentMethod"]) : <any>null;
        }
    }

    static fromJS(data: any): StripePaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["paymentIntentId"] = this.paymentIntentId;
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["paymentProcessorCost"] = this.paymentProcessorCost;
        data["availableOn"] = this.availableOn && this.availableOn.toISOString();
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : this.paymentMethod;
        return data;
    }
}

export interface IStripePaymentInfo {
    guid?: string;
    paymentIntentId?: string | null;
    checkoutSessionId?: string | null;
    paymentProcessorCost?: number | null;
    availableOn?: Date | null;
    paymentMethod?: StripePaymentMethodInfo;
}

export class StripePaymentMethodInfo implements IStripePaymentMethodInfo {
    paymentMethodId!: string | null;
    cardLast4?: string | null;
    cardBrand?: string | null;
    cardExpMonth?: number | null;
    cardExpYear?: number | null;
    type!: string | null;

    constructor(data?: IStripePaymentMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodId = _data["paymentMethodId"];
            this.cardLast4 = _data["cardLast4"];
            this.cardBrand = _data["cardBrand"];
            this.cardExpMonth = _data["cardExpMonth"];
            this.cardExpYear = _data["cardExpYear"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): StripePaymentMethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentMethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodId"] = this.paymentMethodId;
        data["cardLast4"] = this.cardLast4;
        data["cardBrand"] = this.cardBrand;
        data["cardExpMonth"] = this.cardExpMonth;
        data["cardExpYear"] = this.cardExpYear;
        data["type"] = this.type;
        return data;
    }
}

export interface IStripePaymentMethodInfo {
    paymentMethodId: string | null;
    cardLast4?: string | null;
    cardBrand?: string | null;
    cardExpMonth?: number | null;
    cardExpYear?: number | null;
    type: string | null;
}

export enum BoatOwnerType {
    NotSet = "NotSet",
    Internal = "Internal",
    External = "External",
}

export class BoatSpecification implements IBoatSpecification {
    yearBuilt?: number | null;
    yearRefit?: number | null;
    length?: number | null;
    engineType?: EngineType;
    fuelCapacity?: number | null;
    fuelConsumption?: number | null;
    sleepCapacity?: number | null;
    passengersCapacity?: number;
    crewCapacity?: number | null;
    dayCapacity?: number | null;
    dayCapacityDescription?: string | null;
    bedCount?: number | null;
    bathroomsCount?: number | null;
    stateroomsCount?: number | null;
    stateroomsDescription?: string | null;
    portOfRegistry?: string | null;
    flag?: string | null;
    includedToys?: string | null;

    constructor(data?: IBoatSpecification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.yearBuilt = _data["yearBuilt"];
            this.yearRefit = _data["yearRefit"];
            this.length = _data["length"];
            this.engineType = _data["engineType"];
            this.fuelCapacity = _data["fuelCapacity"];
            this.fuelConsumption = _data["fuelConsumption"];
            this.sleepCapacity = _data["sleepCapacity"];
            this.passengersCapacity = _data["passengersCapacity"];
            this.crewCapacity = _data["crewCapacity"];
            this.dayCapacity = _data["dayCapacity"];
            this.dayCapacityDescription = _data["dayCapacityDescription"];
            this.bedCount = _data["bedCount"];
            this.bathroomsCount = _data["bathroomsCount"];
            this.stateroomsCount = _data["stateroomsCount"];
            this.stateroomsDescription = _data["stateroomsDescription"];
            this.portOfRegistry = _data["portOfRegistry"];
            this.flag = _data["flag"];
            this.includedToys = _data["includedToys"];
        }
    }

    static fromJS(data: any): BoatSpecification {
        data = typeof data === 'object' ? data : {};
        let result = new BoatSpecification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yearBuilt"] = this.yearBuilt;
        data["yearRefit"] = this.yearRefit;
        data["length"] = this.length;
        data["engineType"] = this.engineType;
        data["fuelCapacity"] = this.fuelCapacity;
        data["fuelConsumption"] = this.fuelConsumption;
        data["sleepCapacity"] = this.sleepCapacity;
        data["passengersCapacity"] = this.passengersCapacity;
        data["crewCapacity"] = this.crewCapacity;
        data["dayCapacity"] = this.dayCapacity;
        data["dayCapacityDescription"] = this.dayCapacityDescription;
        data["bedCount"] = this.bedCount;
        data["bathroomsCount"] = this.bathroomsCount;
        data["stateroomsCount"] = this.stateroomsCount;
        data["stateroomsDescription"] = this.stateroomsDescription;
        data["portOfRegistry"] = this.portOfRegistry;
        data["flag"] = this.flag;
        data["includedToys"] = this.includedToys;
        return data;
    }
}

export interface IBoatSpecification {
    yearBuilt?: number | null;
    yearRefit?: number | null;
    length?: number | null;
    engineType?: EngineType;
    fuelCapacity?: number | null;
    fuelConsumption?: number | null;
    sleepCapacity?: number | null;
    passengersCapacity?: number;
    crewCapacity?: number | null;
    dayCapacity?: number | null;
    dayCapacityDescription?: string | null;
    bedCount?: number | null;
    bathroomsCount?: number | null;
    stateroomsCount?: number | null;
    stateroomsDescription?: string | null;
    portOfRegistry?: string | null;
    flag?: string | null;
    includedToys?: string | null;
}

export enum EngineType {
    Diesel = "Diesel",
    Gasoline = "Gasoline",
    Electric = "Electric",
    Hybrid = "Hybrid",
}

export enum CalendarDayAvailability {
    NotSet = "NotSet",
    Available = "Available",
    PartiallyAvailable = "PartiallyAvailable",
    SoldOut = "SoldOut",
}

export class PricingAdditionalFeeItem implements IPricingAdditionalFeeItem {
    readonly guid?: string;
    code?: string | null;
    name?: string | null;
    price?: PricedAmount;
    readonly amount?: number;
    taxes?: TaxLine[] | null;

    constructor(data?: IPricingAdditionalFeeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.price = _data["price"] ? PricedAmount.fromJS(_data["price"]) : <any>null;
            (<any>this).amount = _data["amount"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricingAdditionalFeeItem {
        data = typeof data === 'object' ? data : {};
        let result = new PricingAdditionalFeeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["price"] = this.price ? this.price.toJSON() : this.price;
        data["amount"] = this.amount;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPricingAdditionalFeeItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
    price?: PricedAmount;
    amount?: number;
    taxes?: TaxLine[] | null;
}

export class PricingLineItem implements IPricingLineItem {
    name?: string | null;
    price?: number;
    type?: PricingLineItemType;
    feeGuid?: string | null;
    taxes?: TaxLine[] | null;

    constructor(data?: IPricingLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.type = _data["type"];
            this.feeGuid = _data["feeGuid"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricingLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new PricingLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["type"] = this.type;
        data["feeGuid"] = this.feeGuid;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPricingLineItem {
    name?: string | null;
    price?: number;
    type?: PricingLineItemType;
    feeGuid?: string | null;
    taxes?: TaxLine[] | null;
}

export enum PricingLineItemType {
    RentalPrice = "RentalPrice",
    AdditionalFee = "AdditionalFee",
    PromoCodeDiscount = "PromoCodeDiscount",
    CampaignDiscount = "CampaignDiscount",
    ProcessingFee = "ProcessingFee",
}

export class BookingAdditionalFeeItem implements IBookingAdditionalFeeItem {
    readonly guid?: string;
    code?: string | null;
    name?: string | null;
    price?: PricedAmount;
    readonly amount?: number;

    constructor(data?: IBookingAdditionalFeeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.price = _data["price"] ? PricedAmount.fromJS(_data["price"]) : <any>null;
            (<any>this).amount = _data["amount"];
        }
    }

    static fromJS(data: any): BookingAdditionalFeeItem {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAdditionalFeeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["price"] = this.price ? this.price.toJSON() : this.price;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IBookingAdditionalFeeItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
    price?: PricedAmount;
    amount?: number;
}

export class BookingAdditionalFees implements IBookingAdditionalFees {
    readonly items?: BookingAdditionalFeeItem[] | null;
    readonly totalPrice?: number;

    constructor(data?: IBookingAdditionalFees) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(BookingAdditionalFeeItem.fromJS(item));
            }
            (<any>this).totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): BookingAdditionalFees {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAdditionalFees();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IBookingAdditionalFees {
    items?: BookingAdditionalFeeItem[] | null;
    totalPrice?: number;
}

export class BookingAgent implements IBookingAgent {
    readonly guid?: string;
    readonly name?: string | null;
    readonly group?: string | null;
    readonly commissionPercent?: number;

    constructor(data?: IBookingAgent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).name = _data["name"];
            (<any>this).group = _data["group"];
            (<any>this).commissionPercent = _data["commissionPercent"];
        }
    }

    static fromJS(data: any): BookingAgent {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAgent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["group"] = this.group;
        data["commissionPercent"] = this.commissionPercent;
        return data;
    }
}

export interface IBookingAgent {
    guid?: string;
    name?: string | null;
    group?: string | null;
    commissionPercent?: number;
}

export class BookingAppliedAgentDiscount implements IBookingAppliedAgentDiscount {
    appliedDiscountAmount?: number;
    isPercentage?: boolean;
    percentageRate?: number | null;
    fixedAmount?: number | null;

    constructor(data?: IBookingAppliedAgentDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appliedDiscountAmount = _data["appliedDiscountAmount"];
            this.isPercentage = _data["isPercentage"];
            this.percentageRate = _data["percentageRate"];
            this.fixedAmount = _data["fixedAmount"];
        }
    }

    static fromJS(data: any): BookingAppliedAgentDiscount {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAppliedAgentDiscount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appliedDiscountAmount"] = this.appliedDiscountAmount;
        data["isPercentage"] = this.isPercentage;
        data["percentageRate"] = this.percentageRate;
        data["fixedAmount"] = this.fixedAmount;
        return data;
    }
}

export interface IBookingAppliedAgentDiscount {
    appliedDiscountAmount?: number;
    isPercentage?: boolean;
    percentageRate?: number | null;
    fixedAmount?: number | null;
}

export class BookingAppliedCampaign implements IBookingAppliedCampaign {
    campaignCode?: string | null;
    campaignGuid?: string;
    channelGuid?: string;
    appliedDiscountAmount?: number;
    appliedCommisionAmount?: number;

    constructor(data?: IBookingAppliedCampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignCode = _data["campaignCode"];
            this.campaignGuid = _data["campaignGuid"];
            this.channelGuid = _data["channelGuid"];
            this.appliedDiscountAmount = _data["appliedDiscountAmount"];
            this.appliedCommisionAmount = _data["appliedCommisionAmount"];
        }
    }

    static fromJS(data: any): BookingAppliedCampaign {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAppliedCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignCode"] = this.campaignCode;
        data["campaignGuid"] = this.campaignGuid;
        data["channelGuid"] = this.channelGuid;
        data["appliedDiscountAmount"] = this.appliedDiscountAmount;
        data["appliedCommisionAmount"] = this.appliedCommisionAmount;
        return data;
    }
}

export interface IBookingAppliedCampaign {
    campaignCode?: string | null;
    campaignGuid?: string;
    channelGuid?: string;
    appliedDiscountAmount?: number;
    appliedCommisionAmount?: number;
}

export class BookingAppliedPromoCode implements IBookingAppliedPromoCode {
    promoCodeGuid?: string;
    promoCodeType?: PromoCodeType;
    code?: string | null;
    appliedDiscountAmount?: number;
    fixedDiscountAmount?: number | null;
    percentageRate?: number | null;

    constructor(data?: IBookingAppliedPromoCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promoCodeGuid = _data["promoCodeGuid"];
            this.promoCodeType = _data["promoCodeType"];
            this.code = _data["code"];
            this.appliedDiscountAmount = _data["appliedDiscountAmount"];
            this.fixedDiscountAmount = _data["fixedDiscountAmount"];
            this.percentageRate = _data["percentageRate"];
        }
    }

    static fromJS(data: any): BookingAppliedPromoCode {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAppliedPromoCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoCodeGuid"] = this.promoCodeGuid;
        data["promoCodeType"] = this.promoCodeType;
        data["code"] = this.code;
        data["appliedDiscountAmount"] = this.appliedDiscountAmount;
        data["fixedDiscountAmount"] = this.fixedDiscountAmount;
        data["percentageRate"] = this.percentageRate;
        return data;
    }
}

export interface IBookingAppliedPromoCode {
    promoCodeGuid?: string;
    promoCodeType?: PromoCodeType;
    code?: string | null;
    appliedDiscountAmount?: number;
    fixedDiscountAmount?: number | null;
    percentageRate?: number | null;
}

export class BookingCancellationDetails implements IBookingCancellationDetails {
    note?: string | null;
    reason?: BookingCancellationReason;
    cancelledBy?: string | null;
    date?: Date;

    constructor(data?: IBookingCancellationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.reason = _data["reason"];
            this.cancelledBy = _data["cancelledBy"];
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BookingCancellationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCancellationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["reason"] = this.reason;
        data["cancelledBy"] = this.cancelledBy;
        data["date"] = this.date && formatDate(this.date);
        return data;
    }
}

export interface IBookingCancellationDetails {
    note?: string | null;
    reason?: BookingCancellationReason;
    cancelledBy?: string | null;
    date?: Date;
}

export enum BookingCancellationReason {
    NotSet = "NotSet",
    Planning = "Planning",
    Price = "Price",
    Weather = "Weather",
    BoatAvailability = "BoatAvailability",
    TestOrDuplicate = "TestOrDuplicate",
}

export class BookingCustomer implements IBookingCustomer {
    readonly guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    customerNumber?: number;
    createdAtUtc?: Date;
    infoStatus?: CustomerInfoStatus;
    readonly fullName?: string | null;

    constructor(data?: IBookingCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.customerNumber = _data["customerNumber"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
            this.infoStatus = _data["infoStatus"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): BookingCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["customerNumber"] = this.customerNumber;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        data["infoStatus"] = this.infoStatus;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IBookingCustomer {
    guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    customerNumber?: number;
    createdAtUtc?: Date;
    infoStatus?: CustomerInfoStatus;
    fullName?: string | null;
}

export class BookingDayFeeItem implements IBookingDayFeeItem {
    additionalFeeTypeGuid?: string;
    code?: string | null;
    name?: string | null;
    amount?: number;
    defaultTaxes?: TaxLine[] | null;

    constructor(data?: IBookingDayFeeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFeeTypeGuid = _data["additionalFeeTypeGuid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingDayFeeItem {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDayFeeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFeeTypeGuid"] = this.additionalFeeTypeGuid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["amount"] = this.amount;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookingDayFeeItem {
    additionalFeeTypeGuid?: string;
    code?: string | null;
    name?: string | null;
    amount?: number;
    defaultTaxes?: TaxLine[] | null;
}

export class BookingDayPrice implements IBookingDayPrice {
    date?: Date;
    basePrice?: number;
    feesTotal?: number;
    feeItems?: BookingDayFeeItem[] | null;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;
    isChargeableDay?: boolean;

    constructor(data?: IBookingDayPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.basePrice = _data["basePrice"];
            this.feesTotal = _data["feesTotal"];
            if (Array.isArray(_data["feeItems"])) {
                this.feeItems = [] as any;
                for (let item of _data["feeItems"])
                    this.feeItems!.push(BookingDayFeeItem.fromJS(item));
            }
            this.seasonGuid = _data["seasonGuid"];
            this.seasonName = _data["seasonName"];
            this.seasonColor = _data["seasonColor"];
            this.isCustomPrice = _data["isCustomPrice"];
            this.isChargeableDay = _data["isChargeableDay"];
        }
    }

    static fromJS(data: any): BookingDayPrice {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDayPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        data["basePrice"] = this.basePrice;
        data["feesTotal"] = this.feesTotal;
        if (Array.isArray(this.feeItems)) {
            data["feeItems"] = [];
            for (let item of this.feeItems)
                data["feeItems"].push(item.toJSON());
        }
        data["seasonGuid"] = this.seasonGuid;
        data["seasonName"] = this.seasonName;
        data["seasonColor"] = this.seasonColor;
        data["isCustomPrice"] = this.isCustomPrice;
        data["isChargeableDay"] = this.isChargeableDay;
        return data;
    }
}

export interface IBookingDayPrice {
    date?: Date;
    basePrice?: number;
    feesTotal?: number;
    feeItems?: BookingDayFeeItem[] | null;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;
    isChargeableDay?: boolean;
}

export class BookingNotes implements IBookingNotes {
    note?: string | null;
    toysPromised?: string | null;
    customerGoalsAndAgenda?: string | null;
    tripNotes?: string | null;

    constructor(data?: IBookingNotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.toysPromised = _data["toysPromised"];
            this.customerGoalsAndAgenda = _data["customerGoalsAndAgenda"];
            this.tripNotes = _data["tripNotes"];
        }
    }

    static fromJS(data: any): BookingNotes {
        data = typeof data === 'object' ? data : {};
        let result = new BookingNotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["toysPromised"] = this.toysPromised;
        data["customerGoalsAndAgenda"] = this.customerGoalsAndAgenda;
        data["tripNotes"] = this.tripNotes;
        return data;
    }
}

export interface IBookingNotes {
    note?: string | null;
    toysPromised?: string | null;
    customerGoalsAndAgenda?: string | null;
    tripNotes?: string | null;
}

export class BookingPriceBreakdown implements IBookingPriceBreakdown {
    pricingMode?: PricingMode;
    dayPrices?: BookingDayPrice[] | null;
    seasonSummaries?: BookingSeasonSummary[] | null;

    constructor(data?: IBookingPriceBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricingMode = _data["pricingMode"];
            if (Array.isArray(_data["dayPrices"])) {
                this.dayPrices = [] as any;
                for (let item of _data["dayPrices"])
                    this.dayPrices!.push(BookingDayPrice.fromJS(item));
            }
            if (Array.isArray(_data["seasonSummaries"])) {
                this.seasonSummaries = [] as any;
                for (let item of _data["seasonSummaries"])
                    this.seasonSummaries!.push(BookingSeasonSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingPriceBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPriceBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricingMode"] = this.pricingMode;
        if (Array.isArray(this.dayPrices)) {
            data["dayPrices"] = [];
            for (let item of this.dayPrices)
                data["dayPrices"].push(item.toJSON());
        }
        if (Array.isArray(this.seasonSummaries)) {
            data["seasonSummaries"] = [];
            for (let item of this.seasonSummaries)
                data["seasonSummaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookingPriceBreakdown {
    pricingMode?: PricingMode;
    dayPrices?: BookingDayPrice[] | null;
    seasonSummaries?: BookingSeasonSummary[] | null;
}

export class BookingSeasonSummary implements IBookingSeasonSummary {
    seasonGuid?: string | null;
    seasonName?: string | null;
    daysCount?: number;
    totalBasePrice?: number;
    totalFees?: number;

    constructor(data?: IBookingSeasonSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonGuid = _data["seasonGuid"];
            this.seasonName = _data["seasonName"];
            this.daysCount = _data["daysCount"];
            this.totalBasePrice = _data["totalBasePrice"];
            this.totalFees = _data["totalFees"];
        }
    }

    static fromJS(data: any): BookingSeasonSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSeasonSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonGuid"] = this.seasonGuid;
        data["seasonName"] = this.seasonName;
        data["daysCount"] = this.daysCount;
        data["totalBasePrice"] = this.totalBasePrice;
        data["totalFees"] = this.totalFees;
        return data;
    }
}

export interface IBookingSeasonSummary {
    seasonGuid?: string | null;
    seasonName?: string | null;
    daysCount?: number;
    totalBasePrice?: number;
    totalFees?: number;
}

export class BookingSourceInfo implements IBookingSourceInfo {
    source?: BookingSource;
    widgetDomain?: string | null;

    constructor(data?: IBookingSourceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.widgetDomain = _data["widgetDomain"];
        }
    }

    static fromJS(data: any): BookingSourceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSourceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["widgetDomain"] = this.widgetDomain;
        return data;
    }
}

export interface IBookingSourceInfo {
    source?: BookingSource;
    widgetDomain?: string | null;
}

export class BookingTrackingParamsDto implements IBookingTrackingParamsDto {
    fbp?: string | null;
    fbc?: string | null;
    gaClientId?: string | null;
    gclid?: string | null;
    marketplaceSessionId?: string | null;

    constructor(data?: IBookingTrackingParamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fbp = _data["fbp"];
            this.fbc = _data["fbc"];
            this.gaClientId = _data["gaClientId"];
            this.gclid = _data["gclid"];
            this.marketplaceSessionId = _data["marketplaceSessionId"];
        }
    }

    static fromJS(data: any): BookingTrackingParamsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingTrackingParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fbp"] = this.fbp;
        data["fbc"] = this.fbc;
        data["gaClientId"] = this.gaClientId;
        data["gclid"] = this.gclid;
        data["marketplaceSessionId"] = this.marketplaceSessionId;
        return data;
    }
}

export interface IBookingTrackingParamsDto {
    fbp?: string | null;
    fbc?: string | null;
    gaClientId?: string | null;
    gclid?: string | null;
    marketplaceSessionId?: string | null;
}

export class SuperchatDetails implements ISuperchatDetails {
    superchatUrl?: string | null;
    externalOfferUrl?: string | null;

    constructor(data?: ISuperchatDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.superchatUrl = _data["superchatUrl"];
            this.externalOfferUrl = _data["externalOfferUrl"];
        }
    }

    static fromJS(data: any): SuperchatDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SuperchatDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["superchatUrl"] = this.superchatUrl;
        data["externalOfferUrl"] = this.externalOfferUrl;
        return data;
    }
}

export interface ISuperchatDetails {
    superchatUrl?: string | null;
    externalOfferUrl?: string | null;
}

export class CustomerAddress implements ICustomerAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;

    constructor(data?: ICustomerAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CustomerAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        return data;
    }
}

export interface ICustomerAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
}

export class CustomerBillingInfo implements ICustomerBillingInfo {
    companyName?: string | null;
    taxId?: string | null;
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;

    constructor(data?: ICustomerBillingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.taxId = _data["taxId"];
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CustomerBillingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBillingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["taxId"] = this.taxId;
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        return data;
    }
}

export interface ICustomerBillingInfo {
    companyName?: string | null;
    taxId?: string | null;
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
}

export class CustomerConcierge implements ICustomerConcierge {
    name?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: ICustomerConcierge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CustomerConcierge {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerConcierge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ICustomerConcierge {
    name?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class CustomerPreferences implements ICustomerPreferences {
    gratuityNote?: string | null;
    musicPreference?: string | null;
    drinkPreference?: string | null;
    foodPreference?: string | null;
    familyNames?: string | null;
    theyLikeToDo?: string | null;
    miscellaneous?: string | null;
    birthdays?: string | null;

    constructor(data?: ICustomerPreferences) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gratuityNote = _data["gratuityNote"];
            this.musicPreference = _data["musicPreference"];
            this.drinkPreference = _data["drinkPreference"];
            this.foodPreference = _data["foodPreference"];
            this.familyNames = _data["familyNames"];
            this.theyLikeToDo = _data["theyLikeToDo"];
            this.miscellaneous = _data["miscellaneous"];
            this.birthdays = _data["birthdays"];
        }
    }

    static fromJS(data: any): CustomerPreferences {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPreferences();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gratuityNote"] = this.gratuityNote;
        data["musicPreference"] = this.musicPreference;
        data["drinkPreference"] = this.drinkPreference;
        data["foodPreference"] = this.foodPreference;
        data["familyNames"] = this.familyNames;
        data["theyLikeToDo"] = this.theyLikeToDo;
        data["miscellaneous"] = this.miscellaneous;
        data["birthdays"] = this.birthdays;
        return data;
    }
}

export interface ICustomerPreferences {
    gratuityNote?: string | null;
    musicPreference?: string | null;
    drinkPreference?: string | null;
    foodPreference?: string | null;
    familyNames?: string | null;
    theyLikeToDo?: string | null;
    miscellaneous?: string | null;
    birthdays?: string | null;
}

export class OrderingLocationAddress implements IOrderingLocationAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
    latitude?: number;
    longitude?: number;

    constructor(data?: IOrderingLocationAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): OrderingLocationAddress {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingLocationAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IOrderingLocationAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
    latitude?: number;
    longitude?: number;
}

export class BookingCreationSettings implements IBookingCreationSettings {
    displayProformaButton?: boolean;
    displayCreateAndPay?: boolean;
    requirePassengers?: boolean;

    constructor(data?: IBookingCreationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayProformaButton = _data["displayProformaButton"];
            this.displayCreateAndPay = _data["displayCreateAndPay"];
            this.requirePassengers = _data["requirePassengers"];
        }
    }

    static fromJS(data: any): BookingCreationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCreationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayProformaButton"] = this.displayProformaButton;
        data["displayCreateAndPay"] = this.displayCreateAndPay;
        data["requirePassengers"] = this.requirePassengers;
        return data;
    }
}

export interface IBookingCreationSettings {
    displayProformaButton?: boolean;
    displayCreateAndPay?: boolean;
    requirePassengers?: boolean;
}

export class BookingSummaryRequiredFields implements IBookingSummaryRequiredFields {
    phoneVisible?: boolean;
    phoneRequired?: boolean;
    addressVisible?: boolean;
    addressRequired?: boolean;
    companyVisible?: boolean;
    companyRequired?: boolean;
    taxIdVisible?: boolean;
    taxIdRequired?: boolean;
    billingInfoVisible?: boolean;
    billingInfoRequired?: boolean;
    idPassportNumberVisible?: boolean;
    idPassportNumberRequired?: boolean;

    constructor(data?: IBookingSummaryRequiredFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneVisible = _data["phoneVisible"];
            this.phoneRequired = _data["phoneRequired"];
            this.addressVisible = _data["addressVisible"];
            this.addressRequired = _data["addressRequired"];
            this.companyVisible = _data["companyVisible"];
            this.companyRequired = _data["companyRequired"];
            this.taxIdVisible = _data["taxIdVisible"];
            this.taxIdRequired = _data["taxIdRequired"];
            this.billingInfoVisible = _data["billingInfoVisible"];
            this.billingInfoRequired = _data["billingInfoRequired"];
            this.idPassportNumberVisible = _data["idPassportNumberVisible"];
            this.idPassportNumberRequired = _data["idPassportNumberRequired"];
        }
    }

    static fromJS(data: any): BookingSummaryRequiredFields {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSummaryRequiredFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneVisible"] = this.phoneVisible;
        data["phoneRequired"] = this.phoneRequired;
        data["addressVisible"] = this.addressVisible;
        data["addressRequired"] = this.addressRequired;
        data["companyVisible"] = this.companyVisible;
        data["companyRequired"] = this.companyRequired;
        data["taxIdVisible"] = this.taxIdVisible;
        data["taxIdRequired"] = this.taxIdRequired;
        data["billingInfoVisible"] = this.billingInfoVisible;
        data["billingInfoRequired"] = this.billingInfoRequired;
        data["idPassportNumberVisible"] = this.idPassportNumberVisible;
        data["idPassportNumberRequired"] = this.idPassportNumberRequired;
        return data;
    }
}

export interface IBookingSummaryRequiredFields {
    phoneVisible?: boolean;
    phoneRequired?: boolean;
    addressVisible?: boolean;
    addressRequired?: boolean;
    companyVisible?: boolean;
    companyRequired?: boolean;
    taxIdVisible?: boolean;
    taxIdRequired?: boolean;
    billingInfoVisible?: boolean;
    billingInfoRequired?: boolean;
    idPassportNumberVisible?: boolean;
    idPassportNumberRequired?: boolean;
}

export class BookingSummarySettings implements IBookingSummarySettings {
    hideLocationSection?: boolean;
    fuelNotice?: string | null;
    requiredFields?: BookingSummaryRequiredFields;

    constructor(data?: IBookingSummarySettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hideLocationSection = _data["hideLocationSection"];
            this.fuelNotice = _data["fuelNotice"];
            this.requiredFields = _data["requiredFields"] ? BookingSummaryRequiredFields.fromJS(_data["requiredFields"]) : <any>null;
        }
    }

    static fromJS(data: any): BookingSummarySettings {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSummarySettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hideLocationSection"] = this.hideLocationSection;
        data["fuelNotice"] = this.fuelNotice;
        data["requiredFields"] = this.requiredFields ? this.requiredFields.toJSON() : this.requiredFields;
        return data;
    }
}

export interface IBookingSummarySettings {
    hideLocationSection?: boolean;
    fuelNotice?: string | null;
    requiredFields?: BookingSummaryRequiredFields;
}

export class CalendarTooltipSettings implements ICalendarTooltipSettings {
    listingTitleVisible?: boolean;
    customerNameVisible?: boolean;
    totalPriceVisible?: boolean;
    dateRangeVisible?: boolean;
    skipperVisible?: boolean;
    checkinPersonVisible?: boolean;
    stewardessVisible?: boolean;
    pickupDropoffLocationVisible?: boolean;
    sourceVisible?: boolean;
    createdOnVisible?: boolean;
    bookingNotesVisible?: boolean;
    contractVisible?: boolean;
    salesPersonVisible?: boolean;
    channelVisible?: boolean;
    paidAmountVisible?: boolean;
    remainingAmountVisible?: boolean;
    rentalPriceVisible?: boolean;
    fuelVisible?: boolean;

    constructor(data?: ICalendarTooltipSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingTitleVisible = _data["listingTitleVisible"];
            this.customerNameVisible = _data["customerNameVisible"];
            this.totalPriceVisible = _data["totalPriceVisible"];
            this.dateRangeVisible = _data["dateRangeVisible"];
            this.skipperVisible = _data["skipperVisible"];
            this.checkinPersonVisible = _data["checkinPersonVisible"];
            this.stewardessVisible = _data["stewardessVisible"];
            this.pickupDropoffLocationVisible = _data["pickupDropoffLocationVisible"];
            this.sourceVisible = _data["sourceVisible"];
            this.createdOnVisible = _data["createdOnVisible"];
            this.bookingNotesVisible = _data["bookingNotesVisible"];
            this.contractVisible = _data["contractVisible"];
            this.salesPersonVisible = _data["salesPersonVisible"];
            this.channelVisible = _data["channelVisible"];
            this.paidAmountVisible = _data["paidAmountVisible"];
            this.remainingAmountVisible = _data["remainingAmountVisible"];
            this.rentalPriceVisible = _data["rentalPriceVisible"];
            this.fuelVisible = _data["fuelVisible"];
        }
    }

    static fromJS(data: any): CalendarTooltipSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarTooltipSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingTitleVisible"] = this.listingTitleVisible;
        data["customerNameVisible"] = this.customerNameVisible;
        data["totalPriceVisible"] = this.totalPriceVisible;
        data["dateRangeVisible"] = this.dateRangeVisible;
        data["skipperVisible"] = this.skipperVisible;
        data["checkinPersonVisible"] = this.checkinPersonVisible;
        data["stewardessVisible"] = this.stewardessVisible;
        data["pickupDropoffLocationVisible"] = this.pickupDropoffLocationVisible;
        data["sourceVisible"] = this.sourceVisible;
        data["createdOnVisible"] = this.createdOnVisible;
        data["bookingNotesVisible"] = this.bookingNotesVisible;
        data["contractVisible"] = this.contractVisible;
        data["salesPersonVisible"] = this.salesPersonVisible;
        data["channelVisible"] = this.channelVisible;
        data["paidAmountVisible"] = this.paidAmountVisible;
        data["remainingAmountVisible"] = this.remainingAmountVisible;
        data["rentalPriceVisible"] = this.rentalPriceVisible;
        data["fuelVisible"] = this.fuelVisible;
        return data;
    }
}

export interface ICalendarTooltipSettings {
    listingTitleVisible?: boolean;
    customerNameVisible?: boolean;
    totalPriceVisible?: boolean;
    dateRangeVisible?: boolean;
    skipperVisible?: boolean;
    checkinPersonVisible?: boolean;
    stewardessVisible?: boolean;
    pickupDropoffLocationVisible?: boolean;
    sourceVisible?: boolean;
    createdOnVisible?: boolean;
    bookingNotesVisible?: boolean;
    contractVisible?: boolean;
    salesPersonVisible?: boolean;
    channelVisible?: boolean;
    paidAmountVisible?: boolean;
    remainingAmountVisible?: boolean;
    rentalPriceVisible?: boolean;
    fuelVisible?: boolean;
}

export class GratuitySettings implements IGratuitySettings {
    autoGraylistEnabled?: boolean;
    autoGraylistThresholdPercentage?: number;

    constructor(data?: IGratuitySettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoGraylistEnabled = _data["autoGraylistEnabled"];
            this.autoGraylistThresholdPercentage = _data["autoGraylistThresholdPercentage"];
        }
    }

    static fromJS(data: any): GratuitySettings {
        data = typeof data === 'object' ? data : {};
        let result = new GratuitySettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoGraylistEnabled"] = this.autoGraylistEnabled;
        data["autoGraylistThresholdPercentage"] = this.autoGraylistThresholdPercentage;
        return data;
    }
}

export interface IGratuitySettings {
    autoGraylistEnabled?: boolean;
    autoGraylistThresholdPercentage?: number;
}

export enum MeasurementSystem {
    NotSet = "NotSet",
    Metric = "Metric",
    Imperial = "Imperial",
}

export class PlatformAccountSettings implements IPlatformAccountSettings {
    readonly guid?: string;
    measurementSystem?: MeasurementSystem;
    readonly conversionTrackingEnabled?: boolean;
    widget?: WidgetSettings;
    bookingSummary?: BookingSummarySettings;
    readonly aircallEnabled?: boolean;
    readonly worldPayAutomaticPayoutsEnabled?: boolean;
    readonly boatingAndCateringOptInsEnabled?: boolean;
    salesLead?: SalesLeadSettings;
    calendarTooltip?: CalendarTooltipSettings;
    bookingCreation?: BookingCreationSettings;
    gratuity?: GratuitySettings;

    constructor(data?: IPlatformAccountSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.measurementSystem = _data["measurementSystem"];
            (<any>this).conversionTrackingEnabled = _data["conversionTrackingEnabled"];
            this.widget = _data["widget"] ? WidgetSettings.fromJS(_data["widget"]) : <any>null;
            this.bookingSummary = _data["bookingSummary"] ? BookingSummarySettings.fromJS(_data["bookingSummary"]) : <any>null;
            (<any>this).aircallEnabled = _data["aircallEnabled"];
            (<any>this).worldPayAutomaticPayoutsEnabled = _data["worldPayAutomaticPayoutsEnabled"];
            (<any>this).boatingAndCateringOptInsEnabled = _data["boatingAndCateringOptInsEnabled"];
            this.salesLead = _data["salesLead"] ? SalesLeadSettings.fromJS(_data["salesLead"]) : <any>null;
            this.calendarTooltip = _data["calendarTooltip"] ? CalendarTooltipSettings.fromJS(_data["calendarTooltip"]) : <any>null;
            this.bookingCreation = _data["bookingCreation"] ? BookingCreationSettings.fromJS(_data["bookingCreation"]) : <any>null;
            this.gratuity = _data["gratuity"] ? GratuitySettings.fromJS(_data["gratuity"]) : <any>null;
        }
    }

    static fromJS(data: any): PlatformAccountSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformAccountSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["measurementSystem"] = this.measurementSystem;
        data["conversionTrackingEnabled"] = this.conversionTrackingEnabled;
        data["widget"] = this.widget ? this.widget.toJSON() : this.widget;
        data["bookingSummary"] = this.bookingSummary ? this.bookingSummary.toJSON() : this.bookingSummary;
        data["aircallEnabled"] = this.aircallEnabled;
        data["worldPayAutomaticPayoutsEnabled"] = this.worldPayAutomaticPayoutsEnabled;
        data["boatingAndCateringOptInsEnabled"] = this.boatingAndCateringOptInsEnabled;
        data["salesLead"] = this.salesLead ? this.salesLead.toJSON() : this.salesLead;
        data["calendarTooltip"] = this.calendarTooltip ? this.calendarTooltip.toJSON() : this.calendarTooltip;
        data["bookingCreation"] = this.bookingCreation ? this.bookingCreation.toJSON() : this.bookingCreation;
        data["gratuity"] = this.gratuity ? this.gratuity.toJSON() : this.gratuity;
        return data;
    }
}

export interface IPlatformAccountSettings {
    guid?: string;
    measurementSystem?: MeasurementSystem;
    conversionTrackingEnabled?: boolean;
    widget?: WidgetSettings;
    bookingSummary?: BookingSummarySettings;
    aircallEnabled?: boolean;
    worldPayAutomaticPayoutsEnabled?: boolean;
    boatingAndCateringOptInsEnabled?: boolean;
    salesLead?: SalesLeadSettings;
    calendarTooltip?: CalendarTooltipSettings;
    bookingCreation?: BookingCreationSettings;
    gratuity?: GratuitySettings;
}

export class SalesLeadSettings implements ISalesLeadSettings {
    termsUrl?: string | null;
    messagingEnabled?: boolean;

    constructor(data?: ISalesLeadSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termsUrl = _data["termsUrl"];
            this.messagingEnabled = _data["messagingEnabled"];
        }
    }

    static fromJS(data: any): SalesLeadSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termsUrl"] = this.termsUrl;
        data["messagingEnabled"] = this.messagingEnabled;
        return data;
    }
}

export interface ISalesLeadSettings {
    termsUrl?: string | null;
    messagingEnabled?: boolean;
}

export enum WidgetMode {
    Standard = "Standard",
    Enquiry = "Enquiry",
}

export class WidgetRequiredFields implements IWidgetRequiredFields {
    nameVisible?: boolean;
    nameRequired?: boolean;
    emailVisible?: boolean;
    emailRequired?: boolean;
    phoneVisible?: boolean;
    phoneRequired?: boolean;

    constructor(data?: IWidgetRequiredFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameVisible = _data["nameVisible"];
            this.nameRequired = _data["nameRequired"];
            this.emailVisible = _data["emailVisible"];
            this.emailRequired = _data["emailRequired"];
            this.phoneVisible = _data["phoneVisible"];
            this.phoneRequired = _data["phoneRequired"];
        }
    }

    static fromJS(data: any): WidgetRequiredFields {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetRequiredFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameVisible"] = this.nameVisible;
        data["nameRequired"] = this.nameRequired;
        data["emailVisible"] = this.emailVisible;
        data["emailRequired"] = this.emailRequired;
        data["phoneVisible"] = this.phoneVisible;
        data["phoneRequired"] = this.phoneRequired;
        return data;
    }
}

export interface IWidgetRequiredFields {
    nameVisible?: boolean;
    nameRequired?: boolean;
    emailVisible?: boolean;
    emailRequired?: boolean;
    phoneVisible?: boolean;
    phoneRequired?: boolean;
}

export class WidgetSettings implements IWidgetSettings {
    requiredFields?: WidgetRequiredFields;
    mode?: WidgetMode;
    theme?: WidgetTheme;
    summaryNote?: string | null;

    constructor(data?: IWidgetSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requiredFields = _data["requiredFields"] ? WidgetRequiredFields.fromJS(_data["requiredFields"]) : <any>null;
            this.mode = _data["mode"];
            this.theme = _data["theme"] ? WidgetTheme.fromJS(_data["theme"]) : <any>null;
            this.summaryNote = _data["summaryNote"];
        }
    }

    static fromJS(data: any): WidgetSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiredFields"] = this.requiredFields ? this.requiredFields.toJSON() : this.requiredFields;
        data["mode"] = this.mode;
        data["theme"] = this.theme ? this.theme.toJSON() : this.theme;
        data["summaryNote"] = this.summaryNote;
        return data;
    }
}

export interface IWidgetSettings {
    requiredFields?: WidgetRequiredFields;
    mode?: WidgetMode;
    theme?: WidgetTheme;
    summaryNote?: string | null;
}

export class WidgetTheme implements IWidgetTheme {
    primaryColor?: string | null;
    primaryLightColor?: string | null;
    primaryTextColor?: string | null;
    calendarTextColor?: string | null;
    buttonRadius?: string | null;

    constructor(data?: IWidgetTheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["primaryColor"];
            this.primaryLightColor = _data["primaryLightColor"];
            this.primaryTextColor = _data["primaryTextColor"];
            this.calendarTextColor = _data["calendarTextColor"];
            this.buttonRadius = _data["buttonRadius"];
        }
    }

    static fromJS(data: any): WidgetTheme {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetTheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryColor"] = this.primaryColor;
        data["primaryLightColor"] = this.primaryLightColor;
        data["primaryTextColor"] = this.primaryTextColor;
        data["calendarTextColor"] = this.calendarTextColor;
        data["buttonRadius"] = this.buttonRadius;
        return data;
    }
}

export interface IWidgetTheme {
    primaryColor?: string | null;
    primaryLightColor?: string | null;
    primaryTextColor?: string | null;
    calendarTextColor?: string | null;
    buttonRadius?: string | null;
}

export enum PaymentGateway {
    Stripe = "Stripe",
    AuthorizeNet = "AuthorizeNet",
    WorldPay = "WorldPay",
}

export enum PaymentProvider {
    NotSet = "NotSet",
    None = "None",
    Stripe = "Stripe",
    External = "External",
    Balance = "Balance",
    AuthorizeNet = "AuthorizeNet",
    WorldPay = "WorldPay",
}

export enum PaymentStatus {
    NotSet = "NotSet",
    Intent = "Intent",
    Processing = "Processing",
    Complete = "Complete",
    Failed = "Failed",
    Expired = "Expired",
    Cancelled = "Cancelled",
    CheckoutPending = "CheckoutPending",
}

export class PrePaymentInfo implements IPrePaymentInfo {
    percentage?: number;
    amount?: number;
    amountWithOnlineFee?: number;

    constructor(data?: IPrePaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
            this.amountWithOnlineFee = _data["amountWithOnlineFee"];
        }
    }

    static fromJS(data: any): PrePaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PrePaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        data["amountWithOnlineFee"] = this.amountWithOnlineFee;
        return data;
    }
}

export interface IPrePaymentInfo {
    percentage?: number;
    amount?: number;
    amountWithOnlineFee?: number;
}

export enum AddonBookability {
    NotSet = "NotSet",
    Instant = "Instant",
    OnRequest = "OnRequest",
}

export enum AddonSelectionType {
    Simple = "Simple",
    SingleSelect = "SingleSelect",
}

export enum PricingModel {
    NotSet = "NotSet",
    PerItem = "PerItem",
    PerItemPerDay = "PerItemPerDay",
}

export enum BoatAvailabilityMode {
    BookingBased = "BookingBased",
    SeatBased = "SeatBased",
}

export enum BookingType {
    NotSet = "NotSet",
    InstantlyBookable = "InstantlyBookable",
    RequestOnly = "RequestOnly",
}

export enum PublishStatus {
    NotSet = "NotSet",
    Unpublished = "Unpublished",
    PublishedAdminOnly = "PublishedAdminOnly",
    Published = "Published",
    Unlisted = "Unlisted",
}

export enum PricingMode {
    Packages = "Packages",
    Calendar = "Calendar",
}

export enum PromoCodeType {
    NotSet = "NotSet",
    Discount = "Discount",
    Donate = "Donate",
}

export enum BookingAddonStatus {
    NotSet = "NotSet",
    InstantConfirmed = "InstantConfirmed",
    Requested = "Requested",
    Approved = "Approved",
    Declined = "Declined",
}

export enum BookingChannelType {
    NotSet = "NotSet",
    Referral = "Referral",
    Agent = "Agent",
    Direct = "Direct",
}

export enum BookingPaymentStatus {
    NotSet = "NotSet",
    Unpaid = "Unpaid",
    PartiallyPaid = "PartiallyPaid",
    Paid = "Paid",
}

export enum BookingSource {
    NotSet = "NotSet",
    Admin = "Admin",
    Widget = "Widget",
    Import = "Import",
}

export enum BookingStatus {
    NotSet = "NotSet",
    Draft = "Draft",
    Enquiry = "Enquiry",
    Offer = "Offer",
    Proforma = "Proforma",
    Reservation = "Reservation",
    Completed = "Completed",
    Declined = "Declined",
    Cancelled = "Cancelled",
    Expired = "Expired",
    Postponed = "Postponed",
}

export enum ContractStatus {
    Created = "Created",
    Sending = "Sending",
    Sent = "Sent",
    Signed = "Signed",
    Expired = "Expired",
    Voiding = "Voiding",
    Voided = "Voided",
}

export enum CustomerClass {
    FirstTimer = "FirstTimer",
    RepeatCustomer = "RepeatCustomer",
    Vip = "Vip",
}

export enum CustomerClassification {
    None = "None",
    Graylisted = "Graylisted",
    Blacklisted = "Blacklisted",
}

export enum CustomerInfoStatus {
    NotSet = "NotSet",
    Complete = "Complete",
    Incomplete = "Incomplete",
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class TimeOnly implements ITimeOnly {
    hour!: number;
    minute!: number;

    constructor(data?: ITimeOnly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
        }
    }

    static fromJS(data: any): TimeOnly {
        data = typeof data === 'object' ? data : {};
        let result = new TimeOnly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        return data;
    }
}

export interface ITimeOnly {
    hour: number;
    minute: number;
}

export class TimeSpan implements ITimeSpan {
    hours?: number;
    minutes?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface ITimeSpan {
    hours?: number;
    minutes?: number;
}

export function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

function parseDateOnly(s: string) {
    const date = new Date(s);
    return new Date(date.getTime() + 
        date.getTimezoneOffset() * 60000);
}
//-----/CustomTypes.File-----

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

//-----/Types.File-----

import { addResultTypeFactory } from './axios-client/helpers';
export { setBaseUrl, getBaseUrl } from './axios-client/helpers';
export { setAxiosFactory, getAxios } from './axios-client/helpers';


//-----PersistorHydrator.File-----
import type { PersistedClient } from '@tanstack/react-query-persist-client';
import type { DehydratedState, QueryKey } from '@tanstack/react-query'
import { getResultTypeFactory } from './axios-client/helpers';

/*
 * If you have Dates in QueryKeys (i.e. in request parameters), you need to deserialize them to Dates correctly
 * (otherwise they are deserialized as strings by default, and your queries are broken).
 */
export function deserializeDate(str: unknown) {
  if (!str || typeof str !== 'string') return str;
  if (!/^\d\d\d\d\-\d\d\-\d\d/.test(str)) return str;
  
  const date = new Date(str);
  const isDate = date instanceof Date && !isNaN(date as any);
  
  return isDate ? date : str;
}

export function deserializeDatesInQueryKeys(queryKey: QueryKey) {
  return queryKey
    // We need to replace `null` with `undefined` in query key, because
    // `undefined` is serialized as `null`.
    // And most probably if we have `null` in QueryKey it actually means `undefined`.
    // We can't keep nulls, because they have a different meaning, and e.g. boolean parameters are not allowed to be null.
    .map(x => (x === null ? undefined : x))
    .map(x => deserializeDate(x));
}

export function deserializeClassesInQueryData(queryKey: QueryKey, data: any) {
  if (!data) {
    return data;
  } else if (typeof data !== 'object') {
    return data;
  } else if ('pages' in data && 'pageParams' in data && Array.isArray(data.pages) && Array.isArray(data.pageParams)) {
    // infinite query
    data.pages = data.pages.map((page:any) => deserializeClassesInQueryData(queryKey, page));
  } else if (Array.isArray(data)) {
    return data.map(elem => constructDtoClass(queryKey, elem));
  } else {
    return constructDtoClass(queryKey, data);
  }
}

/*
 * Pass this function as `deserialize` option to createSyncStoragePersister/createAsyncStoragePersister
 * to correctly deserialize your DTOs (including Dates)
 */
export function persisterDeserialize(cache: string): PersistedClient {
  const client: PersistedClient = JSON.parse(cache);
  client.clientState.queries.forEach((query) => {
    query.state.data = deserializeClassesInQueryData(query.queryKey, query.state.data);
    query.queryKey = deserializeDatesInQueryKeys(query.queryKey);
  });

  return client;
}

export function constructDtoClass(queryKey: QueryKey, data: any): unknown {
  const resultTypeKey = getResultTypeClassKey(queryKey);
  const constructorFunction = getResultTypeFactory(resultTypeKey);

  if (!data || !constructorFunction)
    return data;

  return constructorFunction(data);
}

export function getResultTypeClassKey(queryKey: QueryKey): string {
  if (!Array.isArray(queryKey)) {
    return queryKey as unknown as string;
  }
  if (queryKey.length >= 2) {
    // We concatenate first and second elements, because they uniquely identify the query.
    // All other QueryKey elements are query parameters
    return `${queryKey[0]}___${queryKey[1]}`;
  }

  // We actually should never reach this point :)
  return queryKey.join('___');
}

export function initPersister() {
  
  addResultTypeFactory('Client___additionalFeesGET', (data: any) => { const result = new GetAllAdditionalFeeTypesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___addonsForBookingGET', (data: any) => { const result = new BookingAvailableAddonDto(); result.init(data); return result; });
  addResultTypeFactory('Client___addonsCategoriesGET', (data: any) => { const result = new GetAvailableAddonCategoriesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___boatsGET', (data: any) => { const result = new PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null(); result.init(data); return result; });
  addResultTypeFactory('Client___boatsGuidGET', (data: any) => { const result = new GetBoatQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___boatsGuidGalleryGET', (data: any) => { const result = new GetBoatGalleryQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___boatsVisibleInCalendarGET', (data: any) => { const result = new GetVisibleBoatsInCalendarQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___boatsByLocationLocationguidGET', (data: any) => { const result = new PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null(); result.init(data); return result; });
  addResultTypeFactory('Client___boatsPublishedGET', (data: any) => { const result = new PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null(); result.init(data); return result; });
  addResultTypeFactory('Client___bookingsBookingguidPublicUrlGET', (data: any) => { const result = new GetBookingPublicUrlQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___bookingsByCreationDateRangeGET', (data: any) => { const result = new PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null(); result.init(data); return result; });
  addResultTypeFactory('Client___bookingsGuidGET', (data: any) => { const result = new GetBookingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___bookingsGuidCustomerGET', (data: any) => { const result = new GetBookingCustomerQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___customersCustomerguidWorldpayCustomerIdGET', (data: any) => { const result = new GetWorldPayCustomerIdQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___bookingsBookingguidAnonymousCustomerFieldsStatusGET', (data: any) => { const result = new GetAnonymousBookingCustomerFieldsStatusQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___listingsGuidGET', (data: any) => { const result = new GetMarketplaceListingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___listingsGuidCalendarDaysGET', (data: any) => { const result = new GetMarketplaceCalendarDaysQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___listingsGuidCalendarDayPricingsGET', (data: any) => { const result = new GetMarketplaceCalendarDayPricingsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___listingsAvailableListingsDetailsGET', (data: any) => { const result = new PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null(); result.init(data); return result; });
  addResultTypeFactory('Client___listingsGuidCalendarPricingGET', (data: any) => { const result = new GetMarketplaceCalendarPricingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___marketsGET', (data: any) => { const result = new PaginatedResult_1OfOfGetPublicMarketsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null(); result.init(data); return result; });
  addResultTypeFactory('Client___multibookingsGuidGET', (data: any) => { const result = new GetMultibookingSummaryForCustomerQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___multibookingsGuidBookingsGET', (data: any) => { const result = new MultibookingCustomerBookingSummary(); result.init(data); return result; });
  addResultTypeFactory('Client___ownersGuidGET', (data: any) => { const result = new GetOwnerQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___paymentsGuidGET', (data: any) => { const result = new GetPaymentQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___paymentsAuthorize_NetCheckoutSessionGuidGET', (data: any) => { const result = new GetAuthorizeNetCheckoutSessionQueryResponse(); result.init(data); return result; });
  addResultTypeFactory('Client___paymentsStatusGET', (data: any) => { const result = new GetPaymentStatusQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___paymentsWorldpayCheckoutSessionGuidGET', (data: any) => { const result = new GetWorldPayCheckoutSessionQueryResponse(); result.init(data); return result; });
  addResultTypeFactory('Client___platformAccountPaymentGatewayGET', (data: any) => { const result = new GetPlatformAccountPaymentGatewayQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___platformAccountSettingsGET', (data: any) => { const result = new GetPlatformAccountSettingsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___pricingsCalculateGET', (data: any) => { const result = new GetMarketplaceCalculatedPriceQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___pricingsCalculateCalendarGET', (data: any) => { const result = new GetMarketplaceCalendarCalculatedPriceQueryResult(); result.init(data); return result; });


}
//-----/PersistorHydrator.File----